// ================================================================
// compounds-excel-imports.js
// Auto-generated by import_compounds.py  —  2026-05-09 06:23
// DO NOT EDIT BY HAND — re-run import_compounds.py to regenerate
//
// This object is spread LAST in compounds.js and overrides any
// matching field in earlier compound source files.
// ================================================================

export const excelImportCompounds = {
  "taar1-agonists": {
    id: "taar1-agonists",
    name: `TAAR1 Agonists`,
    fullName: `Trace Amine-Associated Receptor 1 Agonists (class)`,
    categoryId: `addiction`,
    program: `Program J / Addiction`,
    formula: `Class — various`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Some class members (ulotaront, ralmitaront) are in clinical development.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — leverage Wohler's tryptamine expertise`,
    priorityTier: `Tier 2`,
    summary: `TAAR1 is a novel target for addiction and psychosis, largely ignored until Sunovion developed ulotaront (Phase III for schizophrenia, failed 2023) and ralmitaront (depression). TAAR1 agonism modulates dopaminergic, serotonergic, and glutamatergic neurotransmission — reducing hyperdopaminergic states underlying stimulant addiction and psychosis. Several TAAR1 agonists are tryptamine-derived — directly leveraging Wohler's expertise.`,
    researchAdvantages: `Cutting-edge target | Wohler tryptamine synthesis expertise is directly relevant | Strong mechanistic rationale for stimulant addiction + psychosis research | Unscheduled class | Several published TAAR1 ligand structures available`,
    researchConsiderations: `Ulotaront failed Phase III 2023 — target validation questioned | No single lead compound established for research`,
    evidenceConfidence: `MODERATE`,
    aliases: [`Ulotaront-like`, `Ralmitaront-like`],
    mw: `Varies`,
    benefitScore: 80,
    harmScore: 16,
    nextSteps: [`Select 2–3 research-tool compounds
Leverage existing tryptamine synthesis infrastructure
Partner with stimulant-addiction lab`],
  },

  "cb2-selective-class": {
    id: "cb2-selective-class",
    name: `CB2-Selective Agonist Class`,
    fullName: `CB2-selective cannabinoid agonist research class`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    summary: `Pain / inflammation research without CB1 intoxication. Class entry beyond HU-308 and JWH-133 — includes novel scaffolds in development.`,
    flagWarning: `Cannabinoid-system adjacency`,
  },

  "cbc-analogs": {
    id: "cbc-analogs",
    name: `CBC Analogs`,
    fullName: `Cannabichromene structural analog class`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    summary: `Inflammation / pain / neurogenesis research — CBC is a non-intoxicating phytocannabinoid with TRP and CB2 activity.`,
    flagWarning: `Cannabis adjacency`,
  },

  "cbd-analogs-class": {
    id: "cbd-analogs-class",
    name: `CBD Analog Class`,
    fullName: `Cannabidiol structural analog research class (beyond CBD itself)`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    summary: `Anti-inflammatory / anxiety / pain research — structural analogs of CBD including various alkyl-chain variants.`,
    flagWarning: `Cannabis adjacency but lower THC risk`,
  },

  "cbdv-analogs": {
    id: "cbdv-analogs",
    name: `CBDV Analogs`,
    fullName: `Cannabidivarin structural analog class`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    summary: `Seizure / autism / inflammation research — CBDV is a propyl-chain CBD variant. GW Pharma ran Phase 2 for autism.`,
    flagWarning: `Cannabis adjacency`,
  },

  "cbg-analogs-class": {
    id: "cbg-analogs-class",
    name: `CBG Analog Class`,
    fullName: `Cannabigerol structural analog research class`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    summary: `Inflammation, pain, neuroprotection research — structural analogs of CBG beyond the natural compound.`,
    flagWarning: `Cannabis adjacency`,
  },

  "hu-308": {
    id: "hu-308",
    name: `HU-308`,
    fullName: `[(1R,2R,5R)-2-[2,6-dimethoxy-4-(2-methyloctan-2-yl)phenyl]-7,7-dimethyl-4-bicyclo[3.1.1]hept-3-enyl]methanol`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    cas: `256934-39-1`,
    formula: `C₂₇H₄₂O₃`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Selective CB2 agonist research compound. Not federally scheduled. Synthetic cannabinoid but with low/no CB1 activity — distinct from Schedule I synthetic cannabinoids (e.g., JWH series). Research-use-only.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `green`,
    goDecision: `TODO — gold-standard CB2-selective research tool`,
    priorityTier: `Tier 1`,
    summary: `HU-308 is a highly selective CB2 agonist (>400× CB2 over CB1) developed by the Mechoulam lab (Hebrew University). The gold-standard research tool for CB2-specific pharmacology studies, especially in neuroinflammation, bone remodeling, and liver ischemia research. High academic demand.`,
    researchAdvantages: `>400× CB2/CB1 selectivity — clean pharmacology | Well-characterized in vitro and in vivo | Mechoulam-derived — strong academic credibility | Strong bone / inflammation / ischemia preclinical data`,
    researchConsiderations: `Complex synthesis (pinene-derived bicyclic scaffold) | Expensive starting materials | Niche demand (pure research tool, not therapeutic candidate)`,
    evidenceConfidence: `HIGH`,
    mw: `414.62 g/mol`,
    benefitScore: 72,
    harmScore: 22,
    nextSteps: [`Review Hanus 1999 PNAS synthesis — (+)-α-pinene + alkylresorcinol coupling
Translate to kg scale (heptane + EtOAc palette)
Source (+)-α-pinene + 2,6-dimethoxy-4-(2-methyl-2-octyl)resorcinol
Cost analysis — currently $200-500/g at small scale`],
  },

  "jwh-133": {
    id: "jwh-133",
    name: `JWH-133`,
    fullName: `(6aR,10aR)-3-(1,1-dimethylbutyl)-6a,7,10,10a-tetrahydro-6,6,9-trimethyl-6H-dibenzo[b,d]pyran`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    cas: `259869-55-1`,
    formula: `C₂₂H₃₂O`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `CAUTION: Other JWH-series compounds (JWH-018, JWH-073, JWH-200) are federally scheduled (Schedule I, CSA 2012). JWH-133 is a CB2-selective analog and is NOT scheduled federally but should be confirmed state-by-state. Extreme care with research-use-only labeling.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `orange`,
    goDecision: `TODO — confirm state scheduling before proceeding`,
    priorityTier: `Tier 3`,
    summary: `JWH-133 is a CB2-selective cannabinoid agonist (~200× CB2 over CB1) from the John W. Huffman research series. Unlike the scheduled JWH-018/073/200 compounds, JWH-133 remains unscheduled federally due to its selective CB2 activity (minimal CB1 → no THC-like cannabimimetic). Research tool for CB2 studies — but reputational care is required given the JWH family's scheduling history.`,
    researchAdvantages: `High CB2 selectivity (~200×) — clean CB2 pharmacology tool | Unscheduled despite being in the JWH series (CB2-selective = no cannabimimetic) | Strong published anti-inflammatory / bone data`,
    researchConsiderations: `Shares naming convention with scheduled JWH compounds — reputational risk | State-by-state scheduling confirmation required | Analog Act consideration if misused`,
    evidenceConfidence: `HIGH`,
    mw: `312.49 g/mol`,
    benefitScore: 65,
    harmScore: 35,
    nextSteps: [`Regulatory attorney review — confirm unscheduled status in every target state
Draft synthesis from resorcinol + p-mentha-2,8-dien-1-ol
kg-scale plan — EtOAc + heptane palette
Decide whether to keep or drop based on reputational assessment`],
  },

  "naaa-inhibitors": {
    id: "naaa-inhibitors",
    name: `NAAA Inhibitors`,
    fullName: `N-acylethanolamine acid amidase inhibitor research class`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    summary: `PEA / endocannabinoid-like anti-inflammatory pathway — NAAA inhibition raises PEA tone.`,
  },

  "non-cb1-modulators": {
    id: "non-cb1-modulators",
    name: `Non-CB1 Cannabinoid Modulators`,
    fullName: `Non-CB1 cannabinoid receptor modulator research class`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    summary: `Lower-intoxication cannabinoid program — cannabinoid modulators that spare CB1 (avoiding the THC-like high).`,
    flagWarning: `Lower than THC-like compounds`,
  },

  "oea-analogs": {
    id: "oea-analogs",
    name: `OEA Analogs`,
    fullName: `Oleoylethanolamide analog research class`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    summary: `Appetite / metabolic / inflammation research — OEA is an endogenous PPAR-α agonist related to the endocannabinoid family.`,
  },

  "cbd-research-grade": {
    id: "cbd-research-grade",
    name: `Research-Grade CBD`,
    fullName: `(−)-Cannabidiol (research-grade synthetic or hemp-derived isolate)`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    cas: `13956-29-1`,
    formula: `C₂₁H₃₀O₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Hemp-derived CBD (<0.3% THC) is federally legal under 2018 Farm Bill. State laws vary. Epidiolex (pharmaceutical CBD) is FDA-approved and was removed from DEA schedules in 2020. Research-use-only labeling recommended.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `green`,
    goDecision: `TODO — flagship compound for new cannabinoid program`,
    priorityTier: `Tier 1`,
    summary: `Research-grade cannabidiol (CBD) — the non-intoxicating phytocannabinoid with extensive published pharmacology across epilepsy, anxiety, inflammation, and pain research. Epidiolex (FDA-approved) has validated the therapeutic profile. Wohler research-grade supply would support academic programs in neuroinflammation, CB2 signaling, and non-opioid pain research.`,
    researchAdvantages: `FDA-approved indication (Dravet, Lennox-Gastaut, TSC) validates safety/efficacy | Extensive published pharmacology — low-barrier academic research | Broad mechanism: CB1 negative allosteric modulator, 5-HT1A, TRPV1, GPR55, PPARγ | Low abuse liability — favorable for grad-school program | High student demand — easy to onboard university partners`,
    researchConsiderations: `Market saturated — differentiation via purity/COA rigor required | Quality-control requirements are strict (THC <0.3%, heavy metals, pesticides)`,
    evidenceConfidence: `HIGH`,
    aliases: [`CBD`],
    mw: `314.47 g/mol`,
    benefitScore: 80,
    harmScore: 12,
    nextSteps: [`Develop hemp-derived isolate purification SOP (CO2 + ethanol extraction + chromatography)
OR develop synthetic route from olivetol + (+)-p-mentha-2,8-dien-1-ol
Build kg-scale plan using Wohler standard solvents (ethanol + heptane)
QC: HPLC assay + pesticide panel + heavy metals + residual solvents
COA template for university partners`],
  },

  "cbg-research-grade": {
    id: "cbg-research-grade",
    name: `Research-Grade CBG`,
    fullName: `Cannabigerol`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    cas: `25654-31-3`,
    formula: `C₂₁H₃₂O₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Hemp-derived CBG is federally legal under 2018 Farm Bill. Not federally scheduled. Research-use-only posture.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `green`,
    goDecision: `TODO — complementary non-psychoactive cannabinoid`,
    priorityTier: `Tier 2`,
    summary: `Cannabigerol (CBG) is the 'parent' phytocannabinoid — biosynthetic precursor to THC, CBD, and CBC. Non-intoxicating with promising preclinical data in IBD, glaucoma, and MRSA (CB2 agonism + α2-adrenergic binding). Research-grade supply would support neuroinflammation and IBD research programs.`,
    researchAdvantages: `Non-intoxicating — low abuse liability | Promising IBD preclinical data (Borrelli 2013) | α2-adrenergic agonism adds differentiation vs CBD | Growing market demand in cannabinoid research`,
    researchConsiderations: `Lower published clinical data volume than CBD | Biosynthesis from CBGA requires careful decarboxylation control`,
    evidenceConfidence: `MODERATE`,
    aliases: [`CBG`],
    mw: `316.48 g/mol`,
    benefitScore: 75,
    harmScore: 15,
    nextSteps: [`Extraction/isolation SOP from hemp (high-CBG cultivars now available)
Synthetic route: olivetol + geraniol condensation
kg-scale plan with ethanol + heptane palette
QC + COA template`],
  },

  "thcv-analogs": {
    id: "thcv-analogs",
    name: `THCV Analogs`,
    fullName: `Tetrahydrocannabivarin structural analog class`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    schedulingStatus: `monitor`,
    schedulingNote: `THC structural caution — THCV is federally unscheduled if hemp-derived <0.3% THC but state laws vary significantly. Confirm per state.`,
    summary: `Metabolic / appetite / cognition research — THCV is the propyl-chain THC variant with unique pharmacology (CB1 antagonist at low dose, agonist at high dose).`,
    flagWarning: `THC structural caution`,
  },

  "beta-caryophyllene-analogs": {
    id: "beta-caryophyllene-analogs",
    name: `β-Caryophyllene Analogs`,
    fullName: `β-Caryophyllene natural CB2 agonist analog class`,
    categoryId: `cannabinoid`,
    program: `Program K — Endocannabinoid / CB2`,
    summary: `Natural CB2 agonist scaffold — β-caryophyllene is a sesquiterpene found in cloves, black pepper, and cannabis. FDA GRAS-listed.`,
  },

  "adrafinil": {
    id: "adrafinil",
    name: `Adrafinil`,
    fullName: `(±)-2-[(diphenylmethyl)sulfinyl]-N-hydroxyacetamide`,
    categoryId: `cognitive`,
    program: `Program C — Wakefulness / Neuroinflammation`,
    cas: `63547-13-7`,
    formula: `C₁₅H₁₅NO₃S`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled in the U.S. (modafinil is Schedule IV). Sold as research chemical / supplement in the U.S. but discontinued in France 2011. Research-use-only posture required for supply.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `orange`,
    goDecision: `TODO — useful modafinil prodrug reference for Program C`,
    priorityTier: `Tier 2`,
    summary: `Adrafinil is a prodrug for modafinil — metabolized hepatically to yield modafinil + modafinilic acid. Historically the first wakefulness compound in this class (Lafon, 1970s) and marketed as Olmifon in France for narcolepsy until 2011. Adrafinil is NOT federally scheduled (unlike modafinil, Schedule IV). Liver loading is higher than modafinil due to hepatic conversion — this is the main safety consideration vs modafinil.`,
    researchAdvantages: `Not federally scheduled (vs modafinil Schedule IV) | Established prodrug PK — predictable modafinil exposure | Well-characterized in animal + human narcolepsy studies (1980s-1990s)`,
    researchConsiderations: `Elevated hepatic enzymes with chronic use — France withdrew in 2011 over hepatotoxicity concerns | ~2× loading dose vs modafinil to achieve same modafinil Cmax | Slower onset than modafinil (hepatic first-pass conversion required)`,
    evidenceConfidence: `MODERATE`,
    aliases: [`Olmifon`, `CRL-40028`],
    mw: `289.35 g/mol`,
    benefitScore: 65,
    harmScore: 32,
    nextSteps: [`Build full sulfoxide synthesis from benzhydrylthioacetic acid + H2O2/MCPBA
Translate to kg-scale using EtOAc + ethanol + acetone palette
Draft SOP for hepatic-safety warnings for research customers
Compile full publication list (Milgram, Bastuji) with DOIs`],
  },

  "ampakines": {
    id: "ampakines",
    name: `Ampakines`,
    fullName: `AMPA receptor positive allosteric modulator research class`,
    categoryId: `cognitive`,
    program: `Program J — Nootropic / Cognitive`,
    summary: `AMPA potentiation / cognition research class — sunifiram and unifiram are exemplars. No direct CSA similarity.`,
  },

  "armodafinil-comparator": {
    id: "armodafinil-comparator",
    name: `Armodafinil Comparator`,
    fullName: `Armodafinil — (R)-enantiomer of modafinil (reference)`,
    categoryId: `cognitive`,
    program: `Program C — Wakefulness / Neuroinflammation`,
    schedulingStatus: `scheduled`,
    schedulingNote: `SCHEDULE IV (DEA). FDA-approved.`,
    summary: `Approved Schedule IV (R)-enantiomer of modafinil with longer duration. Reference compound only.`,
    flagWarning: `Schedule IV`,
    aliases: [`Nuvigil`],
  },

  "bromantane-analogs": {
    id: "bromantane-analogs",
    name: `Bromantane Analogs`,
    fullName: `Bromantane-derived adamantane wakefulness research class`,
    categoryId: `cognitive`,
    program: `Program C — Wakefulness / Neuroinflammation`,
    summary: `Adamantane dopaminergic/adaptogen/wakefulness research class — Bromantane approved in Russia for asthenic disorders.`,
    flagWarning: `Stimulant-adjacent`,
  },

  "ce-123": {
    id: "ce-123",
    name: `CE-123`,
    fullName: `CE-123 — atypical DAT inhibitor`,
    categoryId: `cognitive`,
    program: `Program C — Wakefulness / Neuroinflammation`,
    summary: `Atypical dopamine transporter inhibitor / nootropic candidate from the Sitte lab. Pro-cognitive effects without classical stimulant abuse liability.`,
    flagWarning: `Stimulant-mechanism adjacency`,
  },

  "f-modafinil": {
    id: "f-modafinil",
    name: `F-Modafinil (CRL-40,940)`,
    fullName: `Bisfluoromodafinil / Flmodafinil`,
    categoryId: `cognitive`,
    program: `Program C`,
    cas: `90280-13-0`,
    formula: `C₁₅H₁₃F₂NO₂S`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Parent compound modafinil is Schedule IV. F-modafinil retains structural similarity — Schedule IV parent relationship creates medium scheduling risk. FDA/Rx-drug adjacency (modafinil is approved drug) requires careful research-only positioning.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — with legal review + strong EHS process controls`,
    priorityTier: `Tier 1 — Production target`,
    summary: `Bisfluoro analog of modafinil developed by Cephalon/Lafon (CRL-40,940). Reported in animal studies as 3–5× more potent than modafinil with longer duration. Wakefulness-promoting with likely monoamine/orexin/inflammatory-pathway relevance. Wohler internal scale-up safety memo identifies acid-chloride route as the kg-scale limitation (HCl/SO₂ from SOCl₂ or HCl/CO/CO₂ from oxalyl chloride) — requires acid-gas scrubber + ventilated containment + CO monitor.`,
    researchAdvantages: `3–5× more potent than modafinil with extended duration | Novel wakefulness-promoting research tool; potential for ADHD-adjacent and fatigue research | Anti-inflammatory profile suggested by related derivatives (BV2 microglia studies) | Published synthesis routes (Jung 2012, Cephalon patent) | Wohler has existing process development on this compound`,
    researchConsiderations: `Schedule IV parent (modafinil) creates scheduling-trajectory risk | Acid-chloride kg-scale hazards (HCl, SO₂, CO) — scrubber + CO monitor required | FDA/Rx-drug adjacency — clear 'research use only' positioning essential | Dependence potential (class effect — modafinil has low but non-zero abuse liability)`,
    evidenceConfidence: `MODERATE`,
    aliases: [`Flmodafinil`, `CRL-40,940`, `Lauflumide`],
    mw: `309.33 g/mol`,
    benefitScore: 78,
    harmScore: 28,
    nextSteps: [`Finalize scrubber train design for acid-chloride step
Patent landscape review on F-modafinil IP
Produce 50-g reference standard + COA
Anti-inflammatory activity confirmation in BV2 microglia assay
University partner identification for neuroinflammation research`],
  },

  "fladrafinil": {
    id: "fladrafinil",
    name: `Fladrafinil`,
    fullName: `Fladrafinil (CRL-40,941)`,
    categoryId: `cognitive`,
    program: `Program C — Wakefulness / Neuroinflammation`,
    summary: `Bis-fluoro adrafinil analog — the fluorinated prodrug to flmodafinil. Research wakefulness compound.`,
    flagWarning: `Modafinil/adrafinil adjacency`,
    aliases: [`CRL-40941`],
  },

  "flmodafinil-lauflumide": {
    id: "flmodafinil-lauflumide",
    name: `Flmodafinil / Lauflumide`,
    fullName: `Bisfluoromodafinil (CRL-40,940)`,
    categoryId: `cognitive`,
    program: `Program C — Wakefulness / Neuroinflammation`,
    summary: `Bis-fluoro modafinil analog — research wakefulness compound. Same scaffold as F-modafinil program but with two fluorines.`,
    flagWarning: `Modafinil adjacency`,
    aliases: [`CRL-40940`, `Lauflumide`],
  },

  "h3-antagonists": {
    id: "h3-antagonists",
    name: `Histamine H3 Antagonists`,
    fullName: `Histamine H3 receptor antagonist/inverse agonist research class`,
    categoryId: `cognitive`,
    program: `Program C — Wakefulness / Neuroinflammation`,
    summary: `Wakefulness/cognition research — pitolisant is approved (Wakix) for narcolepsy. H3 antagonism increases histamine, ACh, NE, DA.`,
    flagWarning: `Pharma adjacency`,
  },

  "modafinil-anti-inflammatory-11a-k": {
    id: "modafinil-anti-inflammatory-11a-k",
    name: `Modafinil Anti-Inflammatory Derivatives (11a-k, 12a-k)`,
    fullName: `Modafinil-derived benzhydrylsulfinyl/sulfonyl anti-inflammatory compounds (Jung 2012, series 11a-k and 12a-k)`,
    categoryId: `cognitive`,
    program: `Program C`,
    formula: `Series — various modafinil analogs`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Modafinil (parent) is Schedule IV; these anti-inflammatory derivatives are non-stimulant research tools.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — anti-inflammatory framing reduces abuse concern`,
    priorityTier: `Tier 2`,
    summary: `11a-k and 12a-k derivatives of modafinil from Jung et al. 2012 (Molecules). Several derivatives suppress nitrite generation and iNOS/COX-2 expression in LPS-stimulated BV2 microglia — supporting a wakefulness + neuroinflammation research framing rather than stimulant/nootropic. Positioned as anti-inflammatory research tools reduces analog scheduling concern vs wakefulness-focused F-modafinil.`,
    researchAdvantages: `Non-stimulant positioning — reduced scheduling scrutiny vs F-modafinil | Direct anti-neuroinflammatory data in BV2 microglia | Relevant to Parkinson's/Alzheimer's-adjacent research | Series of 20+ analogs → SAR research package | Published synthesis from Jung 2012`,
    researchConsiderations: `Selection of which 11/12 analog to produce first requires review | Some derivatives may still have wakefulness activity`,
    evidenceConfidence: `MODERATE`,
    mw: `Varies (~280–350 g/mol per analog)`,
    benefitScore: 72,
    harmScore: 18,
    nextSteps: [`Select 3–5 lead analogs from Jung 2012 based on potency + drug-likeness
BV2 microglia assay replication (in-house or CRO)
Partner with neuroinflammation lab (Parkinson's or Alzheimer's focus)
File formulation/method-of-use patents`],
  },

  "modafinil-comparator": {
    id: "modafinil-comparator",
    name: `Modafinil Comparator`,
    fullName: `Modafinil — FDA-approved wakefulness drug (reference)`,
    categoryId: `cognitive`,
    program: `Program C — Wakefulness / Neuroinflammation`,
    schedulingStatus: `scheduled`,
    schedulingNote: `SCHEDULE IV (DEA). FDA-approved for narcolepsy, shift-work sleep disorder, and OSA.`,
    summary: `Approved Schedule IV wakefulness drug. Reference compound only — essential benchmark for Wohler's F-modafinil and modafinil derivative programs.`,
    flagWarning: `Schedule IV`,
    aliases: [`Provigil`],
  },

  "nsi-189": {
    id: "nsi-189",
    name: `NSI-189`,
    fullName: `(4-benzylpiperazin-1-yl)[2-(3-methylbutylamino)pyridin-3-yl]methanone phosphate`,
    categoryId: `cognitive`,
    program: `Program J`,
    cas: `1270138-40-3`,
    formula: `C₂₂H₃₀N₄O · H₃PO₄`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Failed Phase II for MDD (Neuralstem, 2017) but not approved or scheduled.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — unique neurogenesis mechanism`,
    priorityTier: `Tier 2`,
    summary: `Neurogenic agent that stimulates hippocampal neurogenesis, specifically increasing dentate gyrus volume. Distinct mechanism from all existing antidepressants. Failed Phase II primary endpoint but promising signals in depression with cognitive complaints and anhedonia. Existing Phase I/II human safety data makes it an unusually well-characterized unscheduled research compound.`,
    researchAdvantages: `Unique neurogenesis mechanism — no competing compounds | Existing Phase I/II human safety data (rare for an unscheduled compound) | Strong cognitive + antidepressant research rationale | Applicable to TBI, Alzheimer's, cognitive decline research | IP landscape open (Neuralstem shelved program)`,
    researchConsiderations: `Failed Phase II primary endpoint — clinical signal is secondary-endpoint only | Complex multi-step synthesis`,
    evidenceConfidence: `HIGH`,
    mw: `464.49 g/mol (phosphate salt)`,
    benefitScore: 75,
    harmScore: 20,
    nextSteps: [`IP landscape review
University partner in TBI / cognitive decline research
Reference standard production`],
  },

  "orexin-agonists": {
    id: "orexin-agonists",
    name: `Orexin Agonist Research Tools`,
    fullName: `Orexin receptor agonist research compounds`,
    categoryId: `cognitive`,
    program: `Program C — Wakefulness / Neuroinflammation`,
    summary: `Narcolepsy/wakefulness research — orexin agonism being pursued by Takeda (TAK-861) and others for narcolepsy type 1.`,
    flagWarning: `Pharma adjacency`,
  },

  "pde4-cognition-tools": {
    id: "pde4-cognition-tools",
    name: `PDE4 Inhibitors / Roflumilast-like`,
    fullName: `PDE4 inhibitor cognition/neuroinflammation research class`,
    categoryId: `cognitive`,
    program: `Program C — Wakefulness / Neuroinflammation`,
    summary: `cAMP / cognition / inflammation research — PDE4 inhibition. Roflumilast is an approved COPD drug; research analogs of interest for cognition.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "prl-8-53": {
    id: "prl-8-53",
    name: `PRL-8-53`,
    fullName: `Methyl 3-(2-(benzyl(methyl)amino)ethyl)benzoate hydrochloride`,
    categoryId: `cognitive`,
    program: `Program J`,
    cas: `51352-87-5`,
    formula: `C₁₈H₂₁NO₂·HCl`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — replicate the famous 1978 study`,
    priorityTier: `Tier 1 — University replication story`,
    summary: `Dopaminergic/serotonergic modulator + cholinergic enhancer developed by Hansl. The 1978 Hansl & Mead clinical trial (Psychopharmacology) reported >200 % improvement in verbal learning retention in below-average baseline scorers — a dramatic result never formally replicated. Ideal rigorous-replication candidate for university research partnership.`,
    researchAdvantages: `Dramatic 1978 human data — never replicated; publishable replication project | Multi-mechanism pharmacology — dopaminergic/serotonergic/cholinergic | Unscheduled | Simple synthesis`,
    researchConsiderations: `Minimal modern data | 1978 study had small sample size — replication may not confirm`,
    evidenceConfidence: `MODERATE`,
    mw: `319.83 g/mol`,
    benefitScore: 72,
    harmScore: 22,
    nextSteps: [`Reference standard production
Partner with university for rigorous double-blind replication of Hansl 1978`],
  },

  "sunifiram": {
    id: "sunifiram",
    name: `Sunifiram`,
    fullName: `1-Benzoyl-4-propanoylpiperazine (DM-235)`,
    categoryId: `cognitive`,
    program: `Program J`,
    cas: `314728-85-3`,
    formula: `C₁₄H₁₈N₂O₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — novel mechanism, low regulatory risk`,
    priorityTier: `Tier 2`,
    summary: `Ampakine-class cognitive enhancer that potentiates AMPA receptors and stimulates CaMKII (LTP/memory consolidation). Also upregulates acetylcholine and dopamine in prefrontal cortex. Active at very low doses in rodent cognition assays (ng/kg range suggested in some reports).`,
    researchAdvantages: `Novel mechanism distinct from classic stimulants — low dependence liability | AMPA potentiation directly relevant to Alzheimer's / cognitive impairment research | Unscheduled, low regulatory risk | Simple piperazine-based synthesis`,
    researchConsiderations: `Human clinical data very limited | High potency in rodent models requires careful dose-response characterization`,
    evidenceConfidence: `MODERATE`,
    aliases: [`DM-235`],
    mw: `246.31 g/mol`,
    benefitScore: 72,
    harmScore: 22,
    nextSteps: [`Reference standard production
Partner with cognition lab for rigorous replication`],
  },

  "unifiram": {
    id: "unifiram",
    name: `Unifiram`,
    fullName: `(S)-1-(Benzoyl)-4-(propionyl)homopiperazine (DM-232)`,
    categoryId: `cognitive`,
    program: `Program J`,
    formula: `C₁₅H₂₀N₂O₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — pair with sunifiram for SAR`,
    priorityTier: `Tier 2`,
    summary: `Homolog of sunifiram with homopiperazine (7-membered ring) in place of piperazine. AMPA potentiator with potentially enhanced selectivity. Anti-amnestic in scopolamine-induced amnesia rodent models.`,
    researchAdvantages: `Paired comparison with sunifiram for SAR | Anti-amnestic activity validated | Simple synthesis | Unscheduled`,
    researchConsiderations: `Less-studied than sunifiram | Limited human data`,
    evidenceConfidence: `MODERATE`,
    aliases: [`DM-232`],
    mw: `260.34 g/mol`,
    benefitScore: 70,
    harmScore: 22,
    nextSteps: [`Reference standard production`],
  },

  "alpha7-nachr-pams": {
    id: "alpha7-nachr-pams",
    name: `α7 Nicotinic PAMs`,
    fullName: `α7 nicotinic acetylcholine receptor positive allosteric modulators`,
    categoryId: `cognitive`,
    program: `Program J — Nootropic / Cognitive`,
    summary: `Focus/cognition/inflammation research — α7 nAChR PAMs without direct nicotine agonism.`,
  },

  "2-fdck": {
    id: "2-fdck",
    name: `2-FDCK`,
    fullName: `2-Fluorodeschloroketamine`,
    categoryId: `dissociatives`,
    program: `Program F`,
    cas: `111982-49-1`,
    formula: `C₁₃H₁₆FNO`,
    schedulingStatus: `scheduled`,
    schedulingNote: `⚠️ FEDERALLY SCHEDULED — temporarily Schedule I as of January 2026. No longer a research-use-only unscheduled compound. Included here for historical reference and as a cautionary data point. Any work requires DEA Schedule I registration and full institutional controls.`,
    status: `Scheduled — Do Not Produce`,
    statusColor: `red`,
    goDecision: `KILL — federally scheduled 2026`,
    priorityTier: `KILL — Scheduled`,
    summary: `Fluorinated ketamine analog that was emergency-scheduled by DEA in January 2026. Analytical reference standard (Cayman Chemical CRM certificate available, 99.42 % purity by HPLC). Included in the Wohler database as a scheduling cautionary reference and to document the regulatory trajectory for related arylcyclohexylamines.`,
    researchAdvantages: `Clean analytical data available for reference (Cayman Chemical CRM) | Demonstrates scheduling trajectory — important regulatory intelligence`,
    researchConsiderations: `Federally scheduled — research requires Schedule I DEA registration | Bladder toxicity reports in human use literature`,
    evidenceConfidence: `HIGH`,
    aliases: [`2F-DCK`, `F-Ketamine`],
    mw: `221.27 g/mol`,
    benefitScore: 60,
    harmScore: 78,
    nextSteps: [`Remove from active production consideration
Retain analytical standard for comparison/QC purposes only`],
  },

  "3meopcp-comparator": {
    id: "3meopcp-comparator",
    name: `3-MeO-PCP Comparator`,
    fullName: `3-Methoxyphencyclidine — PCP-like risk comparator`,
    categoryId: `dissociatives`,
    program: `Program F — Ketamine / Glutamate`,
    schedulingStatus: `scheduled`,
    schedulingNote: `DO NOT SYNTHESIZE. Schedule I in multiple jurisdictions. High CSA similarity to PCP Schedule I/II. Reference only.`,
    summary: `NOT A TARGET — PCP-like dissociative included only as a risk boundary / enforcement intelligence reference.`,
    flagWarning: `High Schedule I/II similarity`,
  },

  "ampa-potentiators": {
    id: "ampa-potentiators",
    name: `AMPA Potentiator Adjuncts`,
    fullName: `AMPA receptor potentiator research tools (ampakine class)`,
    categoryId: `dissociatives`,
    program: `Program F — Ketamine / Glutamate`,
    summary: `Downstream glutamate pathway research — AMPA potentiators are thought to be downstream of ketamine's rapid antidepressant effect.`,
  },

  "blixeprodil": {
    id: "blixeprodil",
    name: `Blixeprodil`,
    fullName: `Blixeprodil — clinical-stage NMDAR modulator`,
    categoryId: `dissociatives`,
    program: `Program F — Ketamine / Glutamate`,
    summary: `Clinical-stage ketamine-adjacent NMDAR modulator (GluN2B-selective) being investigated in depression and related indications.`,
    flagWarning: `Ketamine/glutamate-adjacent`,
  },

  "deschloroketamine": {
    id: "deschloroketamine",
    name: `Deschloroketamine (DCK)`,
    fullName: `2-(methylamino)-2-phenylcyclohexan-1-one`,
    categoryId: `dissociatives`,
    program: `Program F`,
    cas: `4551-92-2`,
    formula: `C₁₃H₁₇NO`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled as of 2026. 2-Fluorodeschloroketamine (2-FDCK) was federally scheduled January 2026 — scheduling trajectory on arylcyclohexylamines is active. Very high emergency-scheduling risk.`,
    status: `Hold — Active Scheduling Risk`,
    statusColor: `orange`,
    goDecision: `HOLD — monitor DEA announcements; do not commit capacity`,
    priorityTier: `Tier 3 — Hold on scheduling monitor`,
    summary: `NMDA receptor antagonist with somewhat higher potency than ketamine. Also binds sigma-1/sigma-2 receptors, which may contribute to rapid antidepressant effects. Longer duration than ketamine (4–6 h vs 1–2 h for dissociative effects). Chloro substituent removed from ketamine scaffold — distinct metabolism.`,
    researchAdvantages: `NMDA antagonism + sigma receptor activity → novel antidepressant research tool | Longer duration than ketamine — different therapeutic session formats | Distinct metabolism from ketamine due to missing chloro | Unscheduled window for research-grade standard production`,
    researchConsiderations: `Very high emergency-scheduling risk (2-FDCK precedent) | Bladder toxicity is class concern (arylcyclohexylamine) | Dependence potential | Longer duration = higher dissociation burden`,
    evidenceConfidence: `MODERATE`,
    aliases: [`DCK`, `2'-Oxo-PCM`],
    mw: `203.28 g/mol`,
    benefitScore: 72,
    harmScore: 40,
    nextSteps: [`Monitor DEA Federal Register for arylcyclohexylamine scheduling
Hold commit to production`],
  },

  "dxm-analogs": {
    id: "dxm-analogs",
    name: `Dextromethorphan Analogs`,
    fullName: `DXM-derived NMDA/sigma antidepressant research analog class`,
    categoryId: `dissociatives`,
    program: `Program F — Ketamine / Glutamate`,
    summary: `NMDA/sigma antidepressant mechanism research — parallel to the FDA-approved Auvelity (dextromethorphan + bupropion) for MDD.`,
    flagWarning: `DXM/pharma adjacency`,
  },

  "fluorexetamine": {
    id: "fluorexetamine",
    name: `Fluorexetamine (FXE)`,
    fullName: `3-Fluoromethoxetamine`,
    categoryId: `dissociatives`,
    program: `Program F`,
    formula: `C₁₅H₂₀FNO₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled as of 2026. MXE (parent) was never federally scheduled in U.S. Given 2-FDCK precedent, monitoring is essential.`,
    status: `Hold — Active Scheduling Risk`,
    statusColor: `orange`,
    goDecision: `HOLD — monitor scheduling; consider non-arylcyclohexylamine glutamate tools instead`,
    priorityTier: `Tier 3 — Hold`,
    summary: `Fluorinated methoxetamine (MXE) analog. NMDA antagonist with improved metabolic stability and BBB penetration vs. MXE due to fluorine. Could serve as a research tool for NMDA antagonist antidepressant mechanism with more predictable PK than MXE.`,
    researchAdvantages: `Fluorine-enhanced PK vs MXE | Clear NMDA antagonist pharmacology | Unscheduled window`,
    researchConsiderations: `Arylcyclohexylamine scheduling trajectory | Bladder toxicity class effect | Limited formal pharmacology data`,
    evidenceConfidence: `MODERATE`,
    aliases: [`FXE`, `3F-MXE`],
    mw: `265.33 g/mol`,
    benefitScore: 65,
    harmScore: 42,
    nextSteps: [`Monitor scheduling
Consider non-arylcyclohexylamine glutamate tools (ketamine metabolites, sigma modulators) as better-priority alternatives`],
  },

  "hnk-analogs": {
    id: "hnk-analogs",
    name: `HNK Analogs`,
    fullName: `Hydroxynorketamine (HNK) analogs`,
    categoryId: `dissociatives`,
    program: `Program F — Ketamine / Glutamate`,
    summary: `(2R,6R)-HNK is ketamine's active metabolite with antidepressant effects proposed to be NMDA-independent (AMPA-dependent). Potentially non-dissociative antidepressant pathway.`,
    flagWarning: `Ketamine metabolite adjacency`,
  },

  "memantine-analogs": {
    id: "memantine-analogs",
    name: `Memantine Analogs`,
    fullName: `Memantine-derived NMDAR research analog class`,
    categoryId: `dissociatives`,
    program: `Program F — Ketamine / Glutamate`,
    summary: `Lower-abuse NMDA research — memantine is an approved Alzheimer's drug with uncompetitive NMDA antagonism. Analogs are research tools for neuroprotection and cognition.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "mxe-comparator": {
    id: "mxe-comparator",
    name: `Methoxetamine (MXE) Comparator`,
    fullName: `Methoxetamine — literature/risk comparator`,
    categoryId: `dissociatives`,
    program: `Program F — Ketamine / Glutamate`,
    schedulingStatus: `scheduled`,
    schedulingNote: `Schedule I in several countries (UK, EU). DEA temporarily scheduled; state-level varies. Research reference only.`,
    summary: `Literature/risk comparator — NOT a preferred target. Included for enforcement intelligence. Has been associated with overdose cases.`,
    flagWarning: `Arylcyclohexylamine concern`,
  },

  "norketamine-analogs": {
    id: "norketamine-analogs",
    name: `Norketamine Analogs`,
    fullName: `Norketamine (ketamine N-demethyl metabolite) analog class`,
    categoryId: `dissociatives`,
    program: `Program F — Ketamine / Glutamate`,
    summary: `Ketamine's primary metabolite with its own NMDA antagonist activity. Reference comparator class for understanding ketamine PK.`,
    flagWarning: `Ketamine adjacency`,
  },

  "sigma-nmda-hybrids": {
    id: "sigma-nmda-hybrids",
    name: `Sigma-1 / NMDA Hybrid Tools`,
    fullName: `Sigma-1 + NMDA receptor hybrid pharmacology research class`,
    categoryId: `dissociatives`,
    program: `Program F — Ketamine / Glutamate`,
    summary: `Hybrid sigma-1 / NMDA modulators for depression, pain, and neuroprotection research. Lower ketamine similarity if structurally distinct.`,
  },

  "xw10508": {
    id: "xw10508",
    name: `XW10508`,
    fullName: `XW10508 — oral esketamine prodrug`,
    categoryId: `dissociatives`,
    program: `Program F — Ketamine / Glutamate`,
    summary: `Clinical-stage esketamine oral prodrug example. Reference compound for oral-delivery NMDA antagonist programs.`,
    flagWarning: `Ketamine/esketamine adjacency`,
  },

  "amino-tadalafil": {
    id: "amino-tadalafil",
    name: `Amino Tadalafil`,
    fullName: `Aminotadalafil — research-grade tadalafil analog`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    cas: `385769-84-6`,
    formula: `C₂₁H₁₉N₃O₄`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Classified as an adulterant in the FDA Tainted Sexual Enhancement Products list (Feb 2020) — cannot be sold as a dietary supplement in the U.S. Pure research-chemical status maintained only with research-use-only labeling and documented IRB/university partnerships.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `green`,
    goDecision: `TODO — high-value research PDE5 reference compound`,
    priorityTier: `Tier 1`,
    summary: `Aminotadalafil is a structural analog of tadalafil — a well-characterized PDE5 inhibitor research compound and tadalafil impurity reference standard. Published IC50 values against PDE5 (Lebret 2003) demonstrate comparable potency to tadalafil itself, making it an excellent research reference for PDE5 pharmacology studies. FDA has flagged it as an adulterant in supplements, so Wohler must enforce strict research-use-only posture.`,
    researchAdvantages: `Well-characterized PDE5 IC50 (~1.5–3 nM — comparable to tadalafil) | Official tadalafil impurity reference standard — pharmacopeial interest | Unscheduled — facilitates research supply | High demand from analytical chemistry labs (tadalafil QC)`,
    researchConsiderations: `FDA flagged as supplement adulterant — Wohler must enforce research-use-only labeling | Off-label human consumption risk if product is diverted | Potential FDA scrutiny of supplier reputation`,
    evidenceConfidence: `HIGH`,
    aliases: [`Tadalafil impurity B`, `Aminotadalafil`],
    mw: `377.39 g/mol`,
    benefitScore: 72,
    harmScore: 22,
    nextSteps: [`Build Lebret 2003 synthesis (Pictet-Spengler from D-tryptophan methyl ester)
Translate to kg-scale using EtOAc + DCM-alt (Wohler uses EtOAc + THF + acetone palette)
Draft research-use-only labeling SOP with regulatory attorney
Confirm unscheduled status in all target states
Identify D-tryptophan methyl ester vendor / reliable supply`],
  },

  "avanafil-analogs": {
    id: "avanafil-analogs",
    name: `Avanafil Analogs`,
    fullName: `Avanafil-derived fast-onset PDE5 analog class`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Fast-onset PDE5 research — avanafil (Stendra) has the fastest onset of approved PDE5 inhibitors.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "baohuoside-analogs": {
    id: "baohuoside-analogs",
    name: `Baohuoside Analogs`,
    fullName: `Baohuoside icariin-family SAR research class`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Icariin-family SAR — baohuoside is a key Epimedium bioactive flavonoid with PDE5 activity.`,
  },

  "d4-agonists": {
    id: "d4-agonists",
    name: `Dopamine D4 Agonist Analogs`,
    fullName: `Dopamine D4 receptor selective agonist class`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Central arousal pathway research — D4 agonists for sexual function without D2-mediated side effects.`,
    flagWarning: `Dopaminergic risk, not CSA by default`,
  },

  "endothelin-antagonists": {
    id: "endothelin-antagonists",
    name: `Endothelin Antagonists`,
    fullName: `Endothelin receptor antagonist vascular research class`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Vascular ED research — endothelin-1 is a potent vasoconstrictor; antagonists for vascular conditions.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "icariin": {
    id: "icariin",
    name: `Icariin / Icariside II`,
    fullName: `Icariin and Icariside II (flavonoid PDE5 modulators)`,
    categoryId: `ed-sexual`,
    program: `Program G`,
    cas: `489-32-7 (icariin)`,
    formula: `C₃₃H₄₀O₁₅ (icariin)`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Used in traditional Chinese medicine; dietary supplement space has FDA attention on claims.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — low-controversy ED research candidate`,
    priorityTier: `Tier 2`,
    summary: `Flavonoid PDE5 inhibitor from Epimedium (horny goat weed). Icariin itself is ~1000× less potent than sildenafil, but its metabolite icariside II is substantially more potent. Multi-mechanism: PDE5 inhibition + neuroprotection + testosterone-potentiating. Very low scheduling risk, clean research narrative.`,
    researchAdvantages: `Low scheduling + regulatory risk | Multi-mechanism profile (PDE5 + neuroprotection + testosterone) | Strong traditional Chinese medicine safety record | Natural product = clean research positioning | Diabetic ED research angle`,
    researchConsiderations: `Weaker primary PDE5 inhibition than synthetic inhibitors | Complex natural product — standardization challenge`,
    evidenceConfidence: `MODERATE`,
    aliases: [`Epimedium flavonoids`],
    mw: `676.67 g/mol`,
    benefitScore: 70,
    harmScore: 12,
    nextSteps: [`Standardized icariin USP-grade production
University ED research partner
Icariside II semi-synthesis optimization`],
  },

  "icariside-ii": {
    id: "icariside-ii",
    name: `Icariside II`,
    fullName: `Icariside II — Epimedium-derived icariin metabolite`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Stronger icariin metabolite candidate — more potent PDE5 inhibition than parent icariin in published studies.`,
  },

  "lodenafil": {
    id: "lodenafil",
    name: `Lodenafil Carbonate`,
    fullName: `Lodenafil carbonate — PDE5 prodrug`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `PDE5 prodrug comparator — approved in Brazil for ED. Prodrug PK research reference.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "melanotan-ii": {
    id: "melanotan-ii",
    name: `Melanotan II`,
    fullName: `Melanotan II — MC1R/MC3R/MC4R/MC5R agonist peptide`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `MC receptor sexual arousal comparator — non-selective melanocortin agonist. FDA has issued consumer warnings; research-use-only.`,
    flagWarning: `Peptide/drug adjacency`,
  },

  "mirodenafil": {
    id: "mirodenafil",
    name: `Mirodenafil`,
    fullName: `Mirodenafil — potent/selective PDE5 inhibitor`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Potent/selective PDE5 comparator — approved in South Korea for ED. Research reference for PDE5 selectivity.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "no-donor-adjuncts": {
    id: "no-donor-adjuncts",
    name: `NO Donor Adjuncts`,
    fullName: `Nitric oxide donor research class`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Low-NO ED / diabetic ED research — NO donor adjuncts to PDE5 inhibitor therapy.`,
  },

  "oxytocin-analogs": {
    id: "oxytocin-analogs",
    name: `Oxytocin Analogs`,
    fullName: `Oxytocin receptor agonist research peptide class`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Bonding / arousal research — oxytocin analog research for sexual-health and relationship research.`,
    flagWarning: `Peptide/drug adjacency`,
  },

  "pt-141": {
    id: "pt-141",
    name: `PT-141 Analogs`,
    fullName: `Bremelanotide-like MC4R agonists`,
    categoryId: `ed-sexual`,
    program: `Program G`,
    formula: `Peptide (11-mer cyclic)`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Parent compound bremelanotide (Vyleesi) is FDA-approved (HSDD). Novel analogs are research compounds.`,
    status: `Strongly Favored`,
    statusColor: `green`,
    goDecision: `GO — strong ED/sexual health research candidate`,
    priorityTier: `Tier 2 — Program G lead`,
    summary: `Melanocortin-4 receptor (MC4R) agonist acting centrally (not via PDE5/vasodilation). Works in populations where PDE5 inhibitors fail (nerve damage, psychological ED, female sexual dysfunction). FDA-approved parent compound has strong safety profile. Novel peptide analogs represent legitimate research space.`,
    researchAdvantages: `Centrally-acting mechanism — works where PDE5 inhibitors fail | Female and male sexual dysfunction applicability | Strong parent safety profile (bremelanotide Vyleesi approved) | Active research interest in peptide analogs | Post-prostatectomy ED research angle directly relevant to Wohler founder story`,
    researchConsiderations: `Peptide synthesis — specialized SPPS equipment required | Nausea is a known class effect | FDA-approved parent creates Rx-drug adjacency (must maintain research positioning)`,
    evidenceConfidence: `HIGH`,
    aliases: [`Bremelanotide analogs`],
    mw: `~1025 Da (bremelanotide)`,
    benefitScore: 80,
    harmScore: 18,
    nextSteps: [`Evaluate outsourced SPPS partnership vs internal capability build
Identify post-prostatectomy ED research partner
IP landscape analysis`],
  },

  "rhok-inhibitors": {
    id: "rhok-inhibitors",
    name: `Rho-Kinase Inhibitors`,
    fullName: `Rho-associated kinase (ROCK) inhibitor smooth-muscle research class`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Smooth-muscle relaxation / ED research — Rho-kinase inhibition enhances NO-cGMP pathway.`,
  },

  "sgc-stimulators": {
    id: "sgc-stimulators",
    name: `sGC Stimulators / Modulators`,
    fullName: `Soluble guanylate cyclase stimulator research class`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `NO/cGMP pathway for PDE5 nonresponders — sGC stimulators like riociguat (Adempas) approved for PAH.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "sildenafil-analogs": {
    id: "sildenafil-analogs",
    name: `Sildenafil / Vardenafil Research Analogs`,
    fullName: `Research-grade non-approved sildenafil and vardenafil structural variants`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    formula: `Various (PDE5 inhibitor pyrazolopyrimidine / triazine scaffolds)`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Many members are FDA Tainted Sexual Enhancement Products list adulterants (e.g., acetildenafil, hydroxyhomosildenafil, aildenafil, dimethylsildenafil). Research-use-only posture required.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `orange`,
    goDecision: `TODO — broad PDE5 SAR program`,
    priorityTier: `Tier 2`,
    summary: `A class of research-grade sildenafil and vardenafil structural analogs used in analytical reference, PDE5 SAR studies, and supplement QC. Includes acetildenafil, hydroxyhomosildenafil, dimethylsildenafil, and related pyrazolopyrimidine/triazine scaffolds. Many are documented FDA supplement adulterants, which means Wohler's role is strictly research-reference with rigorous research-use-only labeling.`,
    researchAdvantages: `High analytical-lab demand for reference standards | Documented PDE5 SAR published for most class members | Unscheduled federal status`,
    researchConsiderations: `Repeatedly found in adulterated supplements — reputational care required | Each analog requires separate synthesis + QC infrastructure`,
    evidenceConfidence: `MODERATE`,
    aliases: [`PDE5 research analogs`],
    mw: `~450–550 g/mol (analog-dependent)`,
    benefitScore: 65,
    harmScore: 28,
    nextSteps: [`Prioritize 3 analogs: acetildenafil, hydroxyhomosildenafil, dimethylsildenafil
Literature review for each (Venhuis, Reepmeyer series)
Build individual synthesis procedures
Regulatory attorney review of research-use-only labeling`],
  },

  "slx-2101": {
    id: "slx-2101",
    name: `SLx-2101`,
    fullName: `SLx-2101 — long-acting PDE5 candidate`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Long-acting PDE5 candidate from Surface Logix — research reference for extended-duration PDE5 research.`,
    flagWarning: `Approved-drug/development adjacency`,
  },

  "tadalafil-analogs-class": {
    id: "tadalafil-analogs-class",
    name: `Tadalafil Analog Class`,
    fullName: `Tadalafil structural analog class for PDE5/PDE11 selectivity research`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Broader tadalafil analog class beyond amino- and thio-tadalafil. PDE5 / PDE11 selectivity SAR research.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "thio-tadalafil": {
    id: "thio-tadalafil",
    name: `Thio-Tadalafil`,
    fullName: `Thiotadalafil — sulfur-substituted tadalafil analog`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    cas: `171596-36-4`,
    formula: `C₂₂H₁₉N₃O₃S`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Known PDE5 adulterant — FDA Tainted Sexual Enhancement Products list (2009+). Research-use-only posture required.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `orange`,
    goDecision: `TODO — PDE5 SAR research tool`,
    priorityTier: `Tier 2`,
    summary: `Thiotadalafil replaces the dione carbonyl oxygens of tadalafil with sulfur (thione) to give a sulfur-substituted research analog. Potent PDE5 inhibitor with published IC50 data (Venhuis 2008). Primarily a research reference compound for tadalafil SAR studies and an analytical reference for supplement-adulteration testing.`,
    researchAdvantages: `PDE5 IC50 potent and published (Venhuis 2008) | Key analytical reference for dietary supplement QC labs | Unscheduled`,
    researchConsiderations: `Adulterant listing by FDA requires strict SOP | Lower clinical relevance than amino tadalafil (fewer pharmacopoeia references)`,
    evidenceConfidence: `MODERATE`,
    aliases: [`Thiotadalafil`],
    mw: `405.47 g/mol`,
    benefitScore: 68,
    harmScore: 28,
    nextSteps: [`Review Venhuis 2008 synthesis route
Design thionation step from tadalafil or direct synthesis from D-Trp-OMe + Lawesson reagent
Draft kg-scale route using Wohler standard solvents
Confirm unscheduled status with regulatory attorney`],
  },

  "tpn171h": {
    id: "tpn171h",
    name: `TPN171H / Simmerafil`,
    fullName: `TPN171H (Simmerafil) — PDE5 ED/PAH candidate`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `PDE5 ED / pulmonary arterial hypertension candidate — Chinese development-stage compound.`,
    flagWarning: `Approved-drug/development adjacency`,
  },

  "udenafil": {
    id: "udenafil",
    name: `Udenafil`,
    fullName: `Udenafil — long-duration PDE5 inhibitor`,
    categoryId: `ed-sexual`,
    program: `Program G — ED / Sexual Health`,
    summary: `Duration/onset PDE5 comparator — approved in South Korea. Longer duration than sildenafil.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "ht1b-ht2a-social": {
    id: "ht1b-ht2a-social",
    name: `5-HT1B/5-HT2A Mixed Social-Behavior Tools`,
    fullName: `Mixed serotonergic social-behavior research class`,
    categoryId: `entactogens`,
    program: `Program E — Entactogens`,
    summary: `Mixed 5-HT1B/5-HT2A modulators for social behavior and fear-extinction research.`,
  },

  "5-iai": {
    id: "5-iai",
    name: `5-IAI`,
    fullName: `5-Iodo-2-aminoindane`,
    categoryId: `entactogens`,
    program: `Program E — Entactogens`,
    summary: `Aminoindane entactogen comparator — less-studied sibling to MDAI in the aminoindane class.`,
    flagWarning: `MDMA-adjacent`,
  },

  "heal": {
    id: "heal",
    name: `HEAL`,
    fullName: `HEAL (MDMA-like research compound — structure pending public disclosure)`,
    categoryId: `entactogens`,
    program: `Program E — Entactogens`,
    formula: `TBD`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Novel research compound. Confirm scheduling status pre-synthesis via regulatory counsel.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `orange`,
    goDecision: `TODO — research MDMA-adjacent entactogen alternative`,
    priorityTier: `Tier 2`,
    summary: `HEAL is a research-stage MDMA-adjacent entactogen discussed in the Wohler expansion list. It is presented as a companion or alternative to MEAI and R-MDMA in the entactogen lane. Full structure, pharmacology, and scheduling status require confirmation from primary literature.`,
    researchAdvantages: `MDMA-alternative for AUD and PTSD research | Potential lower abuse liability vs MDMA`,
    researchConsiderations: `Very limited published data | Federal Analogue Act consideration if structure is too MDMA-like`,
    evidenceConfidence: `LOW`,
    mw: `TBD`,
    benefitScore: 72,
    harmScore: 28,
    nextSteps: [`Confirm HEAL structure and primary reference source
Literature review: compare to MEAI, R-MDMA, methylone
Regulatory attorney review for Federal Analogue Act exposure
Populate synthesis and kg-scale plan once structure is confirmed`],
  },

  "low-dat-entactogens": {
    id: "low-dat-entactogens",
    name: `Low-DAT Entactogen Analogs`,
    fullName: `Low dopamine transporter activity entactogen class`,
    categoryId: `entactogens`,
    program: `Program E — Entactogens`,
    summary: `Entactogen analog class with reduced DAT activity hypothesized to lower abuse liability vs MDMA.`,
  },

  "mbdb-analogs": {
    id: "mbdb-analogs",
    name: `MBDB-like Analogs`,
    fullName: `α-Ethyl homolog entactogen analog class`,
    categoryId: `entactogens`,
    program: `Program E — Entactogens`,
    summary: `α-Ethyl homolog entactogen class (MBDB, BDB, etc.). Reference compounds for SERT-biased entactogen pharmacology.`,
    flagWarning: `MDMA/MDE/MBDB adjacency`,
  },

  "mdai": {
    id: "mdai",
    name: `MDAI`,
    fullName: `5,6-Methylenedioxy-2-aminoindane`,
    categoryId: `entactogens`,
    program: `Program E — Entactogens`,
    summary: `Non-neurotoxic-entactogen literature candidate. Aminoindane scaffold reported with MDMA-like prosocial effects and lower serotonergic neurotoxicity in animal studies.`,
    flagWarning: `MDMA/MDA-adjacent`,
  },

  "mde-analogs": {
    id: "mde-analogs",
    name: `MDE-like Analogs`,
    fullName: `N-ethyl MDMA homolog entactogen class`,
    categoryId: `entactogens`,
    program: `Program E — Entactogens`,
    schedulingStatus: `scheduled`,
    schedulingNote: `MDE itself is Schedule I (CSA 1988). Analog Act consideration for any structurally-related research compound.`,
    summary: `N-ethyl homolog entactogen class. MDE is Schedule I — analogs are reference only.`,
    flagWarning: `MDE is Schedule I`,
  },

  "meai": {
    id: "meai",
    name: `MEAI`,
    fullName: `5-Methoxy-2-aminoindane`,
    categoryId: `entactogens`,
    program: `Program E`,
    cas: `132741-81-2`,
    formula: `C₁₀H₁₃NO`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled in the U.S. Structural family of aminoindanes; MDAI (related) is also unscheduled. MDMA-adjacent = heightened scrutiny.`,
    status: `Favored — Legal Review Required`,
    statusColor: `orange`,
    goDecision: `GO — for alcohol use disorder research framing`,
    priorityTier: `Tier 2`,
    summary: `Entactogen-like compound; pharmacologically and structurally close to MDMA but with a novel aminoindane scaffold. Yale ABN lab has MEAI in Phase I/IIa for alcohol use disorder (Clearmind Medicine), reporting alcohol-like euphoric effects with reduced desire to consume alcohol — making MEAI the most credible MDMA-adjacent compound for therapeutic framing. Best positioning: AUD research tool, not 'legal MDMA.'`,
    researchAdvantages: `Published Phase I/IIa data for AUD (Clearmind Medicine / Yale) | Entactogen-like profile with potential AUD therapeutic signal | Defensible framing as AUD/craving-reduction research tool | Aminoindane scaffold differentiates from MDMA core`,
    researchConsiderations: `MDMA-adjacent perception — heightened legal/reputational scrutiny | Limited long-term safety data | Recreational overdose fatalities reported in UK/Israel`,
    evidenceConfidence: `MODERATE`,
    aliases: [`5-MeO-AI`, `Pace`],
    mw: `163.22 g/mol`,
    benefitScore: 70,
    harmScore: 35,
    nextSteps: [`Legal memo on entactogen analog risk
Partner with Clearmind or Yale
Focus on AUD framing`],
  },

  "sert-biased-releasers": {
    id: "sert-biased-releasers",
    name: `Non-Neurotoxic SERT-Biased Releasers`,
    fullName: `SERT-selective monoamine releaser research class`,
    categoryId: `entactogens`,
    program: `Program E — Entactogens`,
    summary: `Desired research class — SERT > DAT selectivity reduces MDMA-like neurotoxicity while preserving prosocial/entactogenic effects.`,
  },

  "oxytocin-adjuncts": {
    id: "oxytocin-adjuncts",
    name: `Oxytocin / Social-Bonding Adjuncts`,
    fullName: `Oxytocin receptor agonist research adjuncts`,
    categoryId: `entactogens`,
    program: `Program E — Entactogens`,
    summary: `Prosocial therapy research tools — non-MDMA mechanism. Oxytocin receptor agonism for social bonding research.`,
  },

  "r-mddma": {
    id: "r-mddma",
    name: `R-MDDMA`,
    fullName: `R-MDDMA (chiral MDMA analog)`,
    categoryId: `entactogens`,
    program: `Program E`,
    formula: `~MDMA scaffold variant`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled as of 2026. Extremely new — emerging literature.`,
    status: `Hold — Too New`,
    statusColor: `red`,
    goDecision: `HOLD — literature watch; too early`,
    priorityTier: `Watch — Do not produce`,
    summary: `Very recent literature explores R-MDDMA as a potentially safer MDMA analog with chiral separation of therapeutic from adverse properties. Too new for production decisions. Listed here for research tracking.`,
    researchAdvantages: `Potentially safer MDMA analog`,
    researchConsiderations: `Too new to evaluate | MDMA analog scheduling risk`,
    evidenceConfidence: `LOW`,
    mw: `~215 g/mol`,
    benefitScore: 68,
    harmScore: 50,
    nextSteps: [`Literature watch`],
  },

  "r-mdma": {
    id: "r-mdma",
    name: `R-MDMA`,
    fullName: `(R)-(−)-3,4-Methylenedioxymethamphetamine`,
    categoryId: `entactogens`,
    program: `Program E — Entactogens`,
    cas: `81262-70-6`,
    formula: `C₁₁H₁₅NO₂`,
    schedulingStatus: `scheduled`,
    schedulingNote: `SCHEDULE I — both R and S enantiomers of MDMA are DEA Schedule I. Only synthesizable under DEA Schedule I researcher license with institutional partnership. Watch-only pipeline compound.`,
    status: `HOLD`,
    statusColor: `red`,
    goDecision: `HOLD — Schedule I. Reference only.`,
    priorityTier: `Watch`,
    summary: `R-MDMA is the (R)-enantiomer of MDMA. Animal studies suggest reduced locomotor stimulation and serotonergic neurotoxicity compared to racemic MDMA while preserving prosocial / entactogenic effects (Pitts 2018). Cannot be produced without DEA Schedule I license. Tracked as a reference compound only.`,
    researchAdvantages: `Reduced serotonergic neurotoxicity vs racemic MDMA in animal studies (Pitts 2018) | Maintains MDMA-like prosocial effects at lower neurotoxic cost | Pure-enantiomer research relevance for MAPS-adjacent Phase 2/3 exploration`,
    researchConsiderations: `Schedule I — cannot produce or ship without DEA license | Limits Wohler's supply role to reference only`,
    evidenceConfidence: `MODERATE`,
    aliases: [`R-(-)-MDMA`],
    mw: `193.24 g/mol`,
    benefitScore: 60,
    harmScore: 65,
    nextSteps: [`Monitor DEA Schedule I research-license feasibility
Watch Lykos / MAPS clinical program for regulatory shifts
No synthesis work — keep on reference / watch list only`],
  },

  "sdma": {
    id: "sdma",
    name: `SDMA`,
    fullName: `SDMA (1,3-Benzoxathiole MDMA analog)`,
    categoryId: `entactogens`,
    program: `Program E`,
    formula: `~C₁₀H₁₃NOS`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Very close MDMA analog — highest analog-act enforcement concern. Counsel-first posture mandatory.`,
    status: `Hold — Legal-First`,
    statusColor: `red`,
    goDecision: `HOLD — literature watch only until counsel narrows`,
    priorityTier: `KILL — On-hold pending legal`,
    summary: `Next-generation MDMA analog where the 1,3-benzodioxole group of MDMA is replaced by a 1,3-benzoxathiole. 2025 research characterizes SDMA-family compounds for SAR separation of therapeutic entactogenic effects from toxicity and abuse liability. Too close to MDMA for casual Wohler engagement.`,
    researchAdvantages: `Genuine SAR innovation for separating therapy from toxicity | Published 2025 research`,
    researchConsiderations: `Extremely close to MDMA — analog-act high risk | Reputational risk for Wohler | No clinical development pathway`,
    evidenceConfidence: `LOW`,
    mw: `~195 g/mol`,
    benefitScore: 65,
    harmScore: 55,
    nextSteps: [`Literature watch only`],
  },

  "allopregnanolone-analogs": {
    id: "allopregnanolone-analogs",
    name: `Allopregnanolone Analogs`,
    fullName: `Allopregnanolone-derived neurosteroid GABA-A modulator class`,
    categoryId: `gabaergic`,
    program: `Anxiety Lane`,
    summary: `Neurosteroid GABA-A modulation — brexanolone (Zulresso) and zuranolone (Zurzuvae) are approved allopregnanolone-based therapies for PPD and MDD.`,
    flagWarning: `Brexanolone/zuranolone pharma adjacency`,
  },

  "baclofen-analogs": {
    id: "baclofen-analogs",
    name: `Baclofen Analogs`,
    fullName: `Baclofen-derived GABA-B agonist research class`,
    categoryId: `gabaergic`,
    program: `Anxiety Lane`,
    summary: `GABA-B agonist research — baclofen is an approved muscle relaxant; analogs of interest for AUD and anxiety research.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "etifoxine": {
    id: "etifoxine",
    name: `Etifoxine / GRX-917`,
    fullName: `Etifoxine (parent) and GRX-917 (deuterated analog)`,
    categoryId: `gabaergic`,
    program: `Program J / Anxiety`,
    cas: `21715-46-8 (etifoxine)`,
    formula: `C₁₇H₁₇ClN₂OS`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled in the U.S. Approved anxiolytic in France (Stresam). GRX-917 (atai/GABA Therapeutics deuterated analog) is in development.`,
    status: `Strongly Favored`,
    statusColor: `green`,
    goDecision: `GO — cleanest anxiety research lane`,
    priorityTier: `Tier 1 — Lead anxiety candidate`,
    summary: `Non-benzodiazepine anxiolytic acting via TSPO (translocator protein) activation → enhanced neurosteroid synthesis (allopregnanolone) → GABA-A positive modulation. Approved in France as Stresam for 40+ years. GRX-917 is the deuterated clinical candidate (atai). Minimal sedation, minimal amnesia, no classical benzodiazepine dependence.`,
    researchAdvantages: `40+ years approved use in France — extensive human safety data | Non-benzodiazepine mechanism → no classic dependence/withdrawal | Endogenous neurosteroid enhancement = physiological anxiolysis | Active clinical development (atai/GABA Therapeutics GRX-917) | University-friendly: clean mechanism, strong safety record`,
    researchConsiderations: `Rare hepatotoxicity reports (~0.01 % in surveillance) | Rare hypersensitivity reactions`,
    evidenceConfidence: `HIGH`,
    aliases: [`Stresam`, `Stresan`],
    mw: `332.85 g/mol`,
    benefitScore: 82,
    harmScore: 15,
    nextSteps: [`Reference standard production
University partner for neurosteroid research
Explore deuteration strategy`],
  },

  "f-phenibut": {
    id: "f-phenibut",
    name: `F-Phenibut`,
    fullName: `β-(4-Fluorophenyl)-γ-aminobutyric acid`,
    categoryId: `gabaergic`,
    program: `Program J / Anxiety`,
    formula: `C₁₀H₁₂FNO₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled.`,
    status: `Hold — Dependence Risk`,
    statusColor: `orange`,
    goDecision: `GO with caveats — research-use only`,
    priorityTier: `Tier 3`,
    summary: `Fluorinated phenibut with 5–10× higher GABA-B/α2δ potency. Lower effective doses may reduce dependence — a hypothesis worth testing formally. Simple synthesis.`,
    researchAdvantages: `Higher potency than phenibut | Hypothesis: lower dose = lower dependence (testable) | Simple synthesis`,
    researchConsiderations: `Same fundamental dependence mechanism as phenibut | Less human data`,
    evidenceConfidence: `MODERATE`,
    aliases: [`Fluorophenibut`],
    mw: `197.21 g/mol`,
    benefitScore: 62,
    harmScore: 40,
    nextSteps: [`Hypothesis test: dose-dependence characterization`],
  },

  "afobazole-analogs": {
    id: "afobazole-analogs",
    name: `Fabomotizole / Afobazole Analogs`,
    fullName: `Fabomotizole (Afobazole) sigma/MT anxiolytic research class`,
    categoryId: `gabaergic`,
    program: `Anxiety Lane`,
    summary: `Sigma-1/MT anxiolytic class — Afobazole approved in Russia for anxiety; analogs for research.`,
  },

  "grx-917": {
    id: "grx-917",
    name: `GRX-917`,
    fullName: `GRX-917 — deuterated etifoxine analog`,
    categoryId: `gabaergic`,
    program: `Anxiety Lane`,
    summary: `Deuterated etifoxine-style anxiolytic from GRX Therapeutics (formerly GABA Therapeutics). In clinical development for anxiety disorders with TSPO/neurosteroid mechanism.`,
    flagWarning: `Etifoxine/pharma adjacency`,
  },

  "kava-lactone-analogs": {
    id: "kava-lactone-analogs",
    name: `Kava Lactone Analogs`,
    fullName: `Kavalactone (e.g., kavain, dihydrokavain) analog research class`,
    categoryId: `gabaergic`,
    program: `Anxiety Lane`,
    summary: `Botanical anxiolytic research — kavalactones from Piper methysticum with mixed GABA-A modulation.`,
  },

  "krm-ii-81": {
    id: "krm-ii-81",
    name: `KRM-II-81`,
    fullName: `KRM-II-81 (α2/3-selective GABA-A PAM, imidazodiazepine)`,
    categoryId: `gabaergic`,
    program: `Program J / Anxiety`,
    formula: `~C₂₁H₁₈BrN₄O₂ (imidazodiazepine core)`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Imidazodiazepine class — GABA-A PAM mechanism shared with benzodiazepines. Scheduling-trajectory consideration.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — lead α2/3-selective anxiety tool`,
    priorityTier: `Tier 2`,
    summary: `α2/α3-selective GABA-A positive allosteric modulator. Classic benzodiazepines are non-selective across α1-α5 subunits; α1 drives sedation and abuse, α2/α3 drive anxiolysis. KRM-II-81 selectivity produces anxiolytic-like effects preclinically with minimal sedation/motor impairment. Published 2024 review: robust preclinical profile as anxiolytic without BZD baggage.`,
    researchAdvantages: `Subtype-selective — anxiolysis without α1-mediated sedation/abuse | Validated preclinical anxiolytic profile | Strong publishing record from Cook/Witkin labs | Clear 'safer benzodiazepine' positioning for universities`,
    researchConsiderations: `Multi-step synthesis | Imidazodiazepine structural class attracts scheduling attention | Limited human data`,
    evidenceConfidence: `HIGH`,
    aliases: [`MP-III-80 analog`],
    mw: `~454 g/mol`,
    benefitScore: 80,
    harmScore: 25,
    nextSteps: [`IP landscape review (UW/RespireRx)
University partner for SAR extension`],
  },

  "l-theanine-analogs": {
    id: "l-theanine-analogs",
    name: `L-Theanine Analogs`,
    fullName: `L-Theanine-derived low-risk anxiolytic/nootropic research class`,
    categoryId: `gabaergic`,
    program: `Anxiety Lane`,
    summary: `Low-risk anxiolytic/nootropic research — L-theanine derivatives for anxiety reduction and cognitive support.`,
  },

  "pagoclone-like": {
    id: "pagoclone-like",
    name: `Pagoclone-like Compounds`,
    fullName: `Pagoclone and cyclopyrrolone non-benzodiazepine anxiolytic class`,
    categoryId: `gabaergic`,
    program: `Anxiety Lane`,
    summary: `Non-benzo anxiolytic class — cyclopyrrolone scaffold binding at benzodiazepine site with potentially lower abuse profile.`,
    flagWarning: `Z-drug/benzo-site adjacency`,
  },

  "phenibut": {
    id: "phenibut",
    name: `Phenibut`,
    fullName: `β-Phenyl-γ-aminobutyric acid`,
    categoryId: `gabaergic`,
    program: `Program J / Anxiety`,
    cas: `1078-21-3`,
    formula: `C₁₀H₁₃NO₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. FDA has issued warning letters to supplement companies. Significant abuse/dependence potential documented. A few U.S. states have considered scheduling.`,
    status: `Hold — Known Dependence Risk`,
    statusColor: `orange`,
    goDecision: `GO with caveats — research-use only with rigorous dependence characterization`,
    priorityTier: `Tier 3 — Research tool only`,
    summary: `GABA-B agonist + α2δ calcium channel modulator. Clinical drug in Russia since 1960s (Noofen). Anxiolytic, nootropic, sleep-promoting. 40+ years of Russian clinical literature. Dependence syndrome similar to baclofen withdrawal — key cautionary point.`,
    researchAdvantages: `40+ years of Russian clinical use — extensive human data | GABA-B + α2δ mechanism — distinct from benzodiazepines | Simple synthesis | Useful research tool for understanding GABA-B anxiolysis`,
    researchConsiderations: `Documented dependence + withdrawal syndrome | FDA warning letters — regulatory attention | Some state-level scheduling consideration | Low margin of safety vs alcohol (synergistic sedation)`,
    evidenceConfidence: `HIGH`,
    aliases: [`Noofen`, `Fenibut`],
    mw: `179.22 g/mol`,
    benefitScore: 65,
    harmScore: 38,
    nextSteps: [`Dependence characterization study
Reference standard for pharmacology studies`],
  },

  "pregnenolone-analogs": {
    id: "pregnenolone-analogs",
    name: `Pregnenolone Analogs`,
    fullName: `Pregnenolone precursor neurosteroid analog class`,
    categoryId: `gabaergic`,
    program: `Anxiety Lane`,
    summary: `Neurosteroid precursor research — metabolized to allopregnanolone and other active neurosteroids.`,
  },

  "tspo-ligands": {
    id: "tspo-ligands",
    name: `TSPO Ligands`,
    fullName: `Translocator protein (TSPO) 18kDa ligand research class`,
    categoryId: `gabaergic`,
    program: `Anxiety Lane`,
    summary: `Neurosteroidogenesis / anxiety / mood research tools — TSPO is the mitochondrial steroid-synthesis gatekeeper. Etifoxine's mechanism partly TSPO.`,
  },

  "alpha-gaba-pam-library": {
    id: "alpha-gaba-pam-library",
    name: `α2/α3-Selective GABA-A PAM Library`,
    fullName: `α2/α3-selective GABA-A positive allosteric modulator research class`,
    categoryId: `gabaergic`,
    program: `Anxiety Lane`,
    summary: `Key Valium/Xanax replacement research concept — anxiolytic without α1-mediated sedation and dependence. KRM-II-81 is an exemplar.`,
    flagWarning: `Benzodiazepine-mechanism-adjacent`,
  },

  "4-methylpregabalin": {
    id: "4-methylpregabalin",
    name: `4-Methylpregabalin`,
    fullName: `(3S,4R)-3-(Aminomethyl)-4,5-dimethylhexanoic acid`,
    categoryId: `gabapentinoids`,
    program: `Program L — α2δ Calcium-Channel Ligands`,
    cas: `Research compound`,
    formula: `C9H19NO2`,
    schedulingStatus: `Research compound (structural analog of Schedule V pregabalin)`,
    schedulingNote: `Structural analog of pregabalin — Federal Analogue Act scrutiny possible. Verify state and federal status before synthesis or handling.`,
    status: `Research-Needed`,
    statusColor: `orange`,
    goDecision: `CAUTION — analog-act scrutiny + dependence profile`,
    priorityTier: `Tier 3 — SAR reference`,
    summary: `4-Methylpregabalin is a structural SAR analog of pregabalin with additional methyl substitution. Research interest is narrow (α2δ SAR exploration). Analog Act scrutiny and pregabalin-like dependence concerns require careful legal and pharmacological review before any Wohler work.`,
    flagWarning: `Pregabalin analog — Analog Act risk + dependence concern`,
    evidenceConfidence: `LOW`,
    mw: `173.25 g/mol`,
    benefitScore: 58,
    harmScore: 40,
  },

  "atagabalin": {
    id: "atagabalin",
    name: `Atagabalin`,
    fullName: `Atagabalin (PD-200,390)`,
    categoryId: `gabapentinoids`,
    program: `Program L — α2δ Calcium-Channel Ligands`,
    cas: `274691-27-7`,
    formula: `C8H15NO2`,
    schedulingStatus: `Unscheduled (investigational)`,
    schedulingNote: `Investigational compound; not approved or scheduled.`,
    status: `Research-Needed`,
    statusColor: `blue`,
    goDecision: `Research-needed — α2δ SAR analog`,
    priorityTier: `Tier 2 — SAR expansion`,
    summary: `Atagabalin (Pfizer/Parke-Davis PD-200,390) is an investigational α2δ ligand studied for insomnia, anxiety, and pain. Development was discontinued but the compound remains a useful SAR reference. α2δ binding profile similar to pregabalin but with distinct PK.`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`PD-200390`],
    mw: `157.21 g/mol`,
    benefitScore: 62,
    harmScore: 32,
  },

  "gabapentin": {
    id: "gabapentin",
    name: `Gabapentin`,
    fullName: `1-(Aminomethyl)cyclohexaneacetic acid`,
    categoryId: `gabapentinoids`,
    program: `Program L — α2δ Calcium-Channel Ligands`,
    cas: `60142-96-3`,
    formula: `C9H17NO2`,
    schedulingStatus: `unscheduled-federal (state monitoring)`,
    schedulingNote: `Federally unscheduled. Several states (Kentucky, Tennessee, Virginia, Michigan, North Dakota, West Virginia) have classified gabapentin as Schedule V or added it to their prescription monitoring programs. FDA-approved for post-herpetic neuralgia and partial seizures; extensive off-label use for neuropathic pain and anxiety-adjacent conditions.`,
    status: `Reference / Comparator`,
    statusColor: `blue`,
    goDecision: `REFERENCE — baseline α2δ comparator for Wohler Program L`,
    priorityTier: `Reference — α2δ baseline`,
    summary: `Gabapentin is the foundational α2δ-1/α2δ-2 auxiliary calcium-channel ligand. FDA-approved for partial seizures and post-herpetic neuralgia with extensive evidence-base use in neuropathic pain, fibromyalgia, restless legs syndrome, and anxiety. Used by Wohler as the Program L reference compound for all α2δ analog SAR and biomarker studies.`,
    researchAdvantages: `FDA-approved — extensive human safety and efficacy data | Non-opioid, non-benzodiazepine mechanism — valuable harm-reduction framing | Low abuse liability vs pregabalin (despite state-level monitoring) | Renal excretion only (no CYP metabolism) — minimal drug-drug interactions | Simple, scalable manufacturing with standard solvents`,
    researchConsiderations: `Non-linear oral bioavailability (saturable L-amino acid transporter) | Sedation, dizziness, peripheral edema at therapeutic doses | Respiratory depression risk when combined with opioids (2019 FDA warning) | State-level controlled substance status in several jurisdictions | Withdrawal syndrome after chronic dosing`,
    evidenceConfidence: `HIGH`,
    aliases: [`Neurontin`, `Gralise`],
    mw: `171.24 g/mol`,
    benefitScore: 75,
    harmScore: 30,
    nextSteps: [`Maintain 100 g reference stock (USP-grade purchased)
Use as primary comparator in all α2δ analog SAR studies
Benchmark α2δ-1 vs α2δ-2 selectivity of Wohler analogs vs gabapentin`],
  },

  "gabapentin-enacarbil": {
    id: "gabapentin-enacarbil",
    name: `Gabapentin Enacarbil`,
    fullName: `Gabapentin enacarbil (XP13512) — acyloxyalkyl carbamate prodrug of gabapentin`,
    categoryId: `gabapentinoids`,
    program: `Program L — α2δ Calcium-Channel Ligands`,
    cas: `478296-72-9`,
    formula: `C16H27NO6`,
    schedulingStatus: `Unscheduled-federal (Horizant is Rx)`,
    schedulingNote: `FDA-approved (Horizant) for restless legs syndrome and post-herpetic neuralgia. Prescription-only but not scheduled.`,
    status: `Reference — Prodrug`,
    statusColor: `blue`,
    goDecision: `REFERENCE — prodrug strategy exemplar`,
    priorityTier: `Reference — Prodrug design template`,
    summary: `Gabapentin enacarbil (Horizant) is an FDA-approved acyloxyalkyl carbamate prodrug of gabapentin designed to overcome gabapentin's saturable L-amino-acid transporter absorption. Absorbed via high-capacity MCT1 transporter → hydrolyzed to gabapentin. Strong Wohler research interest as a prodrug design template for other α2δ analogs.`,
    flagWarning: `Prodrug — hydrolyzes to gabapentin in vivo`,
    evidenceConfidence: `HIGH`,
    aliases: [`XP13512`, `Horizant`],
    mw: `329.39 g/mol`,
    benefitScore: 68,
    harmScore: 28,
  },

  "imagabalin": {
    id: "imagabalin",
    name: `Imagabalin`,
    fullName: `(3R,5R)-3-Amino-5-methyloctanoic acid (PD-332,334)`,
    categoryId: `gabapentinoids`,
    program: `Program L — α2δ Calcium-Channel Ligands`,
    cas: `487045-56-3`,
    formula: `C9H19NO2`,
    schedulingStatus: `Unscheduled (investigational)`,
    schedulingNote: `Investigational compound; Pfizer Phase 2 for generalized anxiety disorder. Not scheduled.`,
    status: `Research-Needed`,
    statusColor: `blue`,
    goDecision: `Research-needed — GAD/anxiety α2δ candidate`,
    priorityTier: `Tier 2 — Anxiety α2δ`,
    summary: `Imagabalin is an investigational α2δ ligand (Pfizer PD-332,334) studied in Phase 2 for generalized anxiety disorder. Research interest: α2δ-mediated anxiolysis without benzodiazepine-class dependence.`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`PD-332334`],
    mw: `173.25 g/mol`,
    benefitScore: 65,
    harmScore: 32,
  },

  "mirogabalin": {
    id: "mirogabalin",
    name: `Mirogabalin`,
    fullName: `(1R,5S,6S)-6-(Aminomethyl)-3-ethylbicyclo[3.2.0]hept-3-ene-6-carboxylic acid`,
    categoryId: `gabapentinoids`,
    program: `Program L — α2δ Calcium-Channel Ligands`,
    cas: `1138245-13-2`,
    formula: `C12H19NO2`,
    schedulingStatus: `Not scheduled in US (not approved)`,
    schedulingNote: `Approved in Japan (2019, Tarlige) for peripheral neuropathic pain. Not FDA-approved; not currently scheduled in the US.`,
    status: `Priority 2`,
    statusColor: `green`,
    goDecision: `GO — α2δ-1 selective SAR target`,
    priorityTier: `Tier 2 — Active SAR`,
    summary: `Mirogabalin is a newer α2δ ligand (Daiichi Sankyo) with moderate α2δ-1 selectivity (~16× vs α2δ-2) — hypothesis-testing for whether α2δ-1 selectivity preserves analgesia while reducing α2δ-2-driven CNS side effects. Approved in Japan for peripheral neuropathic pain. Key Wohler interest: template for α2δ-1-selective analog design.`,
    researchAdvantages: `α2δ-1 selective (~16×) vs α2δ-2 — reduced sedation hypothesis | Japan-approved with Phase 3 efficacy in diabetic peripheral neuropathic pain | Unscheduled in US — research-access advantage | Bicyclic scaffold provides distinct SAR vs linear gabapentinoids`,
    researchConsiderations: `Complex stereochemistry (3 stereocenters) | Multi-step synthesis with chiral resolution | Limited long-term human safety data vs pregabalin | Still has dose-dependent sedation despite α2δ-1 selectivity`,
    flagWarning: `Approved in Japan only - import research license required`,
    evidenceConfidence: `MEDIUM-HIGH`,
    aliases: [`Tarlige`, `DS-5565`],
    mw: `209.28 g/mol`,
    benefitScore: 72,
    harmScore: 30,
    nextSteps: [`Source mirogabalin reference standard (Japanese supplier or custom synthesis)
Use as α2δ-1 selectivity benchmark for Wohler analog library
Design 20-compound α2δ-1-selective library around bicyclic scaffold`],
  },

  "peripheral-alpha2delta-class": {
    id: "peripheral-alpha2delta-class",
    name: `Peripheral α2δ Ligands`,
    fullName: `Peripherally restricted α2δ calcium-channel ligands (research class)`,
    categoryId: `gabapentinoids`,
    program: `Program L — α2δ Calcium-Channel Ligands`,
    cas: `Research class`,
    formula: `Various`,
    schedulingStatus: `Unscheduled (research class)`,
    schedulingNote: `Research class. BBB-excluded α2δ ligands target peripheral sensory neurons without CNS side effects.`,
    status: `Priority 1 — Target Class`,
    statusColor: `green`,
    goDecision: `GO — peripheral α2δ analgesia program`,
    priorityTier: `Tier 1 — Peripheral α2δ Program`,
    summary: `Peripherally restricted α2δ ligands target nociceptor α2δ subunits in the dorsal root ganglion and peripheral sensory terminals without BBB penetration. Rationale: much of gabapentin/pregabalin's CNS side effects (sedation, ataxia, cognitive slowing) derive from central α2δ binding, while peripheral α2δ binding delivers the analgesic effect. Peripheral restriction (via high polarity or P-gp efflux) decouples efficacy from CNS side effects. Parallels the peripheral KOR strategy (Program D) as a non-controlled, non-CNS-side-effect analgesic class.`,
    researchAdvantages: `Eliminates sedation, ataxia, cognitive slowing of central α2δ binding | Non-controlled, non-opioid, non-benzodiazepine mechanism | Lower abuse liability than pregabalin | Parallels validated peripheral KOR strategy (difelikefalin/Korsuva) | Cleaner safety in elderly and polypharmacy populations`,
    researchConsiderations: `Peripheral restriction (high polarity / P-gp substrate) often hurts oral bioavailability | α2δ is ubiquitously expressed — peripheral selectivity is partial at best | Limited literature precedent vs peripheral KOR | Analgesic efficacy may be more modest than central α2δ ligands`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`Peripheral α2δ`],
    mw: `Various`,
    benefitScore: 72,
    harmScore: 22,
    nextSteps: [`Literature review: identify polar α2δ ligand scaffolds with low logP and high PSA
Design 20-compound library: α2δ-1 + peripheral restriction (MDCK-MDR1, PAMPA assays)
Primary screen: α2δ-1 binding, brain/plasma ratio in rodent
In vivo: SNL neuropathic pain + rotarod (CNS sparing)
Lead candidate: 14-day rat tox + cardiovascular safety
Target indication: non-controlled chronic neuropathic pain`],
  },

  "pregabalin": {
    id: "pregabalin",
    name: `Pregabalin`,
    fullName: `(S)-3-(Aminomethyl)-5-methylhexanoic acid`,
    categoryId: `gabapentinoids`,
    program: `Program L — α2δ Calcium-Channel Ligands`,
    cas: `148553-50-8`,
    formula: `C8H17NO2`,
    schedulingStatus: `Schedule V (US federal)`,
    schedulingNote: `Schedule V CSA. FDA-approved for neuropathic pain, fibromyalgia, partial seizures, generalized anxiety disorder (in EU).`,
    status: `Reference / Comparator`,
    statusColor: `blue`,
    goDecision: `REFERENCE — Schedule V α2δ comparator`,
    priorityTier: `Reference — α2δ baseline (Schedule V)`,
    summary: `Pregabalin is a Schedule V α2δ ligand with 5–10× higher potency than gabapentin and linear oral PK. FDA-approved for neuropathic pain, fibromyalgia, partial seizures, and (EU) generalized anxiety disorder. Schedule V status reflects documented abuse/dependence liability, especially in combination with opioids.`,
    researchAdvantages: `5–10× more potent than gabapentin at α2δ-1/-2 | Linear, predictable oral PK (no saturable absorption) | FDA-approved with extensive clinical data | Stronger anxiety-adjacent efficacy than gabapentin`,
    researchConsiderations: `Schedule V — requires DEA registration, controlled handling | Higher abuse liability than gabapentin | Stronger respiratory depression risk with opioid combinations | Weight gain, edema, sedation more pronounced`,
    flagWarning: `Schedule V - DEA registration required`,
    evidenceConfidence: `HIGH`,
    aliases: [`Lyrica`],
    mw: `159.23 g/mol`,
    benefitScore: 78,
    harmScore: 38,
  },

  "alpha2delta-1-selective-class": {
    id: "alpha2delta-1-selective-class",
    name: `α2δ-1 Selective Ligands`,
    fullName: `α2δ-1 subunit-selective voltage-gated calcium channel ligands (research class)`,
    categoryId: `gabapentinoids`,
    program: `Program L — α2δ Calcium-Channel Ligands`,
    cas: `Research class`,
    formula: `Various`,
    schedulingStatus: `Unscheduled (research class)`,
    schedulingNote: `Research class of α2δ-1-selective compounds. Specific analogs require individual scheduling review.`,
    status: `Priority 1 — Target Class`,
    statusColor: `green`,
    goDecision: `GO — flagship Wohler α2δ-1-selective SAR program`,
    priorityTier: `Tier 1 — α2δ-1 Selective Program`,
    summary: `The α2δ-1 selective ligand class is Wohler's flagship Program L target. Central hypothesis: α2δ-1 binding drives analgesia, while α2δ-2 binding drives sedation/cognitive side effects. Selective α2δ-1 ligands (>50× vs α2δ-2) should provide equivalent analgesic efficacy with reduced sedation, ataxia, and cognitive burden. Mirogabalin is the closest approved example (~16× selectivity) — Wohler targets ≥50× selectivity for next-gen analogs.`,
    researchAdvantages: `Separates analgesia (α2δ-1) from sedation/ataxia (α2δ-2) | Clean mechanism — non-opioid, non-benzodiazepine | Strong IP landscape (mirogabalin validates α2δ-1 selectivity concept) | Phase 3 clinical validation via mirogabalin approval | High university-research appeal (pain, neurology, sensory biology)`,
    researchConsiderations: `SAR for >50× α2δ-1:α2δ-2 selectivity is challenging | Complex stereochemistry often required | Limited long-term safety data for selective analogs | Still dose-dependent sedation observed in mirogabalin despite selectivity`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`α2δ-1 selective`],
    mw: `Various`,
    benefitScore: 78,
    harmScore: 28,
    nextSteps: [`Design 30-compound α2δ-1 selective library using mirogabalin and gabapentin as anchors
Primary screen: α2δ-1 binding (Kd), α2δ-2 counter-screen
Target: ≥50× α2δ-1:α2δ-2 selectivity
In vivo: Spinal nerve ligation (SNL) pain model + rotarod for CNS side effects
Lead candidate advancement to GLP tox and Pre-IND`],
  },

  "18-mc": {
    id: "18-mc",
    name: `18-MC`,
    fullName: `18-Methoxycoronaridine`,
    categoryId: `iboga`,
    program: `Program H`,
    formula: `C₂₂H₂₈N₂O₃`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Derivative of a voacanga alkaloid, distinct from ibogaine itself (Schedule I).`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — strong anti-addiction mechanism`,
    priorityTier: `Tier 2`,
    summary: `Ibogaine analog developed by Glick/Savage as an anti-addiction research compound. Antagonist at α3β4 nicotinic acetylcholine receptor with substantially reduced hallucinogenic and cardiac liabilities vs ibogaine. Has been studied in rodent models for opioid, alcohol, nicotine, and stimulant addictions.`,
    researchAdvantages: `Specific α3β4 nAChR mechanism — clean pharmacology | Substantially reduced cardiac + hallucinogenic liability vs ibogaine | Efficacy across opioid, alcohol, nicotine, cocaine addiction models | Published clinical-scale synthesis routes available`,
    researchConsiderations: `Complex multi-step synthesis from voacanga alkaloid precursors | Limited human clinical data | IP controlled (Savant HWP / MindMed etc.)`,
    evidenceConfidence: `MODERATE`,
    aliases: [`18-Methoxycoronaridine`],
    mw: `368.47 g/mol`,
    benefitScore: 78,
    harmScore: 28,
    nextSteps: [`Literature review on published synthesis
Identify voacanga seed supply chain
IP review`],
  },

  "catharanthine-analogs": {
    id: "catharanthine-analogs",
    name: `Catharanthine Analogs`,
    fullName: `Catharanthine-based iboga-like alkaloid research class`,
    categoryId: `iboga`,
    program: `Program H — Iboga / Non-hallucinogenic Psychoplastogens`,
    cas: `2468-21-5`,
    formula: `C21H24N2O2`,
    schedulingStatus: `Unscheduled research chemical; key precursor to vinblastine/vincristine`,
    schedulingNote: `Catharanthine is unscheduled globally. Commercially available in kg quantities as a vinca-alkaloid synthesis precursor.`,
    status: `Priority 2`,
    statusColor: `green`,
    goDecision: `GO — pharmacophore diversification + commercial availability`,
    priorityTier: `Tier 2 — Pharmacophore Exploration`,
    summary: `Catharanthine is an iboga-like alkaloid from Catharanthus roseus (Madagascar periwinkle). It differs from ibogaine/voacangine primarily in stereochemistry and the position of the indolic nitrogen's alkylation. As a research class, catharanthine analogs test whether the iboga-style pharmacophore can be accessed from a more commercially abundant scaffold without DEA scrutiny.`,
    researchAdvantages: `Commercially available in kg quantities (vinblastine precursor) — no supply constraint | Unscheduled globally — lowest regulatory friction in the iboga family | Different stereochemistry than ibogaine provides a second SAR vector | Well-characterized chemistry from 50+ years of vinca alkaloid research | Potential for α3β4-nAChR selectivity without strong MOR engagement`,
    researchConsiderations: `Significantly weaker KOR/MOR binding than ibogaine | α-methylene-indoline motif is metabolically unstable | Potential genotoxicity concerns inherited from vinblastine/vincristine class | Human pharmacology largely unexplored as a standalone therapeutic`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`Catharanthine`, `Ibogamine-18-carboxylic acid methyl ester (C16 isomer)`],
    mw: 336.43,
    benefitScore: 62,
    harmScore: 32,
    references: [
      { title: `Svoboda G.H. Lloydia 1961, 24, 173 (original isolation)
Glick S.D., Maisonneuve I.M. Ann. N.Y. Acad. Sci. 1998, 844, 214 (iboga-class addiction pharmacology)
Arias H.R. et al. Int. J. Biochem. Cell Biol. 2010, 42, 1525 (nAChR interactions)
Kutney J.P. et al. Heterocycles 1975 (vinblastine biosynthesis/semi-synthesis)
Fagan P. et al. Bioorg. Med. Chem. Lett. 2019 (catharanthine analog SAR)`, url: "" },
    ],
    nextSteps: [`Qualify catharanthine HCl supplier (≥2 kg) for analog campaigns
Design 20-compound amide library exploring nAChR selectivity
Primary screen: α3β4 and α4β2 nAChR FLIPR panel
Counter-screen: MOR/KOR/DAT/SERT
Advance 2 leads to rodent PK and Ames/micronucleus
Compare in vivo addiction model (self-administration) vs 18-MC benchmark`],
  },

  "coronaridine-analogs": {
    id: "coronaridine-analogs",
    name: `Coronaridine Analogs`,
    fullName: `Coronaridine-based iboga addiction-research scaffold (18-MC class)`,
    categoryId: `iboga`,
    program: `Program H — Iboga / Non-hallucinogenic Psychoplastogens`,
    cas: `467-77-6`,
    formula: `C21H26N2O2`,
    schedulingStatus: `Unscheduled research chemical (18-MC is in clinical development)`,
    schedulingNote: `Neither coronaridine nor 18-MC is scheduled federally in the US. 18-MC (Savant HWP / MindMed ibudilast program) has advanced through Phase 1 for addiction indications.`,
    status: `Priority 1`,
    statusColor: `green`,
    goDecision: `GO — lead non-hallucinogenic anti-addiction program`,
    priorityTier: `Tier 1 — Active Research`,
    summary: `Coronaridine and its C18-methoxy derivative 18-methoxycoronaridine (18-MC) represent the most clinically advanced non-hallucinogenic iboga alkaloid scaffold. 18-MC retains ibogaine's anti-addictive efficacy (rat self-administration of cocaine, morphine, nicotine, alcohol) while lacking tremorigenic/cardiotoxic effects. α3β4-nAChR selectivity is the proposed mechanism.`,
    researchAdvantages: `18-MC is α3β4-nAChR-selective (IC50 ~0.75 μM) — clean mechanism vs ibogaine's polypharmacology | No tremor, no cardiac arrhythmia, no hallucinogenic activity in rodent models | Anti-addictive in multiple drug classes (opioids, stimulants, alcohol, nicotine) | Phase 1 human data exists (Savant HWP) — oral bioavailability confirmed | Simple semi-synthesis from voacangine via decarboxylation/methoxylation | Strong IP landscape — broad SAR already published`,
    researchConsiderations: `Modest KOR/MOR activity means no opioid-withdrawal coverage (unlike noribogaine) | Phase 2 efficacy data still pending | α3β4 selectivity can cause GI and ganglionic side-effects at high doses | Metabolism via CYP3A4 — drug-drug interaction risk`,
    evidenceConfidence: `HIGH`,
    aliases: [`Coronaridine`, `18-Methoxycoronaridine (18-MC)`, `Ibogamine-18-carboxylic acid methyl ester`],
    mw: 338.45,
    benefitScore: 82,
    harmScore: 28,
    references: [
      { title: `Glick S.D. et al. Eur. J. Pharmacol. 1996, 308, 95 (18-MC cocaine self-administration)
Glick S.D., Maisonneuve I.M., Szumlinski K.K. Ann. N.Y. Acad. Sci. 2000, 914, 369 (18-MC vs ibogaine review)
Pace C.J. et al. Eur. J. Pharmacol. 2004, 492, 159 (α3β4-nAChR mechanism)
Arias H.R. et al. Biochem. Pharmacol. 2015, 95, 325 (α3β4 selectivity confirmation)
Savant HWP 18-MC Phase 1 Clinical Study Report (2019)`, url: "" },
    ],
    nextSteps: [`Secure 2.0 kg voacangine from internal Wohler Program H campaign
Run bench-scale (50 g) two-step synthesis to lock in yields
Scale to 500 g non-GMP batch for tox studies
Contract GLP 14-day dog tox with ECG telemetry
Prepare Pre-IND package for opioid use disorder indication
Design coronaridine analog library (N1-alkyl, C3-aryl, C18-ester variants) — 30 compounds`],
  },

  "ibogainalog": {
    id: "ibogainalog",
    name: `Ibogainalog`,
    fullName: `Ibogainalog`,
    categoryId: `iboga`,
    program: `Program H`,
    formula: `~C₂₀H₂₆N₂O`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Structurally closer to ibogaine than TBG.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — paired research tool with TBG`,
    priorityTier: `Tier 2`,
    summary: `Related structural analog to TBG with distinct nicotinic receptor pharmacology. PMC11151864 (2024) showed ibogainalog inhibits α7 and α9α10 nicotinic receptors with higher potency than GABAA or calcium channels — directly relevant to nicotine addiction research.`,
    researchAdvantages: `Nicotinic receptor selective inhibition — novel mechanism | Pairs well with TBG for comparative SAR | Unscheduled | Natural-product-inspired scaffold`,
    researchConsiderations: `Lesser-studied than TBG | Multi-step synthesis`,
    evidenceConfidence: `MODERATE`,
    mw: `~310 g/mol`,
    benefitScore: 75,
    harmScore: 22,
    nextSteps: [`Produce as companion to TBG
Nicotine-addiction model research proposal`],
  },

  "psychoplastogen-analogs": {
    id: "psychoplastogen-analogs",
    name: `Non-Hallucinogenic Psychoplastogen Analogs`,
    fullName: `Tabernanthalog (TBG) class — non-hallucinogenic iboga-derived psychoplastogens`,
    categoryId: `iboga`,
    program: `Program H — Iboga / Non-hallucinogenic Psychoplastogens`,
    cas: `2381037-87-2`,
    formula: `C14H18N2O`,
    schedulingStatus: `Unscheduled research chemical (Olson lab / Delix Therapeutics)`,
    schedulingNote: `TBG and the ibogalog class are not scheduled federally or internationally. Delix Therapeutics has Delix-3127 (TBG derivative) in Phase 1.`,
    status: `Priority 1`,
    statusColor: `green`,
    goDecision: `GO — flagship non-hallucinogenic psychoplastogen program`,
    priorityTier: `Tier 1 — Active Research`,
    summary: `Tabernanthalog (TBG) is a structurally simplified ibogaine analog reported by the Olson lab (UC Davis) that retains ibogaine's psychoplastogenic activity (dendritogenesis, spinogenesis, neuroplasticity) while eliminating cardiac arrhythmia risk and hallucinogenic activity. Single-dose efficacy in depression, addiction (alcohol/heroin), and PTSD rodent models. Serves as the template for Wohler's non-hallucinogenic psychoplastogen expansion.`,
    researchAdvantages: `Non-hallucinogenic — eliminates the 5-HT2A perceptual signature while retaining plasticity | Single-dose efficacy in chronic depression, addiction, and PTSD rodent models | No cardiac liability (hERG IC50 >30 μM) — major ibogaine de-risking | Synthetically accessible in 5 steps from commercially available starting materials | TrkB/BDNF activation and mTOR signaling drive dendritic growth | Delix Therapeutics (Olson lab spin-out) has Delix-3127 derivative in Phase 1 — validated translational path | Strong IP — UC Davis patent portfolio licensable/design-around targets`,
    researchConsiderations: `Mechanism of psychoplastogenic activity still being unpacked (5-HT2A partial agonism + TrkB?) | Long-term safety in humans unknown beyond early Phase 1 | Single published primary reference — SAR density still building | Simplified scaffold may have narrower SAR window than ibogaine`,
    evidenceConfidence: `HIGH`,
    aliases: [`Tabernanthalog`, `TBG`, `Ibogalog class`],
    mw: 230.31,
    benefitScore: 85,
    harmScore: 22,
    references: [
      { title: `Cameron L.P. et al. Nature 2021, 589, 474-479 (TBG original disclosure)
Dunlap L.E. et al. J. Med. Chem. 2020, 63, 1142 (isoDMT SAR — Olson lab framework)
Olson D.E. ACS Pharmacol. Transl. Sci. 2021, 4, 563 (psychoplastogen design principles)
Vargas M.V. et al. Science 2023, 379, 700 (5-HT2A intracellular localization drives psychoplasticity)
Delix Therapeutics Delix-3127 IND filing / Phase 1 CSR (2023)`, url: "" },
    ],
    nextSteps: [`File FTO analysis vs UC Davis / Delix patent portfolio
Run 5-step synthesis at 10 g scale to benchmark yields
Scale to 100 g for in vivo proof-of-concept
Rat forced-swim / chronic-mild-stress depression models
Design 25-compound SAR library exploring: N1 substitution, aromatic ring substitution (5-F, 5-OMe, 5-Me), chain length, and C8 substitution
Prioritize 3 lead analogs for GLP tox package
Prepare Pre-IND briefing (treatment-resistant depression indication)`],
  },

  "noribogaine": {
    id: "noribogaine",
    name: `Noribogaine`,
    fullName: `Noribogaine (12-hydroxyibogamine, O-desmethylibogaine)`,
    categoryId: `iboga`,
    program: `Program H — Iboga / Non-hallucinogenic Psychoplastogens`,
    cas: `481-88-9`,
    formula: `C19H24N2O`,
    schedulingStatus: `Research chemical (not FDA-approved; parent ibogaine is Schedule I in US)`,
    schedulingNote: `Noribogaine itself is not explicitly scheduled federally in the US but is controlled as an ibogaine metabolite in several jurisdictions. For research use only — Wohler treats as Schedule I-equivalent.`,
    status: `Priority 1`,
    statusColor: `green`,
    goDecision: `GO — lead anti-addiction / opioid withdrawal candidate`,
    priorityTier: `Tier 1 — Active Research`,
    summary: `Ibogaine's primary CYP2D6-mediated metabolite. Longer plasma half-life (~28-49 h) than ibogaine, reduced hERG/cardiac liability compared to parent, and retains anti-addictive pharmacology. Phase 1/2 human trials (DemeRx IB/NB program) position noribogaine as the most developable iboga alkaloid.`,
    researchAdvantages: `Substantially reduced cardiotoxicity profile vs ibogaine (lower hERG affinity) | Long half-life gives sustained receptor occupancy — useful for opioid withdrawal | G-protein biased kappa-opioid agonism (Maillet 2015) — mood-lifting without dysphoria | Partial MOR agonism helps blunt opioid withdrawal without full reinforcement | SERT inhibition (Ki ~3-4 μM) contributes to antidepressant-like effects | Clinical data from DemeRx supports human safety/tolerability`,
    researchConsiderations: `Still carries some QT prolongation risk at higher doses — ECG monitoring required | Low oral bioavailability of parent ibogaine complicates dosing in microdose studies | Synthesis traditionally relies on CYP2D6 metabolism of ibogaine — total synthesis is long | Limited Phase 2+ data; regulatory path unclear in US | Kappa agonism, even biased, can cause sedation at higher doses`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`12-hydroxyibogamine`, `O-desmethylibogaine`],
    mw: 296.41,
    benefitScore: 78,
    harmScore: 42,
    references: [
      { title: `Antonio T. et al. PLoS One 2013, 8, e77262 (MOR partial agonism, SERT)
Maillet E.L. et al. Neuropharmacology 2015, 99, 675-688 (G-protein biased KOR)
Baumann M.H. et al. J. Pharmacol. Exp. Ther. 2001, 297, 531-539 (in vivo neurochemistry)
Glue P. et al. J. Clin. Pharmacol. 2015, 55, 680-690 (Phase 1 PK/safety in humans)
Glue P. et al. Clin. Pharmacol. Drug Dev. 2016, 5, 460-468 (opioid withdrawal Phase 2)`, url: "" },
    ],
    nextSteps: [`Secure DEA Schedule I registration for research use
Source 5 kg GMP-grade ibogaine HCl from qualified Voacanga supplier
Run bench-scale (50 g) BBr3 → HBr/AcOH comparison to lock in kg route
Develop stability-indicating HPLC method (FDA-compliant)
Contract 28-day rat tox study with ECG telemetry
Prepare Pre-IND briefing document for opioid withdrawal indication`],
  },

  "tabernanthalog": {
    id: "tabernanthalog",
    name: `Tabernanthalog (TBG)`,
    fullName: `Tabernanthalog`,
    categoryId: `iboga`,
    program: `Program H`,
    formula: `C₁₉H₂₄N₂O`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Developed at UC Davis by the Olson lab; published Nature 2021. Active academic investigation.`,
    status: `Strongly Favored`,
    statusColor: `green`,
    goDecision: `GO — lead iboga-scaffold research tool`,
    priorityTier: `Tier 1 — Lead program H candidate`,
    summary: `Non-hallucinogenic ibogaine-inspired analog. Promotes structural and functional neural plasticity in prefrontal cortex similar to ibogaine but without 5-HT2A hallucinogenic activity and without ibogaine's cardiac sodium channel blockade. Strong preclinical addiction + depression data. MDPI IJMS 2025 review: 'scaffold for silent neuroplasticity.'`,
    researchAdvantages: `Non-hallucinogenic — no specialized psychedelic clinical infrastructure needed | No cardiac NaV blockade (vs ibogaine) — major safety advantage | Strong preclinical data: alcohol, heroin-seeking, stress-induced circuit disruption | UC Davis backing — active academic publication pipeline | Unscheduled, novel composition — strong IP opportunity`,
    researchConsiderations: `Multi-step synthesis from indole starting materials | Limited human data — still preclinical | Ibogaine-adjacent branding may attract regulator attention`,
    evidenceConfidence: `HIGH`,
    aliases: [`TBG`],
    mw: `296.41 g/mol`,
    benefitScore: 88,
    harmScore: 18,
    nextSteps: [`License/negotiate with Delix Therapeutics for research-scale supply
UC Davis collaboration
Process development for economical synthesis
Build university research partner list`],
  },

  "voacangine-analogs": {
    id: "voacangine-analogs",
    name: `Voacangine Analogs`,
    fullName: `Voacangine-based iboga alkaloid research class`,
    categoryId: `iboga`,
    program: `Program H — Iboga / Non-hallucinogenic Psychoplastogens`,
    cas: `510-22-5`,
    formula: `C22H28N2O3`,
    schedulingStatus: `Unscheduled research chemical (precursor to ibogaine — watch list in some jurisdictions)`,
    schedulingNote: `Voacangine itself is not a controlled substance in the US, but it is a direct synthetic precursor to ibogaine and is monitored. Possession in kg quantities may raise DEA interest.`,
    status: `Priority 2`,
    statusColor: `green`,
    goDecision: `GO — SAR exploration + ibogaine synthesis precursor`,
    priorityTier: `Tier 2 — Pharmacophore Exploration`,
    summary: `Voacangine is the key biosynthetic precursor to ibogaine (differing only by a C18 carbomethoxy group). As a research class, voacangine analogs probe the role of the C18 ester in receptor binding and metabolism. Decarboxylation of voacangine → ibogaine is the major industrial route to iboga alkaloids from Voacanga africana.`,
    researchAdvantages: `Abundant natural source — Voacanga africana bark is commercially available | C18 ester group enables diverse SAR via hydrolysis/transesterification | Lower CNS penetration than ibogaine — potentially useful for peripheral-only MOR modulation | Key synthetic intermediate for ibogaine, noribogaine, and 18-MC routes | Already used industrially — established purification chemistry`,
    researchConsiderations: `Significantly weaker receptor binding than ibogaine (ester blocks ideal binding geometry) | Watch-list status means regulatory friction even though not formally scheduled | Limited human data — most work is on rodent PK and the decarboxylation chemistry | C18 ester is metabolically labile — short in vivo half-life`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`Voacangine`, `12-methoxyibogamine-18-carboxylic acid methyl ester`],
    mw: 368.47,
    benefitScore: 64,
    harmScore: 35,
    references: [
      { title: `Kingsbury W.L. et al. Phytochemistry 1966 (isolation from Voacanga)
Büchi G. et al. J. Am. Chem. Soc. 1966, 88, 3099 (first total synthesis)
Jenks C.W. Nat. Prod. Lett. 2002 (Voacanga africana pharmacognosy)
Paterna A. et al. J. Nat. Prod. 2016 (MDR-reversing voacangine analogs)
Kuehne M.E. et al. J. Org. Chem. 1988 (ibogamine class synthesis)`, url: "" },
    ],
    nextSteps: [`Qualify Voacanga africana bark supplier (West African botanical sourcing, sustainable harvest certification)
Develop HPLC assay for bark voacangine content as intake QC
Run pilot 10 kg bark extraction to validate yield model
Build SAR library: C18 ester → amide/alcohol/oxadiazole replacements (20 analogs)
Screen library at MOR/KOR/nAChR/SERT panel
Advance 2-3 lead analogs to rodent PK`],
  },

  "7-oh-mitragynine": {
    id: "7-oh-mitragynine",
    name: `7-OH-Mitragynine`,
    fullName: `7-Hydroxymitragynine`,
    categoryId: `mitragynine`,
    program: `Program A — Kratom / Harm Reduction`,
    cas: `174418-82-7`,
    formula: `C₂₃H₃₀N₂O₅`,
    schedulingStatus: `monitor`,
    schedulingNote: `Federal scheduling under active FDA/DEA review as of 2025. Several U.S. states (e.g., WV, IN) have moved to restrict 7-OH kratom products. Watch-only posture — confirm with regulatory counsel monthly. Not currently federally scheduled but high scheduling risk.`,
    status: `HOLD`,
    statusColor: `red`,
    goDecision: `HOLD — high scheduling risk. Watch-only / pseudoreference compound.`,
    priorityTier: `Watch`,
    summary: `7-OH-Mitragynine is the oxidized active metabolite of mitragynine and the most potent kratom-derived mu-opioid agonist known (~10–13× morphine at MOR in vitro). It is the primary driver of kratom's opioid-like pharmacology in humans. High scheduling risk in 2025–2026 — FDA/DEA have flagged 7-OH-dominant kratom products as a public-health concern. Kept as a reference/research tool only.`,
    researchAdvantages: `Most potent naturally-occurring kratom alkaloid at MOR | Essential pharmacological reference for Program A analog SAR | Well-characterized in published receptor-binding studies (Kruegel 2016)`,
    researchConsiderations: `High abuse liability — closest kratom compound to classical opioid pharmacology | Rapidly advancing federal & state scheduling risk | FDA has specifically flagged 7-OH-dominant products as a safety concern`,
    evidenceConfidence: `HIGH`,
    aliases: [`7-OH`, `7-OHMG`],
    mw: `414.50 g/mol`,
    benefitScore: 70,
    harmScore: 55,
    nextSteps: [`Monitor FDA/DEA regulatory status monthly
Build citation library from Kruegel, Váradi, Hiranita
Document oxidation procedure from mitragynine (OsO4 / m-CPBA route)
Decision gate: keep as watch-only or drop from program`],
  },

  "corynantheidine": {
    id: "corynantheidine",
    name: `Corynantheidine`,
    fullName: `Corynantheidine — kratom alkaloid, MOR antagonist-like`,
    categoryId: `mitragynine`,
    program: `Program A — Kratom / Harm Reduction`,
    cas: `6874-98-0`,
    formula: `C22H28N2O3`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled US federal. Natural kratom alkaloid; parent for MGM-family analogs including 9-fluorocorynantheidine.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — reported MOR antagonist-like activity and 7R configuration; useful for mitragynine-class SAR anchor and as potential OUD research tool.`,
    priorityTier: `Tier 2`,
    summary: `Corynantheidine is a kratom alkaloid with opposite C7 stereochemistry to mitragynine. Reported low-efficacy MOR activity / antagonist-like profile — candidate parent for OUD research and basis for the fluorinated corynantheidine family (e.g., 9-F-corynantheidine).`,
    researchAdvantages: `MOR antagonist-like activity — OUD research angle | Natural kratom alkaloid — established extraction chemistry | SAR parent for 9-F-corynantheidine family`,
    researchConsiderations: `Minor alkaloid — low isolated yield from leaf | Incomplete in-vivo OUD data`,
    evidenceConfidence: `MEDIUM`,
    mw: `368.47 g/mol`,
    benefitScore: 68,
    harmScore: 18,
    references: [
      { title: `Kruegel A.C. et al. JACS 2016, 138(21), 6754–6764.
10.1021/jacs.6b00360
Obeng S. et al. ACS Chem. Neurosci. 2020, 11(20), 3428–3443.`, url: "" },
    ],
    nextSteps: [`Confirm antagonist behavior vs DAMGO in Wohler MOR cAMP assay
Morphine-precipitated withdrawal OUD model (mouse)
Parent for 9-F-corynantheidine semi-synthesis
X-ray / ECD confirmation of C7 stereochemistry`],
  },

  "corynoxine-a": {
    id: "corynoxine-a",
    name: `Corynoxine A`,
    fullName: `Corynoxine A — kratom oxindole; autophagy inducer`,
    categoryId: `mitragynine`,
    program: `Program A — Kratom / Harm Reduction`,
    cas: `6877-32-3`,
    formula: `C22H28N2O4`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled US federal. Natural kratom oxindole alkaloid; lower opioid similarity.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — published autophagy-induction and Parkinson's-adjacent neuroprotection data make this a low-harm, high-differentiation program K candidate.`,
    priorityTier: `Tier 2`,
    summary: `Corynoxine A is an oxindole alkaloid from Mitragyna and Uncaria species. Published as an autophagy enhancer (mTOR-independent pathway) with in-vitro and in-vivo Parkinson's disease models showing protection of dopaminergic neurons. Low opioid receptor affinity, distinct mechanism from mitragynine — highest-differentiation kratom-class candidate.`,
    researchAdvantages: `Autophagy-induction mechanism — Parkinson's, Alzheimer's, proteinopathy angles | Low opioid activity — avoids kratom-class regulatory pressure | Published in-vivo neuroprotection (MPTP, 6-OHDA mouse models) | Natural alkaloid — low IP contest risk`,
    researchConsiderations: `Minor alkaloid — low extraction yield | Mechanism-to-disease translation still early`,
    evidenceConfidence: `MEDIUM`,
    mw: `384.47 g/mol`,
    benefitScore: 70,
    harmScore: 14,
    references: [
      { title: `Chen L.L. et al. Corynoxine, a natural autophagy enhancer, promotes the clearance of alpha-synuclein via Akt/mTOR pathway. J. Neuroimmune Pharmacol. 2014, 9(3), 380–387.
10.1007/s11481-014-9528-2
Obeng S. et al. ACS Chem. Neurosci. 2020, 11(20), 3428–3443.`, url: "" },
    ],
    nextSteps: [`In-house autophagy flux assay (LC3-II western, mCherry-LC3 imaging)
α-synuclein clearance dose-response
Rat PK (oral bioavailability — oxindole lipophilicity favorable)
6-OHDA rat PD model confirmation`],
  },

  "fluorocorynantheidine-analogs": {
    id: "fluorocorynantheidine-analogs",
    name: `Fluorocorynantheidine Analogs`,
    fullName: `9-Fluoro-corynantheidine and congeners — MGM-family extension`,
    categoryId: `mitragynine`,
    program: `Program A — Kratom / Harm Reduction`,
    formula: `Class: C22H27FN2O3`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled US federal; mitragynine-class Analogue-Act exposure.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — fluorination extends metabolic half-life of corynantheidine; logical chemical-space expansion.`,
    priorityTier: `Tier 3`,
    summary: `9-Fluoro-corynantheidine and analogs extend the corynantheidine C7-epimer series with fluorine substitution for metabolic stability. Internal Wohler extension of the 7-OH / 9-F MGM program to the opposite stereochemistry — generates SAR anchor for biased MOR antagonist/low-efficacy partial agonist research.`,
    researchAdvantages: `Chemical-space expansion of MGM-family with differentiated stereochemistry | Fluorination improves PK over unfluorinated corynantheidine | Leverages existing Wohler mitragynine semi-synthesis infrastructure`,
    researchConsiderations: `Pharmacology not yet published — internal hypothesis-driven | Minor-alkaloid starting material supply | Class scheduling exposure`,
    evidenceConfidence: `LOW-MEDIUM`,
    mw: `~386 g/mol`,
    benefitScore: 70,
    harmScore: 30,
    references: [
      { title: `Obeng S. et al. ACS Chem. Neurosci. 2020, 11(20), 3428–3443.
Chakraborty S. et al. J. Med. Chem. 2021, 64(18), 13873–13892.
10.1021/acs.jmedchem.1c01273`, url: "" },
    ],
    nextSteps: [`Pilot 10 g synthesis from isolated corynantheidine
MOR/KOR/DOR Ki panel
Rat oral PK vs unfluorinated parent
Hot-plate antinociception dose-response`],
  },

  "mgm-15": {
    id: "mgm-15",
    name: `MGM-15`,
    fullName: `7-Hydroxymitragynine analog (Chakraborty 2021) — fluorinated C9-OMe variant`,
    categoryId: `mitragynine`,
    program: `Program A — Kratom / Harm Reduction`,
    formula: `C23H30FN2O5 (reported class composition)`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled US federal as of 2026. Ohio Board of Pharmacy placed mitragynine-related compounds including 7-OH-mitragynine into Schedule I state list (2024–2025) — precedent for other mitragynine analogs. International: New Zealand Schedule I; some EU states restrict.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — structural class with published mu-biased partial agonism + improved therapeutic index vs 7-OH.`,
    priorityTier: `Tier 2`,
    summary: `MGM-15 is a fluorinated 7-hydroxymitragynine analog from the Chakraborty/Majumdar 2021 J. Med. Chem. series, designed as a low-efficacy mu-opioid receptor partial agonist with attenuated respiratory depression, constipation, and reward-liability profile vs morphine or 7-OH-MG. In vivo mouse antinociception comparable to morphine at equi-analgesic doses with reduced tolerance and physical dependence signals.`,
    researchAdvantages: `Low-efficacy mu-opioid partial agonist — ceiling effect on respiratory depression | Oral bioavailability retained (kratom-scaffold lipophilicity favorable) | Published attenuated-tolerance signal | Fluorine adds metabolic stability + modest potency gain`,
    researchConsiderations: `State-level scheduling pressure (Ohio precedent) on mitragynine-class | Stereochemistry 7R/7S — requires enantioselective synthesis or late-stage resolution | Partial agonism carries naloxone-refractoriness questions at high dose`,
    evidenceConfidence: `MEDIUM`,
    mw: `~451 g/mol (class)`,
    benefitScore: 72,
    harmScore: 36,
    references: [
      { title: `Chakraborty S., Uprety R., Daibani A.E., et al. A Novel Mitragynine Analog with Low-Efficacy Mu Opioid Receptor Agonism Displays Antinociception with Attenuated Adverse Effects. J. Med. Chem. 2021, 64(18), 13873–13892.
10.1021/acs.jmedchem.1c01273
Kruegel A.C. et al. JACS 2016, 138(21), 6754–6764.
10.1021/jacs.6b00360
Obeng S. et al. ACS Chem. Neurosci. 2020, 11(20), 3428–3443.`, url: "" },
    ],
    nextSteps: [`In-house MOR/KOR/DOR Ki + cAMP inhibition panel
β-arrestin-2 bias factor quantification (BRET or Tango)
Rat oral PK + hot-plate antinociception
Whole-body plethysmography for respiratory depression assessment`],
  },

  "mgm-16": {
    id: "mgm-16",
    name: `MGM-16`,
    fullName: `9-Fluoro-7-hydroxymitragynine stereoisomer (Chakraborty 2021 companion)`,
    categoryId: `mitragynine`,
    program: `Program A — Kratom / Harm Reduction`,
    formula: `C23H30FN2O5`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Same as MGM-15 (mitragynine-class).`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — companion diastereomer to MGM-15; used as comparator in Chakraborty SAR.`,
    priorityTier: `Tier 2`,
    summary: `MGM-16 is the stereochemical partner to MGM-15 from the Chakraborty 2021 series, with modest potency differences reflecting 7R vs 7S configuration. Both serve as benchmarks for low-efficacy mu-agonist / harm-reduction opioid research.`,
    researchAdvantages: `Comparator diastereomer for SAR — validates MGM-15 pharmacophore | Chemo-divergent synthesis accessible from same intermediate | Inherits MGM-15 biased-agonism profile with lower potency`,
    researchConsiderations: `Lower potency vs MGM-15 — less attractive lead | Same scheduling/analog risk`,
    evidenceConfidence: `MEDIUM`,
    mw: `~451 g/mol`,
    benefitScore: 70,
    harmScore: 34,
    references: [
      { title: `Chakraborty S. et al. J. Med. Chem. 2021, 64(18), 13873–13892.
10.1021/acs.jmedchem.1c01273`, url: "" },
    ],
    nextSteps: [`SAR bridge study vs MGM-15 on Wohler batch
Stereochemistry confirmation by X-ray
Same downstream in-vivo as MGM-15 if mechanism holds`],
  },

  "mgm-9": {
    id: "mgm-9",
    name: `MGM-9`,
    fullName: `7,9-Difluoromitragynine (10-fluoro-mitragynine pseudoindoxyl scaffold variant)`,
    categoryId: `mitragynine`,
    program: `Program A / D`,
    formula: `C₂₃H₂₉FN₂O₄ (per proposed structure)`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled as of 2026. Mitragynine itself is not federally scheduled. State scheduling varies significantly for kratom/mitragynine compounds — verify per state. Given the high MOR potency of MGM-9 and its structural relationship to scheduled opioids, this compound is flagged Very High analog/enforcement concern. University-institutional research-only posture is mandatory.`,
    status: `Hold — Institutional Only`,
    statusColor: `orange`,
    goDecision: `HOLD — pending legal memo and university/CRO partner identification`,
    priorityTier: `Tier 1 — Lead novel compound (but institutional-only)`,
    summary: `MGM-9 is a fluorinated mitragynine derivative generated via a Wohler Chemical one-pot oxidative/fluorination process using PIFA and Selectfluor. Preliminary pharmacology indicates potent mu-opioid receptor (MOR) activity with kappa-opioid receptor (KOR) involvement. Designed as a research probe for biased-opioid receptor pharmacology and fentanyl-harm-reduction research. Wohler internal process development has achieved ≈70 % purity at 10-g scale; the current program is finalizing chromatographic separation and crystallization.`,
    researchAdvantages: `Potent opioid-receptor ligand with kratom-scaffold origin — clean 'natural product research' narrative | Wohler Chemical has proprietary process knowledge (one-pot PIFA/Selectfluor protocol) | Relevant to fentanyl-harm-reduction research: G-protein biased signaling hypothesis | Scalable synthesis validated through 10-g campaign (Acosta & Yeh, 2026) | Strong university research value for biased-MOR pharmacology programs`,
    researchConsiderations: `High potency at MOR → enforcement scrutiny and diversion risk | Fluorinated opioid analog → emergency scheduling risk similar to 2-FDCK (scheduled Jan 2026) | Requires tight institutional control — not a general research-use compound | PIFA (iodine(III) oxidant) is a thermal-shock-sensitive reagent — kg scale requires engineering controls | Selectfluor requires dry/controlled conditions; exotherm management critical`,
    evidenceConfidence: `MODERATE`,
    aliases: [`Difluoromitragynine (Wohler internal)`],
    mw: `≈ 420 g/mol`,
    benefitScore: 86,
    harmScore: 48,
    nextSteps: [`File provisional patent on MGM-9 composition + one-pot process
Commission formal MOR/KOR/DOR/NOP functional pharmacology at Frontier Sciences or equivalent CRO
Run in vivo antinociception + respiratory-depression comparator study (vs morphine, vs mitragynine)
Draft university partner package (IRB/IACUC-ready)
Finalize ICH-grade crystal form characterization
Conduct legal memo re: federal analog/enforcement risk`],
  },

  "mitragynine": {
    id: "mitragynine",
    name: `Mitragynine`,
    fullName: `Mitragynine (primary kratom alkaloid)`,
    categoryId: `mitragynine`,
    program: `Program A`,
    cas: `4098-40-2`,
    formula: `C₂₃H₃₀N₂O₄`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled (DEA). DEA scheduling attempt withdrawn 2016. Several U.S. states have independent scheduling (AL, AR, IN, RI, VT, WI, TN partial). FDA has issued import alerts and warning letters.`,
    status: `Strongly Favored`,
    statusColor: `green`,
    goDecision: `GO — research-grade standard production`,
    priorityTier: `Tier 1 — Near-term revenue generator`,
    summary: `Primary alkaloid of Mitragyna speciosa (kratom) — ~66 % of total alkaloid content. Biased partial MOR agonist: activates G-protein pathways (analgesic, anti-withdrawal) with reduced β-arrestin recruitment vs. morphine. Reduced respiratory depression is a key public-health research angle. Producing standardized research-grade mitragynine fills a real CRO/university supply gap.`,
    researchAdvantages: `Biased MOR agonism — G-protein > β-arrestin = reduced respiratory depression | Used by millions as a de facto harm-reduction tool for OUD and chronic pain | Strong public-health research narrative for fentanyl-harm reduction | Published 2024 Frontiers in Public Health paper supports harm-reduction framing | Wohler Chemical already has kratom processing expertise`,
    researchConsiderations: `State-level scheduling variability — compliance complexity | Semi-total synthesis complex; practical path is isolation from kratom extract | Dependence potential documented | Public/political controversy around kratom`,
    evidenceConfidence: `HIGH`,
    aliases: [`9-Methoxycorynantheidine`],
    mw: `398.50 g/mol`,
    benefitScore: 80,
    harmScore: 32,
    nextSteps: [`Produce 5 kg USP-grade reference standard
Issue COA with NMR, HRMS, HPLC, residual solvents, and chiral purity
Establish CRO distribution pipeline with 5+ university customers
File method patent on SMB chromatographic isolation process`],
  },

  "mitragynine-ester-analogs": {
    id: "mitragynine-ester-analogs",
    name: `Mitragynine Ester Analogs`,
    fullName: `C16 ester SAR class — mitragynine PK/potency modulation`,
    categoryId: `mitragynine`,
    program: `Program A — Kratom / Harm Reduction`,
    formula: `Variable (ester chain)`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled US federal; mitragynine-class Analogue-Act exposure.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — ester SAR class enables prodrug/PK modulation and oral bioavailability tuning.`,
    priorityTier: `Tier 3`,
    summary: `Mitragynine contains a C16 methyl ester that is a site for PK/potency modulation. Replacing methyl with longer-chain, branched, or hetero-ester groups tunes oral bioavailability, plasma half-life, and MOR potency. Class gives access to prodrug strategies and improved drug-likeness.`,
    researchAdvantages: `Single-step synthesis from mitragynine via transesterification | Enables prodrug or PK-extension strategies | SAR class with well-defined MOR SAR anchor (mitragynine)`,
    researchConsiderations: `Ester hydrolysis to parent mitragynine limits true differentiation for some analogs | Plasma esterase variability across species complicates translation | Class scheduling pressure`,
    evidenceConfidence: `LOW-MEDIUM`,
    mw: `Variable`,
    benefitScore: 66,
    harmScore: 28,
    references: [
      { title: `Kruegel A.C. et al. JACS 2016, 138(21), 6754–6764.
10.1021/jacs.6b00360`, url: "" },
    ],
    nextSteps: [`Design 6-compound ester SAR set (Me / Et / iPr / nBu / CH2CF3 / Ph)
In-vitro plasma hydrolysis rate (human / rat / mouse)
MOR potency panel on each ester
Rat oral PK on lead ester(s)`],
  },

  "mitragynine-oxindole-analogs": {
    id: "mitragynine-oxindole-analogs",
    name: `Mitragynine Oxindole Analogs`,
    fullName: `Mitragynine pseudoindoxyl and related oxindole SAR class`,
    categoryId: `mitragynine`,
    program: `Program A — Kratom / Harm Reduction`,
    formula: `C23H28N2O5 (parent pseudoindoxyl)`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled US federal; mitragynine-class Analogue-Act exposure.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — includes mitragynine pseudoindoxyl (Váradi 2016) as the flagship of this series — best-studied biased MOR kratom-class analgesic.`,
    priorityTier: `Tier 2`,
    summary: `Mitragynine-pseudoindoxyl and its congeners are oxidative rearrangement products of mitragynine with marked pharmacology shifts — MOR agonism + DOR antagonism profile (Váradi 2016) associated with potent analgesia and reduced respiratory depression, reward, and physical dependence in mice. SAR class fundamental to the biased-MOR kratom thesis.`,
    researchAdvantages: `Flagship mitragynine pseudoindoxyl is published biased MOR / DOR antagonist with attenuated adverse-effect profile | Rich SAR around the oxindole core (Váradi, Uprety, Chakraborty series) | Semi-synthesis from mitragynine feasible at scale`,
    researchConsiderations: `Pseudoindoxyl stereochemistry and atropisomerism complicate purification | DOR antagonism may interact with tolerance pharmacology in complex ways | Class under emerging scheduling pressure`,
    evidenceConfidence: `MEDIUM`,
    mw: `428 g/mol (class)`,
    benefitScore: 72,
    harmScore: 28,
    references: [
      { title: `Váradi A., Marrone G.F., Palmer T.C., et al. Mitragynine/Corynantheidine Pseudoindoxyls as Opioid Analgesics with Mu Agonism and Delta Antagonism. J. Med. Chem. 2016, 59(18), 8381–8397.
10.1021/acs.jmedchem.6b00748
Chakraborty S. et al. J. Med. Chem. 2021, 64(18), 13873–13892.
10.1021/acs.jmedchem.1c01273`, url: "" },
    ],
    nextSteps: [`In-house MOR/DOR/KOR Ki + functional bias panel
Respiratory depression WBP confirmation
Chronic tolerance + physical-dependence assessment
Atropisomer separation by SFC`],
  },

  "mitragynine-pseudoindoxyl": {
    id: "mitragynine-pseudoindoxyl",
    name: `Mitragynine Pseudoindoxyl (MGP)`,
    fullName: `Mitragynine pseudoindoxyl — 9-hydroxycorynantheidine pseudoindoxyl`,
    categoryId: `mitragynine`,
    program: `Program A / D`,
    formula: `C₂₃H₃₀N₂O₅`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled as of 2026. Very high scrutiny — potent MOR ligand derived from kratom metabolism. Institutional-only posture mandatory.`,
    status: `Hold — Institutional Only`,
    statusColor: `orange`,
    goDecision: `HOLD / Conditional GO — with university partner + legal memo`,
    priorityTier: `Tier 1 — Highest-impact aspirational`,
    summary: `A metabolic product of mitragynine and 7-hydroxymitragynine. High MOR affinity; biased signaling with reduced β-arrestin recruitment. ≈ 20× more potent than morphine in antinociceptive assays with substantially reduced respiratory depression in mouse models. Complete synthesis route published in 2023 (Chakraborty et al.). Potentially the highest-impact single compound in the kratom space.`,
    researchAdvantages: `≈ 20× more potent than morphine with reduced respiratory depression in preclinical models | Natural-product origin — from kratom metabolism | Complete total synthesis route published 2023 | Addresses the single biggest unmet need in pain/OUD research | Publishable, patentable method/formulation space`,
    researchConsiderations: `Very high enforcement/analog scrutiny — potent MOR agonist | Synthesis complexity — multi-step total synthesis required | Limited in vivo safety data at scale`,
    evidenceConfidence: `HIGH`,
    aliases: [`MGP`, `Mitragynine Pseudoindoxyl`],
    mw: `414.50 g/mol`,
    benefitScore: 90,
    harmScore: 45,
    nextSteps: [`Literature-review of 2023 synthesis supplementary materials
Partner with university lab (Kruegel/Majumdar collaborators) for first 1-g synthesis
File process improvement patents
Proceed only with IRB-registered research partner in place`],
  },

  "paynantheine": {
    id: "paynantheine",
    name: `Paynantheine`,
    fullName: `Paynantheine — kratom minor alkaloid`,
    categoryId: `mitragynine`,
    program: `Program A — Kratom / Harm Reduction`,
    cas: `4382-55-0`,
    formula: `C23H28N2O4`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled US federal. Natural kratom alkaloid.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — well-characterized minor kratom alkaloid; smooth-muscle relaxant and opioid-system research.`,
    priorityTier: `Tier 3`,
    summary: `Paynantheine is the second-most-abundant alkaloid in Mitragyna speciosa leaf (after mitragynine). Smooth-muscle relaxant activity (GI, tracheal) is its best-characterized pharmacology. Opioid-receptor affinity is markedly lower than mitragynine. Useful as standardization reference and for GI/antispasmodic research.`,
    researchAdvantages: `Natural kratom alkaloid — low regulatory novelty | Smooth-muscle relaxant profile — anti-spasmodic research angle | Low opioid-receptor affinity reduces abuse-liability concern`,
    researchConsiderations: `Weak/unclear analgesic activity | Minor alkaloid — supply via extraction has low isolated yield`,
    evidenceConfidence: `MEDIUM`,
    mw: `396.48 g/mol`,
    benefitScore: 62,
    harmScore: 18,
    references: [
      { title: `Obeng S. et al. ACS Chem. Neurosci. 2020, 11(20), 3428–3443.
León F. et al. Phytochem. Anal. 2009, 20, 509–515.`, url: "" },
    ],
    nextSteps: [`MOR/KOR/DOR binding panel on Wohler isolate
Smooth-muscle bioassay (isolated guinea-pig ileum)
Analytical reference standard qualification (HPLC, NMR, MS)`],
  },

  "sc13": {
    id: "sc13",
    name: `SC13`,
    fullName: `Kratom-analog biased MOR agonist (Uprety/Majumdar eLife 2021)`,
    categoryId: `mitragynine`,
    program: `Program A — Kratom / Harm Reduction`,
    formula: `TBD (mitragynine pseudoindoxyl-class)`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled US federal. Mitragynine-class Analogue-Act exposure.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — SC13 published as G-protein-biased MOR agonist with strong antinociception and attenuated respiratory depression in mice.`,
    priorityTier: `Tier 2`,
    summary: `SC13 is a kratom-analog G-protein-biased MOR agonist from the Uprety/Majumdar 2021 eLife paper (Controlling Opioid Receptor Functional Selectivity). It achieves morphine-equivalent antinociception in mice with markedly attenuated respiratory depression (whole-body plethysmography) and reward (conditioned place preference). A leading candidate for the safer-opioid research program.`,
    researchAdvantages: `Published morphine-equivalent analgesia with reduced respiratory depression (Uprety 2021) | G-protein bias validated by β-arrestin-2 Tango + BRET assays | Reduced CPP (reward) signal in mice | Oral bioavailability retained`,
    researchConsiderations: `Schedule/Analogue-Act exposure (kratom-class) | Single-digit mg/kg active dose in mice — potency translates to tight dosing window | Chronic tolerance data limited`,
    evidenceConfidence: `MEDIUM`,
    mw: `TBD`,
    benefitScore: 74,
    harmScore: 30,
    references: [
      { title: `Uprety R., Che T., Zaidi S.A., et al. Controlling Opioid Receptor Functional Selectivity by Targeting Distinct Subpockets of the Orthosteric Site. eLife 2021, 10:e56519.
10.7554/eLife.56519
Kruegel A.C. et al. JACS 2016, 138(21), 6754–6764.
10.1021/jacs.6b00360
Váradi A. et al. J. Med. Chem. 2016, 59(18), 8381–8397.
10.1021/acs.jmedchem.6b00748`, url: "" },
    ],
    nextSteps: [`Reproduce Uprety 2021 WBP respiratory-depression study in Wohler CRO
Chronic-tolerance and physical-dependence assessment (28-day rat)
Oral rat PK (bioavailability, plasma + brain)
Freedom-to-operate IP review`],
  },

  "speciociliatine": {
    id: "speciociliatine",
    name: `Speciociliatine`,
    fullName: `Speciociliatine — (stereoisomer of mitragynine)`,
    categoryId: `mitragynine`,
    program: `Program A`,
    formula: `C₂₃H₃₀N₂O₄`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — excellent comparative research tool`,
    priorityTier: `Tier 2`,
    summary: `Minor kratom alkaloid (~1 % content) and a stereoisomer of mitragynine. WashU research identifies speciociliatine as a MORE mu-selective opioid agonist than mitragynine — and notably less functionally biased. The mitragynine-vs-speciociliatine comparison is an ideal scientific tool for studying the relationship between functional bias and respiratory safety.`,
    researchAdvantages: `Direct scientific comparator to mitragynine for bias-vs-safety research | Higher MOR selectivity — cleaner pharmacology | Natural product — strong research narrative | Emerging WashU/academic interest creates publication pull`,
    researchConsiderations: `Low natural abundance (~1 %) — semi-synthesis via epimerization may be needed | Less biased = potentially higher respiratory depression than mitragynine`,
    evidenceConfidence: `MODERATE`,
    mw: `398.50 g/mol`,
    benefitScore: 75,
    harmScore: 30,
    nextSteps: [`Produce 100-g reference standard
Publish comparison study with WashU collaborators`],
  },

  "speciogynine": {
    id: "speciogynine",
    name: `Speciogynine`,
    fullName: `Speciogynine`,
    categoryId: `mitragynine`,
    program: `Program A`,
    formula: `C₂₃H₃₀N₂O₄`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — kratom pharmacology deconvolution tool`,
    priorityTier: `Tier 2`,
    summary: `Minor kratom alkaloid (~7 % content). Mu-opioid antagonist with partial agonism at kappa and delta opioid receptors. Functions as a multi-receptor opioid modulator. May contribute to kratom's 'ceiling effect' — a key property underlying harm-reduction claims.`,
    researchAdvantages: `Multi-receptor opioid modulation — scientifically unique research probe | Contributes to kratom's characteristic ceiling effect (harm-reduction property) | Natural kratom alkaloid at meaningful abundance (~7 %) | Lower abuse liability than full MOR agonists`,
    researchConsiderations: `Moderate natural abundance limits isolation yield | Complex pharmacology requires careful assay design`,
    evidenceConfidence: `MODERATE`,
    mw: `398.50 g/mol`,
    benefitScore: 72,
    harmScore: 25,
    nextSteps: [`100-g reference standard
WashU comparative receptor-function study`],
  },

  "brorphine-warning-class": {
    id: "brorphine-warning-class",
    name: `Brorphine Warning Class`,
    fullName: `Brorphine and benzimidazolone nitazene-adjacent opioids — regulatory warning class`,
    categoryId: `opioid`,
    program: `Program D — Biased MOR / Safer Opioid`,
    cas: `2244737-98-0`,
    formula: `C21H24BrN3O`,
    schedulingStatus: `Schedule I (US) — emergency scheduled 2020, permanent 2023`,
    schedulingNote: `Brorphine is Schedule I in the US, UK, and multiple EU states. Wohler tracks this class as a REGULATORY WARNING and DO-NOT-SYNTHESIZE example — NOT a development target.`,
    status: `DO-NOT-DEVELOP — Regulatory Warning`,
    statusColor: `red`,
    goDecision: `NO-GO — regulatory and safety contraindication`,
    priorityTier: `Regulatory Awareness — Avoid`,
    summary: `Brorphine and structurally related benzimidazolone (and broader nitazene-adjacent) opioids are potent full MOR agonists with fentanyl-class overdose potential. First identified as a recreational adulterant 2019-2020, brorphine was emergency-scheduled in the US in 2020 and associated with multiple fatal overdoses. Wohler maintains this entry as a REGULATORY AWARENESS record — the structural class is documented here so that Program D SAR explicitly designs AWAY from it.`,
    researchAdvantages: `None — this is a DO-NOT-SYNTHESIZE regulatory-awareness entry`,
    researchConsiderations: `Full high-efficacy MOR agonism — extreme respiratory depression risk | Fentanyl-class potency (ED50 ~0.05 mg/kg mouse) | No β-arrestin bias — worst-case safety profile | Schedule I in US, UK, EU — criminal liability for possession/synthesis | Associated with >30 confirmed overdose deaths 2019-2021 | No therapeutic rationale — emerged as novel psychoactive substance (NPS)`,
    evidenceConfidence: `HIGH`,
    aliases: [`Brorphine`, `Benzimidazolone opioids`],
    mw: 414.34,
    benefitScore: 8,
    harmScore: 96,
    references: [
      { title: `DEA Final Rule: Placement of Brorphine in Schedule I (2023)
Vandeputte M.M. et al. Drug Test. Anal. 2020, 12, 1382 (brorphine pharmacology)
Krotulski A.J. et al. J. Anal. Toxicol. 2021, 45, 850 (forensic overdose cases)
UNODC Early Warning Advisory: Brorphine (2020)`, url: "" },
    ],
    nextSteps: [`Maintain this entry as part of Wohler's internal structural-alert database
Review all Program D library designs against the brorphine structural motif before synthesis
Report any accidental structural convergence to regulatory affairs immediately
Use in SAR education for all Wohler chemists working in Program D`],
  },

  "cebranopadol-like": {
    id: "cebranopadol-like",
    name: `Cebranopadol-like NOP/MOR/DOR/KOR Ligands`,
    fullName: `Multi-receptor opioid ligand class (NOP/MOR/DOR/KOR)`,
    categoryId: `opioid`,
    program: `Program D — Biased MOR / Safer Opioid`,
    summary: `Strong analgesia research class with mixed opioid-receptor activity. Cebranopadol itself is in late clinical development for chronic pain.`,
    flagWarning: `Opioid-receptor similarity`,
  },

  "conolidine": {
    id: "conolidine",
    name: `Conolidine`,
    fullName: `Conolidine (Tabernaemontana divaricata alkaloid)`,
    categoryId: `opioid`,
    program: `Program D — Biased MOR / Safer Opioid`,
    cas: `6879-01-2`,
    formula: `C₁₉H₂₄N₂O`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Natural product from Tabernaemontana divaricata. Research-grade conolidine was first synthesized by Micalizio (2011) — prior scarcity of natural supply limited research.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `green`,
    goDecision: `TODO — strong candidate for non-opioid analgesia program`,
    priorityTier: `Tier 1`,
    summary: `Conolidine is a C5-nor-stemmadenine alkaloid from Tabernaemontana divaricata with potent analgesic activity in mouse models without classical opioid receptor activity. Proposed mechanism includes ACKR3 (CXCR7) modulation and opioid-peptide activity enhancement. Represents an interesting non-MOR analgesic research tool.`,
    researchAdvantages: `Potent analgesic in mouse hot-plate and tail-flick without classical opioid binding | No respiratory depression or constipation reported in animal studies | Novel mechanism — ACKR3/CXCR7 atypical chemokine receptor modulation | Micalizio 2011 synthesis published in Nature (Tarselli et al.)`,
    researchConsiderations: `Mechanism of action not fully established | No human PK or clinical data | Historically supply-limited (natural isolation)`,
    evidenceConfidence: `MODERATE`,
    mw: `296.41 g/mol`,
    benefitScore: 82,
    harmScore: 18,
    nextSteps: [`Build full Micalizio 2011 synthesis writeup (Nature Chem)
Translate synthesis to kg-scale using Wohler standard solvents
Develop scoring with Meyrath 2020 ACKR3 mechanism data
Regulatory attorney review (natural product, unscheduled)
Identify commercial starting-material vendor for Tabernaemontana intermediates`],
  },

  "corynoxine-b": {
    id: "corynoxine-b",
    name: `Corynoxine B`,
    fullName: `Corynoxine B (and Corynoxine A)`,
    categoryId: `opioid`,
    program: `Program A / J`,
    formula: `C₂₂H₂₈N₂O₄`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — expands Wohler portfolio into neuroprotection`,
    priorityTier: `Tier 2`,
    summary: `Oxindole alkaloid found in kratom and Uncaria species. Emerging neuroprotective profile with autophagy-promoting activity; USC Parkinson's research. Acts on calcium channels and dopaminergic pathways — distinct from opioid mechanism.`,
    researchAdvantages: `Non-opioid mechanism — low diversion/scheduling risk | Neuroprotection angle (Parkinson's, neurodegeneration) | Natural-product narrative | Low intrinsic abuse liability`,
    researchConsiderations: `Smaller therapeutic signal than opioid-active alkaloids | Limited pharmacology literature`,
    evidenceConfidence: `MODERATE`,
    mw: `384.47 g/mol`,
    benefitScore: 70,
    harmScore: 18,
    nextSteps: [`Collaborate with neurodegeneration lab at USC or equivalent
100-g reference-standard production`],
  },

  "damgo-comparator": {
    id: "damgo-comparator",
    name: `DAMGO Comparator`,
    fullName: `[D-Ala², N-MePhe⁴, Gly-ol]-enkephalin`,
    categoryId: `opioid`,
    program: `Program D — Biased MOR / Safer Opioid`,
    summary: `Lab benchmark peptide — selective full MOR agonist standard used in binding/functional assays. Reference only, not a product target.`,
    flagWarning: `Opioid peptide benchmark`,
  },

  "oliceridine-comparator": {
    id: "oliceridine-comparator",
    name: `Oliceridine Comparator (TRV130)`,
    fullName: `Oliceridine (TRV130) — FDA-approved G-protein biased MOR agonist, Wohler reference compound`,
    categoryId: `opioid`,
    program: `Program D — Biased MOR / Safer Opioid`,
    cas: `1401028-24-7`,
    formula: `C22H30N2O2S`,
    schedulingStatus: `Schedule II (US) — FDA approved August 2020 as Olinvyk® (IV)`,
    schedulingNote: `Oliceridine is Schedule II CSA. Used by Wohler strictly as a reference/comparator compound; no development intent.`,
    status: `Reference / Comparator`,
    statusColor: `blue`,
    goDecision: `REFERENCE — not a Wohler development candidate`,
    priorityTier: `Reference — Comparator Use Only`,
    summary: `Oliceridine (Trevena TRV130, marketed as Olinvyk) is the first FDA-approved G-protein biased MOR agonist for acute moderate-to-severe pain in hospital settings (IV). Bias factor ~3-6 vs morphine. Post-approval data show modestly reduced respiratory depression and nausea/vomiting vs morphine at equianalgesic doses, though real-world benefit remains debated. Wohler uses oliceridine as the benchmark comparator for all Program D candidates.`,
    researchAdvantages: `FDA-approved (August 2020) — validates G-protein biased MOR concept in humans | IV formulation avoids GI side-effects at drug/receptor level | Modest reduction in respiratory depression and emesis vs morphine in Phase 3 | Proven manufacturing scale (Trevena supply chain) | Definitive bias-factor measurement point for Wohler internal benchmarking`,
    researchConsiderations: `Post-approval real-world benefit more modest than initial claims | Re-classification as low-efficacy partial agonist (Gillis 2020) rather than biased agonist | IV-only formulation limits market | Schedule II — full abuse liability potential | Limited chronic-pain data; narrow acute-pain indication | Trevena patent protected — no Wohler development path`,
    evidenceConfidence: `HIGH`,
    aliases: [`TRV130`, `Olinvyk`],
    mw: 386.55,
    benefitScore: 68,
    harmScore: 48,
    references: [
      { title: `DeWire S.M. et al. J. Pharmacol. Exp. Ther. 2013, 344, 708 (TRV130 primary)
Singla N.K. et al. Pain Pract. 2019, 19, 715 (APOLLO-1 Phase 3)
Viscusi E.R. et al. Pain 2016, 157, 264 (Phase 2 dose-finding)
FDA Briefing Document for NDA 210730 (2018/2020)
Gillis A. et al. Sci. Signal. 2020, 13, eaaz3140 (low-efficacy reframing)`, url: "" },
    ],
    nextSteps: [`Maintain 50-100 g reference stock from qualified supplier
Use as primary in vivo comparator for all Wohler Program D candidates
Benchmark bias factors (BRET) of Wohler compounds vs oliceridine reference
Cite in Wohler's TPP (Target Product Profile) for biased MOR program`],
  },

  "peptide-opioid-ligands": {
    id: "peptide-opioid-ligands",
    name: `Peptide Opioid Ligands (CNS-limited)`,
    fullName: `Peptide opioid-receptor ligands with low CNS penetration`,
    categoryId: `opioid`,
    program: `Program D — Biased MOR / Safer Opioid`,
    summary: `Peptide-based opioid research tools hypothesized to have lower diversion risk due to limited oral bioavailability and CNS penetration. Delivery is the primary research challenge.`,
    flagWarning: `Opioid-receptor similarity`,
  },

  "peripheral-kor-agonists": {
    id: "peripheral-kor-agonists",
    name: `Peripheral KOR Agonists`,
    fullName: `Peripherally restricted kappa-opioid receptor agonists — analgesia without CNS dysphoria`,
    categoryId: `opioid`,
    program: `Program D — Biased MOR / Safer Opioid`,
    cas: `1024828-77-0 (difelikefalin)`,
    formula: `C36H53N7O6 (difelikefalin)`,
    schedulingStatus: `Unscheduled (difelikefalin approved 2021 as Korsuva®)`,
    schedulingNote: `Difelikefalin (Korsuva) is not a controlled substance — peripheral-only activity eliminates abuse potential. Sets precedent that peripheral KOR agonism is a viable non-controlled analgesic path.`,
    status: `Priority 1`,
    statusColor: `green`,
    goDecision: `GO — peripheral KOR analgesia program`,
    priorityTier: `Tier 1 — Active Research`,
    summary: `Peripherally restricted KOR agonists (difelikefalin/CR845, asimadoline) achieve analgesia and anti-pruritic effects without crossing the blood-brain barrier, thereby avoiding KOR-mediated central dysphoria, sedation, and hallucinations. Difelikefalin (Korsuva) was FDA-approved in 2021 for uremic pruritus and validated the peripheral-KOR strategy in humans. Wohler pursues peripheral-KOR as a non-controlled, non-MOR analgesic pathway.`,
    researchAdvantages: `Difelikefalin (FDA-approved 2021) validates peripheral-KOR strategy in humans | No controlled-substance scheduling — no abuse liability | No respiratory depression (KOR does not drive MOR-type respiratory effects) | No constipation at therapeutic doses (peripheral restriction spares CNS/GI) | Peptide-based (difelikefalin) and small-molecule (asimadoline) templates both available | Strong IP landscape — clean design-around opportunities`,
    researchConsiderations: `Peptide delivery (difelikefalin is IV/SC only) — no oral option currently | Analgesic efficacy more modest than MOR agonists in somatic pain | Tolerance development at peripheral KOR over chronic dosing | Niche indications (uremic pruritus) vs broad pain market | Asimadoline failed in Phase 3 IBS (efficacy not met)`,
    evidenceConfidence: `HIGH`,
    aliases: [`CR845`, `Difelikefalin`, `Asimadoline`, `FE 200665`],
    mw: 679.84,
    benefitScore: 76,
    harmScore: 25,
    references: [
      { title: `Deeks E.D. Drugs 2022, 82, 681 (difelikefalin approval review)
Fishbane S. et al. N. Engl. J. Med. 2020, 382, 222 (KALM-1 pivotal trial)
Arendt-Nielsen L. et al. Scand. J. Pain 2009 (peripheral KOR analgesia)
Beck T.C. et al. Med. Sci. 2019, 7, 95 (peripheral KOR mechanism review)
Mangel A.W. et al. Aliment. Pharmacol. Ther. 2008, 28, 239 (asimadoline Phase 2 IBS)`, url: "" },
    ],
    nextSteps: [`Design 20-compound peripherally restricted KOR small-molecule library
Primary screen: KOR binding (Ki), G-protein activation (BRET), MOR counter-screen
PAMPA and MDCK-MDR1 assays to confirm peripheral restriction
In vivo: rat formalin paw model (peripheral nociception) + rotarod (CNS exclusion)
Lead candidate: advance to GLP tox and Pre-IND package
Target indication: post-operative pain (non-controlled alternative to opioids)`],
  },

  "pzm21": {
    id: "pzm21",
    name: `PZM21`,
    fullName: `PZM21 — structure-based biased mu-opioid receptor agonist`,
    categoryId: `opioid`,
    program: `Program D — Biased MOR / Safer Opioid`,
    cas: `1997387-43-5`,
    formula: `C21H25N3O2`,
    schedulingStatus: `Unscheduled research chemical (investigational)`,
    schedulingNote: `PZM21 is not currently scheduled; as a MOR agonist with analgesic activity, any clinical development would likely trigger Schedule II placement.`,
    status: `Priority 1`,
    statusColor: `green`,
    goDecision: `GO — structural template for G-protein biased MOR program`,
    priorityTier: `Tier 1 — Active Research`,
    summary: `PZM21 was discovered by Manglik, Shoichet, and Roth via virtual screening of 3 million compounds against the MOR crystal structure, followed by SAR optimization. Originally reported as a G-protein biased MOR agonist with analgesia but reduced respiratory depression and reward. Subsequent re-evaluation (Hill et al. 2018, Kliewer et al. 2019) showed partial agonism rather than strong bias, but the scaffold remains valuable as a low-efficacy MOR template.`,
    researchAdvantages: `Derived from structure-based drug design — defined binding pose (PDB 5C1M) | Low-efficacy partial MOR agonism reduces respiratory depression and reward | Clean off-target profile vs morphine (no kappa/delta/NOP at therapeutic doses) | Oral bioavailability and CNS penetration confirmed in rodent PK | Open IP landscape — no NCE restrictions on core scaffold | Template for designing low-efficacy MOR ligands that avoid β-arrestin-dependent toxicities`,
    researchConsiderations: `Original bias claims overstated — re-classification as partial agonist limits narrative | Analgesic potency modest (ED50 ~4.6 mg/kg IP, rat hot plate) | Short half-life in rodents (t½ ~1.5 h) requires PK optimization | Multi-step synthesis (6+ steps) compared to morphinans | No human clinical data`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`PZM-21`],
    mw: 367.45,
    benefitScore: 72,
    harmScore: 45,
    references: [
      { title: `Manglik A. et al. Nature 2016, 537, 185-190 (discovery + primary pharmacology)
Hill R. et al. Br. J. Pharmacol. 2018, 175, 2653 (low-efficacy reclassification)
Kliewer A. et al. Br. J. Pharmacol. 2019, 176, 3110 (bias reassessment)
Schmid C.L. et al. Cell 2017, 171, 1165 (bias factor framework)
PDB 5C1M (MOR crystal structure used for discovery)`, url: "" },
    ],
    nextSteps: [`Reproduce 6-step synthesis at 10 g scale
Develop CDI-based kg-scale route (eliminate triphosgene)
Chiral SFC method development for (S)-PZM21 isolation
Rat hot-plate and tail-flick analgesia benchmarking vs morphine
Plethysmography for respiratory depression window
Use as reference compound for Wohler MOR library SAR`],
  },

  "sr-14968": {
    id: "sr-14968",
    name: `SR-14968`,
    fullName: `SR-14968 — Scripps biased MOR agonist (next-gen of SR-17018 class)`,
    categoryId: `opioid`,
    program: `Program D — Biased MOR / Safer Opioid`,
    cas: `Not CAS-registered`,
    formula: `C22H27FN4O2`,
    schedulingStatus: `Unscheduled research chemical (investigational)`,
    schedulingNote: `SR-14968 and related Scripps MOR biased agonists are not scheduled. Any clinical advancement would likely trigger Schedule II placement.`,
    status: `Priority 1`,
    statusColor: `green`,
    goDecision: `GO — strongest G-protein bias reported in MOR literature`,
    priorityTier: `Tier 1 — Active Research`,
    summary: `SR-14968 (and sibling SR-17018) are Scripps biased MOR agonists reported by Bohn/Cameron/Schmid in Cell 2017. Bias factor 11-15 (vs DAMGO), the highest reported for a small-molecule MOR ligand. In vivo: equianalgesic to morphine but with markedly reduced respiratory depression, constipation, tolerance, and physical dependence. Represents the most pharmacologically validated MOR-biased scaffold.`,
    researchAdvantages: `Highest G-protein bias factor reported in small-molecule MOR literature (Schmid 2017) | Reduced respiratory depression, constipation, tolerance, and dependence in rodent models | Equianalgesic potency to morphine — no efficacy compromise | Non-morphinan scaffold avoids opiate alkaloid IP clutter | Open IP — Scripps-licensable/design-around friendly`,
    researchConsiderations: `Original bias framework under active debate (Hill 2018, Kliewer 2019) | Synthesis is 7+ steps with expensive fluorinated intermediates | Limited in vivo data beyond Bohn lab publications | No human PK or safety data | Metabolic liability at the piperazine linker`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`SR14968`],
    mw: 398.48,
    benefitScore: 74,
    harmScore: 40,
    references: [
      { title: `Schmid C.L. et al. Cell 2017, 171, 1165-1175 (primary disclosure)
Bohn L.M. et al. Science 1999, 286, 2495 (β-arrestin-2 KO establishes bias rationale)
Raehal K.M. et al. J. Pharmacol. Exp. Ther. 2005, 314, 1195 (arrestin/respiratory link)
Hill R. et al. Br. J. Pharmacol. 2018, 175, 2653 (bias framework critique)
Gillis A. et al. Sci. Signal. 2020, 13, eaaz3140 (low-efficacy reframing)`, url: "" },
    ],
    nextSteps: [`Reproduce 7-step synthesis at 5 g scale to validate route
Develop CDI-based piperazine coupling to avoid halide intermediates
Run G-protein/β-arrestin bias assays (BRET) in-house to confirm bias factor
Rat tail-flick analgesia and whole-body plethysmography safety margin
5-day tolerance and precipitated withdrawal studies vs morphine
Design 15-compound SAR library around the piperazine linker`],
  },

  "sr-17018": {
    id: "sr-17018",
    name: `SR-17018`,
    fullName: `SR-17018 (biased MOR agonist)`,
    categoryId: `opioid`,
    program: `Program D`,
    formula: `C₂₀H₁₉F₃N₄O (approximate)`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled but structurally in the biased-opioid research class. Very high analog/enforcement/diversion concern despite research-only posture. Brorphine-like structural class has drawn scrutiny.`,
    status: `Hold — Legal Review Required`,
    statusColor: `red`,
    goDecision: `HOLD — require legal memo + university/CRO partner before any synthesis`,
    priorityTier: `Tier 3 — Hold`,
    summary: `A biased mu-opioid receptor agonist that preferentially activates G-protein signaling over β-arrestin recruitment. The biased-opioid hypothesis posits reduced tolerance and respiratory depression at equianalgesic doses. The hypothesis is debated — recent replication work has produced mixed results. Relevant to fentanyl-harm-reduction research but only in a tightly controlled institutional context.`,
    researchAdvantages: `Most characterized biased MOR agonist in research literature | Directly relevant to fentanyl-harm-reduction + tolerance/dependence research | Clear mechanism hypothesis for rigorous testing`,
    researchConsiderations: `Brorphine-like structural class — enforcement concern | Biased-opioid hypothesis not yet fully validated | Potent MOR agonism = abuse/diversion risk | Controversial compound — reputational consideration for Wohler`,
    evidenceConfidence: `MODERATE`,
    mw: `≈ 404 g/mol`,
    benefitScore: 75,
    harmScore: 55,
    nextSteps: [`Legal memo on scheduling/analog/enforcement risk
Survey universities for interest before committing synthesis
Consider KOR/DOR/NOP alternatives with lower risk profile first`],
  },

  "u50488-comparator": {
    id: "u50488-comparator",
    name: `U-50,488 / KOR Comparator`,
    fullName: `trans-(±)-3,4-Dichloro-N-methyl-N-[2-(1-pyrrolidinyl)cyclohexyl]benzeneacetamide`,
    categoryId: `opioid`,
    program: `Program D — Biased MOR / Safer Opioid`,
    summary: `KOR-selective agonist lab benchmark compound. Reference tool for KOR pharmacology research — not a product target.`,
    flagWarning: `Opioid receptor similarity`,
  },

  "2mm-salvinorin-b": {
    id: "2mm-salvinorin-b",
    name: `2-Methoxymethyl Salvinorin B`,
    fullName: `2-Methoxymethyl salvinorin B`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Salvinorin B analog with enhanced KOR potency/duration — analgesia / itch / inflammation research tool.`,
    flagWarning: `Salvinorin-adjacent`,
  },

  "dor-agonists": {
    id: "dor-agonists",
    name: `Delta Opioid Receptor (DOR) Agonists`,
    fullName: `Selective DOR Agonists for Chronic Pain (class)`,
    categoryId: `pain`,
    program: `Program D`,
    formula: `Class — various`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Class — specific compounds vary. Most research DOR agonists are unscheduled. Seizure risk is historical concern for class.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — pain/mood research without MOR or KOR baggage`,
    priorityTier: `Tier 2 — Class selection required`,
    summary: `Delta opioid receptors are overlooked but promising for chronic pain, allodynia, hyperalgesia, and mood disorders. A 2025 review describes DOR as lacking the euphoric/addictive profile of mu and the dysphoria of kappa. Relevant to neuropathic pain and mood without mu-opioid risk.`,
    researchAdvantages: `Non-mu, non-kappa opioid pain target | Mood-benefit research angle | Lower abuse liability than mu opioids | No respiratory depression (class)`,
    researchConsiderations: `Seizure risk (historical concern; newer compounds safer) | No single lead compound identified for Wohler production`,
    evidenceConfidence: `MODERATE`,
    aliases: [`DOR agonists`],
    mw: `Varies`,
    benefitScore: 75,
    harmScore: 28,
    nextSteps: [`Lead compound selection
Seizure-liability prescreening plan`],
  },

  "eom-salvinorin-b": {
    id: "eom-salvinorin-b",
    name: `EOM-Salvinorin B`,
    fullName: `Ethoxymethyl salvinorin B`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Ethoxymethyl salvinorin B analog — KOR research tool with extended duration vs parent salvinorin A.`,
    flagWarning: `Salvinorin-adjacent`,
  },

  "faah-inhibitors": {
    id: "faah-inhibitors",
    name: `FAAH Inhibitors`,
    fullName: `Fatty acid amide hydrolase inhibitor research class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Endocannabinoid pain modulation — FAAH inhibition raises anandamide tone for pain and anxiety research.`,
    flagWarning: `Endocannabinoid-system adjacency`,
  },

  "ldn-analogs": {
    id: "ldn-analogs",
    name: `Low-Dose Naltrexone Analogs`,
    fullName: `Low-dose naltrexone-derived glial/TLR4 modulator class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Glial / TLR4 / pain research — low-dose naltrexone is used off-label for chronic pain and fibromyalgia; analogs for research.`,
    flagWarning: `Opioid antagonist drug adjacency`,
  },

  "magl-inhibitors": {
    id: "magl-inhibitors",
    name: `MAGL Inhibitors`,
    fullName: `Monoacylglycerol lipase inhibitor research class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Endocannabinoid pain modulation — MAGL inhibition raises 2-AG tone. Research tools for pain and inflammation.`,
    flagWarning: `Endocannabinoid-system adjacency`,
  },

  "nop-mor-mixed": {
    id: "nop-mor-mixed",
    name: `Mixed NOP/MOR Ligands`,
    fullName: `Mixed Nociceptin/Mu-Opioid Receptor Agonists (class)`,
    categoryId: `pain`,
    program: `Program D`,
    formula: `Class — various`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Class-dependent. Cebranopadol (NOP/MOR mixed) is in late-stage clinical development; unscheduled currently.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — potentially the best next-generation pain lane`,
    priorityTier: `Tier 2`,
    summary: `Mixed nociceptin (NOP) + mu-opioid receptor agonists preserve potent analgesia while reducing abuse liability, tolerance, and respiratory depression. Cebranopadol is the most-advanced clinical example. This mechanism — not 'make another mu agonist' — may be the best next-generation pain research direction.`,
    researchAdvantages: `Strong analgesia with reduced abuse + respiratory depression | Not simply 'another mu agonist' — mechanistically differentiated | Late-stage clinical validation (cebranopadol) | University/CRO research interest high`,
    researchConsiderations: `Complex synthesis for most advanced compounds | IP is tightly held by industry`,
    evidenceConfidence: `MODERATE`,
    aliases: [`NOP/MOR bitopic`],
    mw: `Varies`,
    benefitScore: 82,
    harmScore: 26,
    nextSteps: [`Select 1–2 research tools
IP landscape review
Partner with pain research lab`],
  },

  "n-ca-blockers": {
    id: "n-ca-blockers",
    name: `N-type Calcium Channel Blockers`,
    fullName: `N-type (Cav2.2) calcium channel blocker pain research class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Pain research — ziconotide (Prialt) is an approved intrathecal ω-conotoxin; research analogs explore oral/systemic delivery.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "nav17-blockers": {
    id: "nav17-blockers",
    name: `NaV1.7 Blockers`,
    fullName: `Voltage-gated sodium channel 1.7 selective blocker class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Non-opioid pain research — NaV1.7 is the 'pain channel' genetically validated for analgesia without CNS effects.`,
  },

  "nav18-blockers": {
    id: "nav18-blockers",
    name: `NaV1.8 Blockers`,
    fullName: `Voltage-gated sodium channel 1.8 selective blocker class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Non-opioid pain research — highly relevant post-Journavx (suzetrigine) era. FDA-approved Jan 2025 for acute pain.`,
  },

  "p2x3-antagonists": {
    id: "p2x3-antagonists",
    name: `P2X3 Antagonists`,
    fullName: `P2X3 purinergic receptor antagonist class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Pain/cough/sensory signaling research — gefapixant is an approved P2X3 antagonist for chronic cough.`,
  },

  "pea-analogs": {
    id: "pea-analogs",
    name: `Palmitoylethanolamide (PEA) Analogs`,
    fullName: `PEA and PPAR-α anti-inflammatory pain research class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `PPAR-alpha / anti-inflammatory pain research — PEA is an endogenous fatty-acid amide with analgesic and anti-inflammatory activity.`,
  },

  "peripheral-opioids": {
    id: "peripheral-opioids",
    name: `Peripherally-Restricted Opioid Agonists`,
    fullName: `Peripherally-restricted opioid receptor agonists (class)`,
    categoryId: `pain`,
    program: `Program D`,
    formula: `Class — various`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Class — loperamide is a classic approved example (OTC). Peripheral restriction via physicochemical properties or efflux substrate design.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — clean pain research without CNS abuse liability`,
    priorityTier: `Tier 2`,
    summary: `Peripheral opioid receptor agonists act at opioid receptors outside the CNS, producing analgesia (especially visceral and inflammatory pain) without central euphoria or respiratory depression. Represents a very good research direction if the goal is to help pain without creating fentanyl-like CNS risk.`,
    researchAdvantages: `No central abuse or respiratory depression | Clean 'fentanyl-harm-reduction' research narrative | Multiple lead compounds in development | Suitable for visceral + inflammatory pain research`,
    researchConsiderations: `Limited utility for severe CNS-mediated pain | P-gp substrate design can create PK complexity`,
    evidenceConfidence: `MODERATE`,
    aliases: [`Peripheral opioids`],
    mw: `Varies`,
    benefitScore: 75,
    harmScore: 18,
    nextSteps: [`Lead compound selection
P-gp substrate validation plan`],
  },

  "salvinorin-a-analogs": {
    id: "salvinorin-a-analogs",
    name: `Salvinorin A Analogs`,
    fullName: `Salvinorin A and C-2 modified analogs (EOM-Salvinorin B, etc.)`,
    categoryId: `pain`,
    program: `Program D / Pain`,
    formula: `C₂₃H₂₈O₈ (parent Salvinorin A)`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Salvinorin A not federally scheduled; some U.S. states have scheduled it (CA, OH, WI partial). Novel analogs generally unscheduled.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — KOR analgesia is major pharma target`,
    priorityTier: `Tier 2`,
    summary: `Salvinorin A (from Salvia divinorum) is the most potent natural hallucinogen known — active at microgram doses — and is the first non-nitrogenous opioid receptor ligand discovered, acting exclusively on KOR. 2024 PMC research screened C-2 analogs for selective KOR agonism with reduced hallucinogenic effects. Major target for non-opioid analgesia and anti-itch research.`,
    researchAdvantages: `KOR-selective analgesia — no respiratory depression, different addiction liability | Non-nitrogenous scaffold — unique medicinal chemistry space | Validated analgesic + anti-pruritus mechanism | C-2 analogs with reduced hallucinogenic profile available | Strong academic research interest`,
    researchConsiderations: `Complex terpenoid scaffold — synthesis is demanding | Some KOR agonists produce dysphoria (class effect) | State-level Salvia scheduling complexity`,
    evidenceConfidence: `HIGH`,
    aliases: [`KOR agonists`],
    mw: `432.46 g/mol`,
    benefitScore: 82,
    harmScore: 28,
    nextSteps: [`State-scheduling review
Partner with Roth/Cohen labs (UNC, Stanford)
Produce EOM-Salvinorin B research tool`],
  },

  "sigma-1-modulators": {
    id: "sigma-1-modulators",
    name: `Sigma-1 Receptor Modulators`,
    fullName: `Sigma-1 receptor antagonists and modulators (class)`,
    categoryId: `pain`,
    program: `Program D / Pain`,
    formula: `Class — various`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Sigma-1 ligands generally not scheduled. Specific compounds may have FDA/Rx status (e.g., S1RA/E-52862 in development).`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — cutting-edge non-opioid pain target`,
    priorityTier: `Tier 2 — Class selection required`,
    summary: `Sigma-1 receptors are intracellular chaperone proteins at the mitochondria-associated ER membrane. Sigma-1 antagonism modulates central sensitization — underlying chronic pain, fibromyalgia, neuropathic pain — without opioid receptor engagement. Emerging 2023 PMC research highlights sigma receptors as promising pain targets.`,
    researchAdvantages: `Novel non-opioid analgesic mechanism | Active academic and industry development | Low scheduling risk | Class provides multiple compound opportunities`,
    researchConsiderations: `No single lead compound established | Requires compound selection + synthesis program | Off-target activity common in early ligands`,
    evidenceConfidence: `MODERATE`,
    aliases: [`S1R ligands`],
    mw: `Varies`,
    benefitScore: 78,
    harmScore: 16,
    nextSteps: [`Literature review to select 2–3 lead compounds
IP landscape review
Partner identification`],
  },

  "sigma-2-ligands": {
    id: "sigma-2-ligands",
    name: `Sigma-2 Receptor Ligands`,
    fullName: `Sigma-2 (TMEM97) receptor ligand research class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Pain/inflammation/cancer research — sigma-2 receptor (TMEM97) is a novel pain target.`,
  },

  "trpa1-antagonists": {
    id: "trpa1-antagonists",
    name: `TRPA1 Antagonists`,
    fullName: `Transient receptor potential A1 antagonist class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Pain/inflammation research — TRPA1 is a cold and irritant receptor involved in inflammatory pain.`,
  },

  "trpv1-antagonists": {
    id: "trpv1-antagonists",
    name: `TRPV1 Antagonists`,
    fullName: `Transient receptor potential V1 antagonist class`,
    categoryId: `pain`,
    program: `Pain / Non-Opioid Analgesia`,
    summary: `Pain / inflammation research — TRPV1 is the capsaicin receptor; antagonists of interest for neuropathic pain.`,
  },

  "epitalon-albumin-binding": {
    id: "epitalon-albumin-binding",
    name: `Albumin-Binding Epitalon Analogs`,
    fullName: `Epitalon albumin-binding HL-extension analog class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Half-life extension via albumin binding — fatty-acid / albumin-binder conjugation strategy.`,
  },

  "bpc-157": {
    id: "bpc-157",
    name: `BPC-157 Analogs`,
    fullName: `BPC-157 — Body Protective Compound-157 research class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Tissue-repair research — BPC-157 is a 15-amino-acid peptide derived from human gastric juice. FDA has issued cautions on compounded use; research-use-only posture required.`,
    flagWarning: `Peptide/drug/claim risk`,
  },

  "cjc-1295-comparator": {
    id: "cjc-1295-comparator",
    name: `CJC-1295-like Comparators`,
    fullName: `CJC-1295 and DAC-technology peptide PK research comparators`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Peptide PK research — CJC-1295's DAC (drug-affinity complex) technology is a reference for albumin-binding peptide half-life extension.`,
    flagWarning: `Peptide/drug adjacency`,
  },

  "dsip-analogs": {
    id: "dsip-analogs",
    name: `DSIP Analogs`,
    fullName: `Delta sleep-inducing peptide analog research class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Sleep peptide research — DSIP is a 9-amino-acid sleep-regulating peptide isolated from rabbit brain.`,
  },

  "epitalon": {
    id: "epitalon",
    name: `Epitalon Analogs`,
    fullName: `Epitalon (Ala-Glu-Asp-Gly) + half-life-extension analogs`,
    categoryId: `peptides`,
    program: `Program I`,
    cas: `307297-39-8 (epitalon)`,
    formula: `C₁₄H₂₂N₄O₉ (epitalon)`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Not an approved drug in the U.S. FDA/peptide/drug-claim concerns if marketed for human use.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — peptide PK-extension research program`,
    priorityTier: `Tier 2 — IP opportunity`,
    summary: `Epitalon is a tetrapeptide (Ala-Glu-Asp-Gly) developed by Vladimir Khavinson for circadian, telomerase, pineal gland, and longevity research. Rapidly degraded in plasma — half-life extension analogs (D-amino acid substitutions, PEGylation, fatty acid conjugation) are the Wohler program focus. Good patent/IP research program.`,
    researchAdvantages: `Very low toxicity profile | Open patent space for PK-extended analogs | Circadian + longevity research market interest | Simple parent peptide; feasible SPPS | Russian clinical literature 30+ years`,
    researchConsiderations: `Rapid parent peptide degradation | Efficacy vs placebo claims need rigorous study | FDA scrutiny on longevity claims`,
    evidenceConfidence: `MODERATE`,
    aliases: [`Epithalon`],
    mw: `390.35 g/mol`,
    benefitScore: 68,
    harmScore: 12,
    nextSteps: [`File provisional patents on 2–3 PK-extended analogs
Establish CMO partnership for SPPS
Longevity research partner identification`],
  },

  "epithalamin-peptides": {
    id: "epithalamin-peptides",
    name: `Epithalamin-Derived Peptides`,
    fullName: `Epithalamin / pineal peptide research class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Pineal peptide research — epithalamin is a mixture of low-MW pineal peptides; Epitalon is the simplified tetrapeptide.`,
  },

  "glp1-platform": {
    id: "glp1-platform",
    name: `GLP-1 / GIP Half-Life Platform`,
    fullName: `GLP-1 / GIP technology platform for peptide PK extension`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Not an RC lead — platform technology reference. Semaglutide/tirzepatide PK-extension technology applicable to Epitalon and other peptides.`,
    flagWarning: `Approved-drug adjacency`,
  },

  "epitalon-hl-extended": {
    id: "epitalon-hl-extended",
    name: `Half-Life Extended Epitalon Analogs`,
    fullName: `Epitalon PK-extension analog class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `IP/patentable peptide PK project — Epitalon has <1h half-life in plasma; HL-extended analogs are a major Wohler research opportunity.`,
  },

  "kpv-analogs": {
    id: "kpv-analogs",
    name: `KPV Peptide Analogs`,
    fullName: `α-MSH-derived Lys-Pro-Val tripeptide anti-inflammatory research class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Anti-inflammatory peptide research — KPV is a tripeptide fragment of α-MSH with anti-inflammatory activity.`,
  },

  "epitalon-lipidated": {
    id: "epitalon-lipidated",
    name: `Lipidated Epitalon Analogs`,
    fullName: `Epitalon lipid-conjugated PK-extension analog class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `GLP-1-style half-life extension concept — lipid conjugation (like semaglutide) applied to Epitalon for weekly dosing potential.`,
  },

  "melatonin-peptide-hybrids": {
    id: "melatonin-peptide-hybrids",
    name: `Melatonin Peptide Hybrids`,
    fullName: `Melatonin-peptide conjugate research class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Sleep / circadian research — melatonin conjugated to Epitalon-like peptides for dual circadian mechanisms.`,
  },

  "epitalon-pegylated": {
    id: "epitalon-pegylated",
    name: `PEGylated Epitalon Analogs`,
    fullName: `PEGylated Epitalon PK-extension analog class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Half-life extension via PEGylation — classical peptide PK-extension strategy.`,
  },

  "semax-selank": {
    id: "semax-selank",
    name: `Semax / Selank Analogs`,
    fullName: `Semax and Selank Russian nootropic/anxiolytic peptide research class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Nootropic / anxiolytic peptides — developed in Russia. Semax is an ACTH fragment; Selank is a tuftsin analog.`,
  },

  "thymosin-beta4": {
    id: "thymosin-beta4",
    name: `Thymosin β-4 Fragments`,
    fullName: `Thymosin β-4 fragment research class`,
    categoryId: `peptides`,
    program: `Program I — Peptide PK-Extension / Epitalon`,
    summary: `Tissue repair / inflammation research — thymosin β-4 fragment research. Regulatory caution on wellness / clinical claims.`,
    flagWarning: `Peptide/drug/claim risk`,
  },

  "4-aco-det": {
    id: "4-aco-det",
    name: `4-AcO-DET`,
    fullName: `4-Acetoxy-N,N-diethyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B`,
    cas: `936-04-9 (free base)`,
    formula: `C₁₆H₂₂N₂O₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Active metabolite (4-HO-DET / CZ-74) was studied in humans by Hofmann and Leuner in 1960s Swiss psychiatric protocols. Structurally related to scheduled psilocin; analog considerations identical to 4-HO-MET.`,
    status: `Strongly Favored`,
    statusColor: `green`,
    goDecision: `GO — 60+ years of human data via CZ-74`,
    priorityTier: `Tier 1`,
    summary: `O-acetyl prodrug of 4-HO-DET. The N,N-diethyl analog of 4-AcO-DMT has one of the longest human safety records among tryptamines — it was studied as CZ-74 / CEY-19 by Leuner & Baer in 1960s Swiss clinical psychotherapy trials. Shorter duration than psilocybin; lower 5-HT2C activation than psilocin.`,
    researchAdvantages: `Active metabolite CZ-74 has 60+ years of documented human clinical experience (Leuner, Baer, Hofmann) | Prodrug mechanism identical to 4-AcO-MET — esterase-driven O-deacetylation in plasma | ED50 = 0.71 mg/kg in mouse HTR (Klein et al. 2021) — robust in vivo activity | Lower 5-HT2C component than psilocin — potentially cleaner side-effect profile | Shorter duration than psilocybin — operationally attractive for 4-hour therapy sessions`,
    researchConsiderations: `5-HT2B Emax ≈ 64 % — moderate cardiac valve concern with chronic dosing | Most clinical data is 1960s — modern PK/PD reanalysis required | Psilocin scaffold — scheduling scrutiny applies`,
    evidenceConfidence: `HIGH`,
    aliases: [`Ethacetin`, `Psilacetin-DET`, `CZ-74 prodrug`],
    mw: `274.36 g/mol`,
    benefitScore: 85,
    harmScore: 24,
    nextSteps: [`Reference-standard production for CROs
IRB dossier emphasizing 60-yr human safety record
Patent filing on crystal form`],
  },

  "4-aco-dpt": {
    id: "4-aco-dpt",
    name: `4-AcO-DPT`,
    fullName: `4-Acetoxy-N,N-dipropyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B`,
    cas: `1024612-25-6`,
    formula: `C₁₈H₂₆N₂O₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Structural relative of psilocin; same analog considerations as 4-HO-MET. DPT (N,N-dipropyltryptamine, non-4-hydroxy) is also unscheduled federally.`,
    status: `Strongly Favored`,
    statusColor: `green`,
    goDecision: `GO — lead differentiation candidate`,
    priorityTier: `Tier 1 — Lead novel compound`,
    summary: `Prodrug for 4-HO-DPT. The distinguishing pharmacological feature: 129-fold 5-HT2A/5-HT2C selectivity vs. ≈1-fold for psilocin itself. 5-HT2C activation is implicated in anxiety, appetite suppression, and adverse subjective effects — a truly 5-HT2A-selective psychedelic is a genuinely novel therapeutic concept. EC₅₀ ≈ 23.7 nM at 5-HT2A with near-full agonist efficacy.`,
    researchAdvantages: `129-fold 5-HT2A/5-HT2C selectivity — genuinely novel SAR differentiation vs. psilocybin | Near-full 5-HT2A agonist efficacy (Emax ≈ 96 %) | Theoretical therapeutic advantage: cleaner psychedelic experience with less anxiety/nausea | Publishable, patentable differentiation story | Same Speeter-Anthony synthesis infrastructure as 4-AcO-MET`,
    researchConsiderations: `No human clinical data — novel compound | 5-HT2B still active — cardiac concern for chronic dosing | Scheduling scrutiny (psilocin scaffold)`,
    evidenceConfidence: `HIGH`,
    aliases: [`Procetin`],
    mw: `302.41 g/mol`,
    benefitScore: 89,
    harmScore: 23,
    nextSteps: [`Publish receptor selectivity paper in collaboration with McCorvy lab
Patent crystal form + method-of-use
Generate reference standard`],
  },

  "4-aco-ept": {
    id: "4-aco-ept",
    name: `4-AcO-EPT`,
    fullName: `4-Acetoxy-N-ethyl-N-propyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B`,
    cas: `N/A (not yet assigned)`,
    formula: `C₁₇H₂₄N₂O₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Psilocin analog considerations apply.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — high potency + 5-HT2B plasticity interest`,
    priorityTier: `Tier 2`,
    summary: `Prodrug for 4-HO-EPT. Notably, 4-HO-EPT is among the most potent psilocin analogs at 5-HT2A (EC₅₀ ≈ 3.15 nM). The asymmetric N-ethyl-N-propyl substitution produces high 5-HT2B efficacy (89 %) — of interest for neuroplasticity research (5-HT2B contributes to BDNF release).`,
    researchAdvantages: `Among the most potent 5-HT2A agonists in the psilocin family (EC₅₀ ≈ 3.15 nM) | High 5-HT2B efficacy (89 %) — relevant for neuroplasticity research | Asymmetric N-alkyl substitution — structurally distinct from symmetric tryptamines | Same synthesis route as 4-AcO-MET`,
    researchConsiderations: `5-HT2B activity — cardiac caution | Minimal human data | Psilocin scheduling concern`,
    evidenceConfidence: `MODERATE`,
    mw: `288.39 g/mol`,
    benefitScore: 84,
    harmScore: 25,
    nextSteps: [`5-HT2B specificity counter-screen
Cardiac safety dossier before CRO distribution`],
  },

  "4-aco-met": {
    id: "4-aco-met",
    name: `4-AcO-MET`,
    fullName: `4-Acetoxy-N-methyl-N-ethyltryptamine (Metocin / Metacetin)`,
    categoryId: `tryptamines`,
    program: `Program B — Tryptamine Space (Wohler flagship)`,
    cas: `1432794-99-4`,
    formula: `C15H20N2O2`,
    meltingPoint: `154–158 °C (fumarate salt)`,
    appearance: `Off-white to pale tan crystalline solid (fumarate salt)`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Not federally scheduled in the United States. Psilocybin/psilocin-class analog — Federal Analogue Act scrutiny is possible. State-level scheduling varies (Louisiana, California have research-use ambiguity; Colorado permitted; confirm per jurisdiction). Research-use-only posture required. DEA List I monitoring where applicable.`,
    status: `GO — Wohler Flagship`,
    statusColor: `green`,
    goDecision: `GO — Wohler flagship tryptamine; psilocin-class prodrug with improved stability and standardized dosing. Priority program for depression / PTSD / addiction research partnerships.`,
    priorityTier: `Tier 1 — Active Development`,
    summary: `4-AcO-MET is Wohler Chemical's flagship tryptamine research compound — the O-acetylated prodrug of 4-HO-MET (metocin). Plasma and hepatic esterase-mediated deacetylation unmasks the active 5-HT2A/5-HT2C agonist 4-HO-MET. Compared to psilocybin, 4-AcO-MET offers a shorter research-session duration (~4–5 h vs 6 h), equivalent subjective intensity at equimolar doses, and a simpler crystalline salt for analytical standardization. Wohler uses 4-AcO-MET as the primary chemical platform for depression, treatment-resistant anxiety, PTSD, end-of-life psycho-oncology distress, addiction medicine, and neuroplasticity research partnerships with university IRB-approved programs.`,
    researchAdvantages: `Wohler flagship — validated synthetic route, analytical standards, and multi-gram scale history | Prodrug strategy: improved crystalline stability vs free-base 4-HO-MET (which oxidizes rapidly) | Shorter duration than psilocybin (~4–5 h) enables tighter clinical-research session design and lower IRB burden | Strong university-partner appeal for 5-HT2A neuroplasticity / depression / PTSD research | Simpler analytical fingerprint than psilocybin (no psilocin ↔ psilocybin equilibrium complications) | Unscheduled federally — lowest-friction tryptamine for controlled substance research registration | Single-dose therapeutic potential (like psilocybin) — efficient for randomized trial design`,
    researchConsiderations: `Psilocybin/psilocin analog — non-zero Federal Analogue Act scrutiny requires legal memo per jurisdiction | State-by-state scheduling varies — institutional legal review required | Limited peer-reviewed human clinical data vs psilocybin's extensive literature base | 5-HT2B agonism must be rigorously profiled (chronic dosing cardiac valvulopathy concern) | Requires controlled-access inventory, dual-witnessed handling, and research-use-only posture | Potential for perceptual disturbance in subjects without screening`,
    evidenceConfidence: `MEDIUM-HIGH`,
    aliases: [`4-Acetoxy-MET`, `Metocin`, `Metacetin`, `O-Acetyl-4-HO-MET`],
    mw: `260.33 g/mol`,
    benefitScore: 88,
    harmScore: 18,
    nextSteps: [`Lock in kg-scale manufacturing process (campaign 1 → campaign 2 process confirmation)
Complete 2-year stability program on fumarate Form I (ICH-compliant)
FTO analysis refresh and polymorph patent filing (Q2 2025 target)
5-HT2B chronic-dosing cardiac safety study (guinea pig cardiac valve + echocardiogram, contract CRO)
HTR dose-response validation in C57BL/6 mice (internal)
Prodrug conversion kinetics in human plasma (CES1/CES2 phenotype panel)
Partner-readiness dossier: consolidated analytical COA template, stability data, FTO summary, Wohler MTA
University partnership outreach: 3 target institutions for Phase 2a depression pilot design
Contract GLP 28-day rat tox (ICH-compliant, 0.5/2/10 mg/kg dose levels)
Pre-IND briefing package drafting for treatment-resistant depression indication (FDA meeting target Q4 2025)`],
  },

  "4-aco-mipt": {
    id: "4-aco-mipt",
    name: `4-AcO-MiPT`,
    fullName: `4-Acetoxy-N-methyl-N-isopropyltryptamine (Ipracetin)`,
    categoryId: `tryptamines`,
    program: `Program B — Tryptamine Space`,
    cas: `1445751-37-2`,
    formula: `C16H22N2O2`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled federal US; psilocybin prodrug class — Analogue Act scrutiny likely; state schedules vary.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — 4-HO-MiPT prodrug with improved stability; cleanest 5-HT2B profile in acetoxy series.`,
    priorityTier: `Tier 2`,
    summary: `4-AcO-MiPT is the O-acetyl prodrug of 4-HO-MiPT, paralleling the psilocybin → psilocin relationship. Klein et al. (2021) report EC50 = 43.9 nM at h5-HT2A (Emax 93.2%) and low 5-HT2B efficacy (49.1%) — cleaner cardiac profile than DPT/EPT series. In vivo HTR potency (ED50 = 2.84 μmol/kg) confirms deacetylation → active 4-HO-MiPT.`,
    researchAdvantages: `Prodrug strategy — improved chemical stability vs 4-HO-MiPT free phenol | Low 5-HT2B Emax (49.1%) — cleanest cardiac profile among Klein acetoxy series with isopropyl group | Reliable, duration-bounded session length (~4 h) | Well-tolerated by dry-powder formulation (non-oxidizing)`,
    researchConsiderations: `Psilocybin analog — direct Analogue-Act risk | Requires plasma esterase activation — PK variability possible | No published human PK`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`Ipracetin`, `Mipracetin`, `4-Acetoxy-MiPT`],
    mw: `274.36 g/mol`,
    benefitScore: 80,
    harmScore: 20,
    references: [
      { title: `Klein A.K. et al. ACS Pharmacol. Transl. Sci. 2021, 4(2), 533–542.
10.1021/acsptsci.0c00176
33860183
Nichols D.E., Frescas S. Improvements to the synthesis of psilocybin and a facile method for preparing the O-acetyl prodrug of psilocin. Synthesis 1999, 935–938.
10.1055/s-1999-3490
Shulgin A.T., Shulgin A. TIHKAL: The Continuation. Transform Press, 1997.`, url: "" },
    ],
    nextSteps: [`Register for DEA List I (acetic anhydride) if not already
Develop DMAP-catalyzed acetylation SOP in EtOAc at 1 kg scale
Stability study: 4-AcO-MiPT fumarate vs 4-HO-MiPT free base (25 °C / 40 °C / 6 months)
Compare plasma esterase kinetics vs 4-AcO-MET in human plasma in vitro`],
  },

  "4-aco-mpt": {
    id: "4-aco-mpt",
    name: `4-AcO-MPT`,
    fullName: `4-Acetoxy-N-methyl-N-propyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B`,
    formula: `C₁₆H₂₂N₂O₂`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — intermediate SAR member`,
    priorityTier: `Tier 2`,
    summary: `Prodrug for 4-HO-MPT. ED50 = 0.55 mg/kg in mouse HTR — potency between 4-AcO-MET and 4-AcO-DET. Near-full 5-HT2A agonist (Emax 96 %). Useful for SAR studies bridging methyl/ethyl and propyl groups.`,
    researchAdvantages: `Intermediate SAR data point in methyl/ethyl/propyl tryptamine series | ED50 = 0.55 mg/kg — strong in vivo activity | Asymmetric N-alkyl = distinct PK from symmetric analogs | Same manufacturing infrastructure`,
    researchConsiderations: `Less differentiated than 4-AcO-DPT | Limited human data | Psilocin scheduling scrutiny`,
    evidenceConfidence: `MODERATE`,
    mw: `274.36 g/mol`,
    benefitScore: 78,
    harmScore: 25,
    nextSteps: [`SAR comparison batch with 4-AcO-MET and 4-AcO-DET
CRO reference standard`],
  },

  "4-ho-det": {
    id: "4-ho-det",
    name: `4-HO-DET`,
    fullName: `4-Hydroxy-N,N-diethyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B — Tryptamine Space`,
    cas: `22204-89-3`,
    formula: `C₁₄H₂₀N₂O`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled (DEA) — but structural analog of psilocin (Schedule I). Federal Analogue Act applies for human-consumption intent. Research-use-only posture required.`,
    status: `RESEARCH-NEEDED`,
    statusColor: `orange`,
    goDecision: `TODO — add to research journal pipeline`,
    priorityTier: `Tier 2`,
    summary: `4-HO-DET (Ethocin / CZ-74) is the desacetyl active metabolite of CZ-74 (4-AcO-DET). It was investigated in the 1960s by Sandoz alongside psilocybin by Hofmann and colleagues. Less studied in modern literature than 4-HO-MET but chemically closely related. Added to the Wohler pipeline as a companion to the existing 4-AcO-DET program.`,
    researchAdvantages: `Classical Sandoz compound with a documented human-research history | Shorter duration than psilocybin (~3–4 h) | Direct active metabolite of 4-AcO-DET — useful PK reference`,
    researchConsiderations: `Limited modern pharmacology data vs 4-HO-MET | High structural similarity to psilocin — scrutiny risk`,
    evidenceConfidence: `MODERATE`,
    aliases: [`CZ-74`, `Ethocin`],
    mw: `232.32 g/mol`,
    benefitScore: 72,
    harmScore: 25,
    nextSteps: [`Locate original Sandoz Hofmann 1960s publications
Compare HTR / ED50 data to 4-HO-MET
Design Speeter-Anthony lab synthesis from 4-acetoxyindole + diethylamine
Populate kg-scale plan parallel to 4-HO-MET route
Finalize Wohler scoring`],
  },

  "4-ho-dpt": {
    id: "4-ho-dpt",
    name: `4-HO-DPT`,
    fullName: `4-Hydroxy-N,N-dipropyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B — Tryptamine Space`,
    cas: `63065-94-5`,
    formula: `C16H24N2O`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled federal US; Analog-Act risk; state schedules vary.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO with caution — best 5-HT2A/5-HT2C selectivity (129-fold) in Klein series; high 5-HT2B efficacy (94%) is the constraint.`,
    priorityTier: `Tier 2`,
    summary: `4-HO-DPT is the symmetric N,N-dipropyl psilocin homolog. Klein et al. (2021) report exceptional 5-HT2A potency (EC50 = 1.64 nM, Emax = 103%) and a remarkable 129-fold selectivity over 5-HT2C (EC50 = 212 nM). However, 5-HT2B Emax is 94.1% — the highest in the series — making chronic-dose use high-risk. Ideal for acute-dose 5-HT2A-specific research.`,
    researchAdvantages: `Most potent 5-HT2A agonist in Klein SAR series (EC50 1.64 nM, Emax 103%) | Outstanding 5-HT2A/5-HT2C selectivity (129-fold) | Symmetric structure — simpler synthesis than asymmetric analogs (cleaner amine coupling)`,
    researchConsiderations: `5-HT2B Emax 94% — highest in Klein series; chronic-use valvulopathy risk substantial | Analog-Act exposure | Longer duration of action than shorter-alkyl analogs (Klein Fig 2 time course)`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`Procin`, `4-Hydroxy-DPT`],
    mw: `260.38 g/mol`,
    benefitScore: 78,
    harmScore: 30,
    references: [
      { title: `Klein A.K. et al. ACS Pharmacol. Transl. Sci. 2021, 4(2), 533–542.
10.1021/acsptsci.0c00176
33860183
Repke D.B. et al. J. Heterocycl. Chem. 1981, 18, 175–179.
10.1002/jhet.5570180131
Fantegrossi W.E. et al. Hallucinogen-like effects of N,N-dipropyltryptamine (DPT). Pharmacol. Biochem. Behav. 2008, 88(3), 358–365.
10.1016/j.pbb.2007.09.007
17905422
Shulgin A.T., Shulgin A. TIHKAL: The Continuation. Transform Press, 1997.`, url: "" },
    ],
    nextSteps: [`Commission 28-day rat cardiac-valve histopathology at sub-HTR dose (5-HT2B risk assessment)
Develop hemifumarate GMP-ready SOP
PK profiling in rat (IV + oral, plasma + brain)
In-house Ki vs Klein published EC50 on Wohler batch`],
  },

  "4-ho-ept": {
    id: "4-ho-ept",
    name: `4-HO-EPT`,
    fullName: `4-Hydroxy-N-ethyl-N-propyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B — Tryptamine Space`,
    cas: `63065-87-6`,
    formula: `C15H22N2O`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled at US federal level. Psilocin analog — Analogue Act scrutiny possible. State schedules vary.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — high 5-HT2A potency (EC50 3.15 nM) and full efficacy; well-characterized.`,
    priorityTier: `Tier 2`,
    summary: `4-HO-EPT is the asymmetric N-ethyl-N-propyl psilocin homolog. Klein et al. (2021) report EC50 = 3.15 nM at h5-HT2A with 99.5% Emax — among the most potent compounds in the Klein SAR series. Higher 5-HT2B efficacy (89.2%) than shorter-chain analogs raises valvulopathy concern for chronic use, but makes it an excellent acute-dose research tool.`,
    researchAdvantages: `Among most potent 5-HT2A agonists in Klein SAR series (EC50 3.15 nM, Emax 99.5%) | Literature user-reports describe cleaner visual profile than psilocin | Asymmetric N-alkyl substitution — good IP differentiation`,
    researchConsiderations: `Elevated 5-HT2B efficacy (89% vs 39% for psilocin) — chronic/microdose use contraindicated pending cardiac safety data | Longer alkyl chains require recrystallization optimization at scale (lower crystallinity) | Analog-Act exposure (psilocin homolog)`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`4-Hydroxy-EPT`, `Ethylpropocin`],
    mw: `246.35 g/mol`,
    benefitScore: 76,
    harmScore: 26,
    references: [
      { title: `Klein A.K. et al. ACS Pharmacol. Transl. Sci. 2021, 4(2), 533–542.
10.1021/acsptsci.0c00176
33860183
Repke D.B. et al. J. Heterocycl. Chem. 1981, 18, 175–179.
10.1002/jhet.5570180131
Shulgin A.T., Shulgin A. TIHKAL: The Continuation. Transform Press, 1997.`, url: "" },
    ],
    nextSteps: [`5-HT2B cardiac-safety risk assessment before any chronic/microdose protocols
Develop hemifumarate seeded-crystallization SOP (PAT-monitored)
In-house Ki confirmation on Wohler batch
Formulation study for taste-masking (free phenol bitter)`],
  },

  "4-ho-met": {
    id: "4-ho-met",
    name: `4-HO-MET`,
    fullName: `4-Hydroxy-N-methyl-N-ethyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B`,
    cas: `77872-43-6`,
    formula: `C₁₃H₁₈N₂O`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled (DEA) as of 2026. 4-OH-DiPT was federally scheduled in 2022; 4-HO-MET remains unscheduled but is structurally related to psilocin (Schedule I). Analog-Act consideration applies only to substances intended for human consumption — research use only is the required posture. Several U.S. states have independent scheduling laws; verify per-state.`,
    status: `Strongly Favored`,
    statusColor: `green`,
    goDecision: `GO — strong university companion to 4-AcO-MET`,
    priorityTier: `Tier 1 — Immediate synthesis target`,
    summary: `4-HO-MET is the direct active metabolite of Wohler's flagship 4-AcO-MET and a close psilocin homolog. In head-twitch response (HTR) assays at UCSD (Klein/Halberstadt 2021) it is more potent than psilocin (ED50 = 0.65 vs 0.81 μmol/kg) and functions as a near-full agonist at 5-HT2A (Emax ≈ 97%). Shorter duration than psilocybin (~4–5 h) makes it attractive for structured therapeutic sessions.`,
    researchAdvantages: `More potent than psilocin in the validated mouse HTR assay (ED50 = 0.65 μmol/kg vs 0.81 for psilocin) | Near-full agonist at 5-HT2A (Emax ≈ 97%) — matches psilocybin-like therapeutic mechanism | Shorter duration (~4–5 h) favorable for structured psychedelic-assisted therapy protocols | Direct active metabolite of 4-AcO-MET — allows bypassing of prodrug conversion variability | Strong published SAR data in ACS Pharmacology & Translational Science (2021), PMC8033608 | Logical university-grade companion compound for 4-AcO-MET research lines already in place`,
    researchConsiderations: `No formal human clinical trials yet — most human data is observational (Kjellgren & Soussan 2011) | 5-HT2B efficacy (Emax ≈ 44%) requires cardiac valve monitoring in chronic dosing paradigms | Structurally close to psilocin (Schedule I) — high scrutiny class, emergency scheduling risk | Requires a DEA-registered or institution-based schedule-I-waiver environment for live-subject work`,
    evidenceConfidence: `HIGH`,
    aliases: [`Metocin`, `Homopsilocin`],
    mw: `218.30 g/mol`,
    benefitScore: 88,
    harmScore: 22,
    nextSteps: [`Finalize fumarate crystal form; perform single-crystal XRD for patent disclosure
Generate 100-mg reference standard for CRO distribution with full COA
Draft IRB-ready investigator brochure for university partners
Commission 14-day rat tox at 3 mg/kg/day (behavioral + cardiac endpoints)`],
  },

  "4-ho-mipt": {
    id: "4-ho-mipt",
    name: `4-HO-MiPT`,
    fullName: `4-Hydroxy-N-methyl-N-isopropyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B`,
    cas: `77872-41-4`,
    formula: `C₁₄H₂₀N₂O`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. Note: 5-MeO-MiPT was federally scheduled in 2022; the 4-OH isomer remains distinct and unscheduled.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — longer-duration option`,
    priorityTier: `Tier 2`,
    summary: `4-HO-MiPT (Miprocin) is a direct 4-hydroxytryptamine (not a prodrug). Near-full 5-HT2A agonist (EC₅₀ ≈ 5.2 nM, Emax ≈ 99.6 %). Human experiential literature reports a gentler onset and longer duration than psilocin (5–6 h) — likely due to isopropyl group effect on metabolism.`,
    researchAdvantages: `Near-full 5-HT2A agonist — psilocin-comparable receptor profile | Longer duration (5–6 h) — attractive for extended structured sessions | Gentler onset curve reported in phenomenology literature | Direct 4-OH compound — no prodrug conversion variability`,
    researchConsiderations: `5-MeO-MiPT scheduled in 2022 — potential scheduling trajectory for N-isopropyl class | Limited rigorous clinical data | Duration may exceed optimal therapy-session window`,
    evidenceConfidence: `MODERATE`,
    aliases: [`Miprocin`],
    mw: `232.32 g/mol`,
    benefitScore: 82,
    harmScore: 24,
    nextSteps: [`Duration-of-action PK study proposal
SAR comparison with 4-AcO-MET`],
  },

  "4-ho-mpt": {
    id: "4-ho-mpt",
    name: `4-HO-MPT`,
    fullName: `4-Hydroxy-N-methyl-N-propyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B — Tryptamine Space`,
    cas: `77872-43-6`,
    formula: `C14H20N2O`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Not federally scheduled in the United States. Structural analog of psilocin — Federal Analogue Act scrutiny possible under 21 USC §813. State-level scheduling varies; confirm jurisdiction. Research-use-only posture required.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — close psilocin homolog with published pharm data (Klein 2021); well-suited as Wohler flagship companion to 4-AcO-MPT.`,
    priorityTier: `Tier 2`,
    summary: `4-HO-MPT is the asymmetric N-methyl-N-propyl homolog of psilocin and the active metabolite of 4-AcO-MPT. Klein et al. (2021) demonstrated it is a highly potent, highly efficacious 5-HT2A agonist (EC50 = 3.82 nM, Emax = 98.1% of 5-HT) with near-identical potency to psilocin. Behavioral HTR potency (ED50 = 1.92 μmol/kg) places it in the psilocin-potency range. Serves as a natural companion research tool to 4-AcO-MPT with a shorter/cleaner profile.`,
    researchAdvantages: `Published 5-HT2A pharmacology (Klein 2021): EC50 3.82 nM, Emax 98% | Low 5-HT2B efficacy vs 5-HT2A — potentially cleaner cardiac-safety profile than longer-chain analogs | Asymmetric N-alkyl substitution reduces 5-HT2C potency (45.8 nM) vs 5-HT2A — modest 5-HT2A selectivity | Direct metabolite of 4-AcO-MPT — consolidates research program`,
    researchConsiderations: `Psilocin analog — Federal Analogue Act risk | 5-HT2B Emax 58.4% (partial agonist) — chronic/microdose use carries theoretical valvulopathy risk | Free phenolic 4-OH oxidation-sensitive; handling under N2/Ar required for pure free base`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`Meprocin`, `4-Hydroxy-MPT`],
    mw: `232.33 g/mol`,
    benefitScore: 78,
    harmScore: 22,
    references: [
      { title: `Klein A.K., Chatha M., Laskowski L.J., et al. Investigation of the Structure–Activity Relationships of Psilocybin Analogues. ACS Pharmacol. Transl. Sci. 2021, 4(2), 533–542.
10.1021/acsptsci.0c00176
33860183`, url: "" },
    ],
    nextSteps: [`Procure reference standard for internal analytical method qualification (LC-MS, NMR)
Develop kilo-lab SOP and run 100 g pilot of Pd/C debenzylation
Generate in-house 5-HT2A/2B/2C binding data on Wohler batch to confirm published profile
File Wohler internal IP-landscape review (no composition-of-matter patents; process IP achievable)`],
  },

  "5-meo-dalt": {
    id: "5-meo-dalt",
    name: `5-MeO-DALT`,
    fullName: `5-Methoxy-N,N-diallyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B — Tryptamine Space`,
    cas: `928822-98-4`,
    formula: `C17H22N2O`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled US federal. 5-MeO-DMT analog — Analogue-Act scrutiny. Several states schedule the 5-MeO class.`,
    status: `HOLD`,
    statusColor: `orange`,
    goDecision: `HOLD — well-characterized binding profile (Cozzi 2016) but Analogue-Act exposure caps scope; prioritize after 4-OH series.`,
    priorityTier: `Tier 3`,
    summary: `5-MeO-DALT is Shulgin's N,N-diallyl-5-methoxytryptamine. Cozzi & Daley (2016) report HIGH affinity at 5-HT1A (Ki ~19 nM) and 5-HT2B (Ki ~17 nM), moderate at 5-HT6/5-HT7 (~90–155 nM), weaker 5-HT2A (~218 nM). Multi-receptor pharmacology with 5-HT1A bias. Active oral dose 12–20 mg (Shulgin TIHKAL).`,
    researchAdvantages: `Published binding at 45 receptors (Cozzi 2016) — best-characterized DALT | Short duration (~2–3 h) — session-design advantage | 5-HT1A bias may give distinct anxiolytic/antidepressant signal vs 5-HT2A-dominant psychedelics | Human-dose range established`,
    researchConsiderations: `High 5-HT2B affinity (Ki 17 nM) — valvulopathy risk | 5-MeO class Analogue-Act exposure (5-MeO-DMT is Schedule I) | Body-load reports — narrow therapeutic window`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`5-Methoxy-DALT`],
    mw: `270.37 g/mol`,
    benefitScore: 66,
    harmScore: 30,
    references: [
      { title: `Cozzi N.V., Daley P.F. Receptor binding profiles and QSAR of some 5-substituted-N,N-diallyltryptamines. Bioorg. Med. Chem. Lett. 2016, 26, 959–964.
10.1016/j.bmcl.2015.12.053
Arunotayanun W. et al. Bioorg. Med. Chem. Lett. 2013, 23, 3411.
Michely J.A. et al. Anal. Bioanal. Chem. 2015, 407, 7831.
Shulgin A.T., Shulgin A. TIHKAL: The Continuation. Transform Press, 1997. Entry #16.`, url: "" },
    ],
    nextSteps: [`In-house confirmation of Cozzi 2016 binding profile
5-HT1A functional cAMP assay on Wohler batch
Acute rodent HTR ED50 + drug-discrimination vs 5-MeO-DMT
State-by-state scheduling review`],
  },

  "5-meo-met": {
    id: "5-meo-met",
    name: `5-MeO-MET`,
    fullName: `5-Methoxy-N-methyl-N-ethyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B — Tryptamine Space`,
    cas: `4021-34-5`,
    formula: `C14H20N2O`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled at US federal level. 5-MeO-DMT analog — Analogue Act exposure. Rapid/intense onset profile requires heightened research-protocol controls.`,
    status: `HOLD`,
    statusColor: `orange`,
    goDecision: `HOLD — 5-MeO series has rapid-onset, very-high-intensity subjective profile; limited published pharm data on MET specifically; prioritize after 4-substituted series.`,
    priorityTier: `Tier 3`,
    summary: `5-MeO-MET is an asymmetric N-methyl-N-ethyl homolog of 5-MeO-DMT. The 5-MeO series is characterized by shorter duration (~15–45 min smoked; ~90 min oral with MAOI) but very-high-intensity mystical-experience profile. Pharmacology is dominated by 5-HT1A and 5-HT2A agonism (different balance vs 4-OH series). Published data on 5-MeO-MET specifically is sparse; Shulgin reports in TIHKAL.`,
    researchAdvantages: `Short duration — attractive for rapid-acting depression research | 5-HT1A bias (5-MeO series) may contribute to anxiolytic/anti-depressant action distinct from 4-OH series | Literature SAR framework available from 5-MeO-DMT, 5-MeO-DIPT, 5-MeO-MiPT data`,
    researchConsiderations: `Sparse published pharmacology on 5-MeO-MET specifically | Very high subjective intensity — narrow therapeutic window; protocol-design challenge | Analog Act exposure (5-MeO-DMT is Schedule I)`,
    evidenceConfidence: `LOW-MEDIUM`,
    aliases: [`5-Methoxy-MET`, `5-MeO-MET`],
    mw: `232.33 g/mol`,
    benefitScore: 68,
    harmScore: 32,
    references: [
      { title: `Rickli A. et al. Receptor interaction profiles of novel psychoactive tryptamines. Eur. Neuropsychopharmacol. 2016, 26(8), 1327–1337.
10.1016/j.euroneuro.2016.05.001
27216487
Fantegrossi W.E. et al. Hallucinogen-like actions of 5-methoxy-N,N-diisopropyltryptamine in mice and rats. Pharmacol. Biochem. Behav. 2006, 83(1), 122–129.
10.1016/j.pbb.2005.12.015
16460788
Shulgin A.T., Shulgin A. TIHKAL: The Continuation. Transform Press, 1997.`, url: "" },
    ],
    nextSteps: [`In-house 5-HT1A, 5-HT2A, 5-HT2B, 5-HT2C panel via contract pharm service
Acute rodent HTR ED50 determination
Stability assessment vs 5-MeO-DMT (5-MeO-MET expected more stable — less susceptible to MAO-A)
IP-landscape review for 5-MeO-MET specifically`],
  },

  "5-meo-nmt": {
    id: "5-meo-nmt",
    name: `5-MeO-NMT`,
    fullName: `5-Methoxy-N-methyltryptamine`,
    categoryId: `tryptamines`,
    program: `Program B`,
    formula: `C₁₂H₁₆N₂O`,
    schedulingStatus: `unscheduled`,
    schedulingNote: `Not federally scheduled. 5-MeO-DMT is Schedule I; 5-MeO-NMT (monomethyl) is distinct.`,
    status: `Favored`,
    statusColor: `green`,
    goDecision: `GO — non-psychedelic-spectrum research tool`,
    priorityTier: `Tier 3`,
    summary: `Naturally occurring 5-methoxytryptamine — found in several plant species. Partial 5-HT1A/5-HT2A agonist with substantially attenuated psychedelic intensity vs. 5-MeO-DMT. A Nature 2024 structural pharmacology paper highlights 5-methoxytryptamines as a class with broad therapeutic potential.`,
    researchAdvantages: `Naturally occurring — strong 'known plant alkaloid' positioning | Attenuated intensity vs. 5-MeO-DMT — easier clinical use | Recent Nature 2024 paper highlights class therapeutic potential | Simple synthesis from 5-methoxyindole`,
    researchConsiderations: `Weaker pharmacology → smaller therapeutic signal | Less psychedelic research interest than 4-OH series`,
    evidenceConfidence: `MODERATE`,
    mw: `204.27 g/mol`,
    benefitScore: 70,
    harmScore: 28,
    nextSteps: [`Literature-review expansion
5-HT1A vs 5-HT2A ratio characterization`],
  },

  "aeruginascin-analogs": {
    id: "aeruginascin-analogs",
    name: `Aeruginascin Analogs`,
    fullName: `4-Phosphoryloxy-N,N,N-trimethyltryptammonium class`,
    categoryId: `tryptamines`,
    program: `Program B — Tryptamine Space`,
    cas: `72476-36-3`,
    formula: `C13H20N2O4P`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled US federal. Quaternary — does NOT cross BBB. Natural in Inocybe aeruginascens; implicated in 'entourage effect'.`,
    status: `HOLD`,
    statusColor: `orange`,
    goDecision: `HOLD — intriguing entourage-effect hypothesis; pharmacology essentially unpublished. Pursue only as mechanistic probe within entourage research.`,
    priorityTier: `Tier 3`,
    summary: `Aeruginascin is the quaternary N-trimethyl analog of psilocybin, naturally occurring in Inocybe aeruginascens, implicated (via user reports / Gartz) in atypical euphoric / anti-anxiety profile. The quaternary ammonium is BBB-excluded — any CNS effect must be indirect (peripheral 5-HT3 / vagal) or via metabolism. Research value = mechanistic probe + entourage interaction with psilocin.`,
    researchAdvantages: `Novel mechanistic niche — peripheral 5-HT signaling | Naturally occurring alkaloid | Low direct harm (BBB-excluded)`,
    researchConsiderations: `Essentially no formal pharmacology | BBB exclusion limits CNS-therapy hypothesis | MeI quaternization — IARC 3 carcinogen, specialized handling`,
    evidenceConfidence: `LOW`,
    aliases: [`Aeruginascin class`, `Quaternary tryptammonium`],
    mw: `300.29 g/mol`,
    benefitScore: 60,
    harmScore: 15,
    references: [
      { title: `Gartz J. Beitr. Kenntn. Pilze Mitteleur. 1987, 3, 275–281.
Jensen N. et al. Synthesis and pharmacology of novel 4-position modified analogs of psilocin. J. Nat. Prod. 2020.
Stijve T., Kuyper T.W. Occurrence of psilocybin and aeruginascin in Inocybe aeruginascens Babos. Persoonia 1985, 12, 469–473.`, url: "" },
    ],
    nextSteps: [`NIMH PDSP broad receptor screen
Peripheral 5-HT3 functional assay
Plasma stability + renal clearance PK in rat
Entourage study with psilocin co-administration`],
  },

  "norpsilocin-analogs": {
    id: "norpsilocin-analogs",
    name: `Norpsilocin Analogs`,
    fullName: `4-Hydroxy-N-methyltryptamine (norpsilocin) and mono-alkyl congeners`,
    categoryId: `tryptamines`,
    program: `Program B — Tryptamine Space`,
    cas: `1210-35-1`,
    formula: `C11H14N2O`,
    schedulingStatus: `unscheduled-federal`,
    schedulingNote: `Unscheduled federal US. Psilocin-family Analogue-Act exposure. Norpsilocin is a natural metabolite in Psilocybe species.`,
    status: `GO`,
    statusColor: `green`,
    goDecision: `GO — Sherwood et al. 2020 identified norpsilocin as a highly 5-HT2A-selective agonist with no HTR response — candidate for non-hallucinogenic psychoplastogen research.`,
    priorityTier: `Tier 2`,
    summary: `Norpsilocin (4-HO-NMT) is a natural demethylation product of psilocin. Sherwood et al. (J. Nat. Prod. 2020) showed it is a potent 5-HT2A agonist (EC50 ~100 nM) that does NOT produce the head-twitch response in mice — suggesting either signaling bias or PK-mediated CNS exclusion. Important flagship for the non-hallucinogenic psychoplastogen thesis.`,
    researchAdvantages: `5-HT2A agonist without HTR (Sherwood 2020) — non-hallucinogenic psychoplastogen candidate | Natural mushroom metabolite — low structural novelty risk | Small scaffold — easy SAR expansion`,
    researchConsiderations: `Primary amine — MAO substrate; low oral bioavailability without MAOI | Oxidation-sensitive (free phenol + primary amine) | Analogue-Act exposure`,
    evidenceConfidence: `MEDIUM`,
    aliases: [`4-HO-NMT class`, `norpsilocin SAR`],
    mw: `190.24 g/mol`,
    benefitScore: 70,
    harmScore: 22,
    references: [
      { title: `Sherwood A.M., Halberstadt A.L., Klein A.K., McCorvy J.D., Kaylo K.W., Kargbo R.B., Meisenheimer P. Synthesis and biological evaluation of tryptamines found in hallucinogenic mushrooms. J. Nat. Prod. 2020, 83(2), 461–467.
10.1021/acs.jnatprod.9b01061
32051999
Klein A.K. et al. ACS Pharmacol. Transl. Sci. 2021, 4(2), 533–542.
10.1021/acsptsci.0c00176`, url: "" },
    ],
    nextSteps: [`Confirm no-HTR phenotype on Wohler batch
β-arrestin vs Gq bias at 5-HT2A (Tango assay)
Prodrug strategy — 4-acetoxy-NMT for oral PK improvement
In vivo PK (plasma + brain) ± MAOI`],
  },

};
